(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[47966],{

/***/ 29973:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), 'ArrowForward');

exports.Z = _default;

/***/ }),

/***/ 60424:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
}), 'Help');

exports.Z = _default;

/***/ }),

/***/ 64379:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"
}), 'KeyboardBackspace');

exports.Z = _default;

/***/ }),

/***/ 9969:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
}), 'Settings');

exports.Z = _default;

/***/ }),

/***/ 90431:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account",
      function () {
        return __webpack_require__(17133);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ account; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./redux/actions/prismic.ts
var prismic = __webpack_require__(64063);
// EXTERNAL MODULE: ./components/Layout/Layout.tsx
var Layout = __webpack_require__(8122);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./redux/actions/user.ts
var actions_user = __webpack_require__(76809);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./components/Loader/Loader.tsx
var Loader = __webpack_require__(96149);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(52663);
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js + 1 modules
var useMatomo = __webpack_require__(86700);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button_Button = __webpack_require__(282);
// EXTERNAL MODULE: ./components/Link/Link.tsx
var Link = __webpack_require__(31520);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
;// CONCATENATED MODULE: ./components/InStore/InStoreLink.tsx






var InStoreReturnLink = function(param) {
    var isInStore = param.isInStore, isBlank = param.isBlank, cmsText = param.cmsText, cmsDefaultText = param.cmsDefaultText;
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    if (isInStore) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            href: './rdv/return',
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                target: isBlank ? '_blank' : '_self',
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: 'small',
                    component: 'span',
                    variant: 'outlined',
                    color: 'secondary',
                    onClick: function() {
                        return trackEvent({
                            category: 'In Store',
                            action: "User Go to In Store Return appointment page"
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        asText: true,
                        data: cmsText,
                        defaultText: cmsDefaultText
                    })
                })
            })
        }));
    }
    return null;
};
/* harmony default export */ var InStoreLink = (InStoreReturnLink);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Error.js
var icons_Error = __webpack_require__(72063);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
// EXTERNAL MODULE: ./components/Order/DownloadInvoiceButton/DownloadInvoiceButton.tsx
var DownloadInvoiceButton = __webpack_require__(44987);
// EXTERNAL MODULE: ./components/Order/RentalReturnLabelDownload.tsx
var RentalReturnLabelDownload = __webpack_require__(53706);
// EXTERNAL MODULE: ./hooks/useTakeback.ts
var useTakeback = __webpack_require__(78931);
;// CONCATENATED MODULE: ./components/Order/OrderList.tsx
/* provided dependency */ var process = __webpack_require__(34155);

















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var isBuyingOption = "false";
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        orderListTitle: {
            marginBottom: theme.spacing(2)
        },
        orderHeader: {
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center'
        },
        circleDefault: {
            width: 16,
            height: 16,
            borderRadius: '50%',
            backgroundColor: theme.palette.common.black
        },
        circlePrimary: {
            backgroundColor: theme.palette.primary.main
        },
        circleSecondary: {
            backgroundColor: theme.palette.secondary.main
        },
        circleWarning: {
            backgroundColor: theme.palette.warning.main
        },
        orderTitle: {
            paddingLeft: theme.spacing(1)
        },
        orderItem: {
            borderLeft: "1px solid currentColor",
            paddingLeft: theme.spacing(2),
            marginLeft: theme.spacing(1),
            paddingBottom: theme.spacing(3)
        },
        orderItemComing: {
            borderLeft: "1px dashed ".concat(theme.extraColors.greyMedium)
        },
        orderItemReturn: {
            borderLeft: "1px solid ".concat(theme.palette.secondary.main)
        },
        orderItemCancelled: {
            borderLeft: "1px dashed ".concat(theme.palette.warning.main)
        },
        orderItemLast: {
            border: 0
        },
        productCard: _defineProperty({
            background: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius,
            minHeight: 60,
            padding: theme.spacing(1),
            display: 'flex',
            justifyContent: '',
            alignItems: 'center',
            marginBottom: theme.spacing(2)
        }, theme.breakpoints.down('md'), {
            width: '100%'
        }),
        imgProduct: {
            width: 50,
            height: 50,
            objectFit: 'contain',
            display: 'block'
        },
        imgContainer: _defineProperty({
            width: 50,
            marginLeft: theme.spacing(2)
        }, theme.breakpoints.down('md'), {
            marginLeft: theme.spacing(0)
        }),
        productName: _defineProperty({
            marginLeft: theme.spacing(2)
        }, theme.breakpoints.down('md'), {
            marginLeft: theme.spacing(1)
        }),
        downloadInvoiceButton: {
            display: 'flex',
            justifyContent: 'flex-end'
        },
        warning: {
            color: theme.palette.warning.main
        },
        buyArea: {
            display: 'flex',
            justifyContent: 'space-between'
        },
        cancelArea: {
            textAlign: 'right',
            marginLeft: '1rem',
            paddingBottom: '0.3rem'
        },
        cancelBtn: {
            padding: 0,
            textTransform: 'none',
            textDecoration: 'underline',
            fontSize: '80%',
            color: theme.extraColors.greyText,
            '&:hover, &:focus': {
                background: 'none'
            }
        },
        modal: {
            borderRadius: 0,
            '& .MuiPaper-root': _defineProperty({
                borderRadius: 0
            }, theme.breakpoints.up('md'), {
                minWidth: 700
            })
        },
        modalHead: {
            padding: theme.spacing(2, 3),
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: theme.extraColors.greyLight,
            '& .MuiTypography-root': {
                fontWeight: 400,
                lineHeight: 1
            }
        },
        modalHeadWarning: {
            display: 'inline-flex',
            alignItems: 'center',
            color: theme.palette.error.main,
            '&>.MuiSvgIcon-root': {
                marginRight: theme.spacing(1)
            }
        },
        modalFoot: {
            padding: theme.spacing(1, 2),
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center'
        },
        modalContent: {
            padding: theme.spacing(3),
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: theme.spacing(1)
        },
        modalClose: {
            cursor: 'pointer',
            padding: theme.spacing(0.5),
            width: theme.spacing(4),
            height: theme.spacing(4),
            borderRadius: theme.spacing(2),
            textAlign: 'center',
            color: theme.extraColors.greyLight,
            background: theme.extraColors.greyMedium,
            '&:hover, &:focus': {
                background: theme.palette.common.black
            }
        },
        cancelCTA: {
        }
    });
});
var OrderList = function(param) {
    var orders = param.orders, doc = param.doc, t = param.t, isInStore = param.isInStore, inStoreText = param.inStoreText, showSizes = param.showSizes, putUserOrder = param.putUserOrder, getUserOrders = param.getUserOrders, takeback = param.takeback, isSecondHand = param.isSecondHand, unit = param.unit, handleDownloadInvoice = param.handleDownloadInvoice, invoiceDownloadError = param.invoiceDownloadError;
    var ref15;
    var classes = useStyles();
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    var productCheckState = (0,useTakeback/* useTakeback */.C)().productCheckState;
    var ref1 = (0,react.useState)({
        open: false,
        currentOrder: null
    }), openModal = ref1[0], setOpenModal = ref1[1];
    var states = productCheckState(takeback === null || takeback === void 0 ? void 0 : takeback.data);
    var noCalendly = process.env.NO_CALENDLY;
    var handleOpen = function(currentOrder) {
        setOpenModal({
            open: true,
            currentOrder: currentOrder
        });
    };
    var handleClose = function() {
        setOpenModal({
            open: false,
            currentOrder: null
        });
    };
    var handleCancel = function(order) {
        var cancelOrder = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                var response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return setOpenModal({
                                open: false,
                                currentOrder: null
                            });
                        case 2:
                            _ctx.next = 4;
                            return putUserOrder(order.tokenValue);
                        case 4:
                            response = _ctx.sent;
                            if (!(response.type === 'PUT_USER_ORDER_SUCCESS')) {
                                _ctx.next = 8;
                                break;
                            }
                            _ctx.next = 8;
                            return getUserOrders();
                        case 8:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function cancelOrder() {
                return _ref.apply(this, arguments);
            };
        }();
        cancelOrder();
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: 'h5',
                component: 'h2',
                className: classes.orderListTitle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                    asText: true,
                    data: doc === null || doc === void 0 ? void 0 : (ref15 = doc.data) === null || ref15 === void 0 ? void 0 : ref15.order_list_title,
                    defaultText: t('texts:account:order_list_title')
                })
            }),
            (orders === null || orders === void 0 ? void 0 : orders.length) > 0 && orders.map(function(order, index1) {
                var ref23, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
                var orderNumber = "order--".concat(order.number);
                var isCancelled = order.shipments[0].state === 'cancelled';
                var lastOrder = index1 + 1 === orders.length;
                var isRental = (order === null || order === void 0 ? void 0 : (ref23 = order.items) === null || ref23 === void 0 ? void 0 : (ref2 = ref23[0]) === null || ref2 === void 0 ? void 0 : ref2.type) === constants/* ORDER_ITEM_TYPE.RENTAL */._$.RENTAL;
                var state;
                if (isCancelled) {
                    state = 'cancelled';
                } else {
                    if (dayjs_min_default()().diff(dayjs_min_default()(order.startLeasingDate, 'DD/MM/YYYY'), 'day') <= 0) {
                        state = 'coming';
                    } else {
                        if (dayjs_min_default()().diff(dayjs_min_default()(order.endLeasingDate, 'DD/MM/YYYY'), 'day') <= 0) {
                            state = 'return';
                        } else {
                            state = 'finished';
                        }
                    }
                }
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)('order', orderNumber),
                    id: orderNumber,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "order--".concat(state),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.orderHeader,
                                    children: [
                                        state === 'cancelled' && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)(classes.circleDefault, classes.circleWarning)
                                        }),
                                        state === 'coming' && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)(classes.circleDefault, classes.circlePrimary)
                                        }),
                                        state === 'return' && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)(classes.circleDefault, classes.circleSecondary)
                                        }),
                                        state === 'finished' && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes.circleDefault
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classes.orderTitle,
                                            children: [
                                                state === 'cancelled' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    variant: 'body1',
                                                    color: 'inherit',
                                                    className: classes.warning,
                                                    children: [
                                                        t('texts:account:cancelled'),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                            children: [
                                                                "\xa0-\xa0",
                                                                order.cancelledAt ? order.cancelledAt : order.startLeasingDate
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                state === 'coming' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    variant: 'body1',
                                                    color: 'primary',
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: doc === null || doc === void 0 ? void 0 : (ref3 = doc.data) === null || ref3 === void 0 ? void 0 : ref3.date,
                                                            defaultText: t('texts:account:date')
                                                        }),
                                                        "\xa0",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                            children: dayjs_min_default()(order.checkoutCompletedAt).format('DD/MM/YYYY')
                                                        })
                                                    ]
                                                }),
                                                state === 'return' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    variant: 'body1',
                                                    color: 'secondary',
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: doc === null || doc === void 0 ? void 0 : (ref4 = doc.data) === null || ref4 === void 0 ? void 0 : ref4.date,
                                                            defaultText: t('texts:account:date')
                                                        }),
                                                        "\xa0",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                            children: order.endLeasingDate
                                                        })
                                                    ]
                                                }),
                                                state === 'finished' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    variant: 'body1',
                                                    color: 'textPrimary',
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: doc === null || doc === void 0 ? void 0 : (ref5 = doc.data) === null || ref5 === void 0 ? void 0 : ref5.returned_at,
                                                            defaultText: t('texts:account:returned_at')
                                                        }),
                                                        "\xa0",
                                                        order.endLeasingDate
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)([
                                        'order__item',
                                        classes.orderItem
                                    ], state === 'cancelled' && classes.orderItemCancelled, state === 'coming' && classes.orderItemComing, state === 'return' && classes.orderItemReturn, state === 'finished' && classes.orderItem, lastOrder && [
                                        'order__item--last',
                                        classes.orderItemLast
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: classes.orderHeader,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            variant: 'body2',
                                                            color: 'textSecondary',
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                    asText: true,
                                                                    data: doc === null || doc === void 0 ? void 0 : (ref6 = doc.data) === null || ref6 === void 0 ? void 0 : ref6.command,
                                                                    defaultText: t('texts:account:command')
                                                                }),
                                                                "\xa0",
                                                                order.number
                                                            ]
                                                        }),
                                                        (order === null || order === void 0 ? void 0 : order.isCancellable) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (0,clsx_m/* default */.Z)('order-cancel', classes.cancelArea),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                size: "small",
                                                                disableRipple: true,
                                                                className: (0,clsx_m/* default */.Z)('order-cancel__btn', classes.cancelBtn),
                                                                onClick: function() {
                                                                    return handleOpen(order.number);
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                    asText: true,
                                                                    data: doc === null || doc === void 0 ? void 0 : (ref7 = doc.data) === null || ref7 === void 0 ? void 0 : ref7.cancel_order_cta_modal,
                                                                    defaultText: t('texts:account:cancel_order:cta_modal')
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                isRental && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        variant: 'body2',
                                                        color: 'textSecondary',
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: doc === null || doc === void 0 ? void 0 : (ref8 = doc.data) === null || ref8 === void 0 ? void 0 : ref8.leasing_date_from,
                                                                defaultText: t('texts:account:leasing_date_from')
                                                            }),
                                                            "\xa0",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: order.startLeasingDate
                                                            }),
                                                            "\xa0",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: doc === null || doc === void 0 ? void 0 : (ref9 = doc.data) === null || ref9 === void 0 ? void 0 : ref9.leasing_date_to,
                                                                defaultText: t('texts:account:leasing_date_to')
                                                            }),
                                                            "\xa0",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: order.endLeasingDate
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'body2',
                                                    children: "".concat(order.shippingAddress.street, " ").concat(order.shippingAddress.city, " ").concat(order.shippingAddress.postcode === '00000' ? '' : order.shippingAddress.postcode, " ").concat(order.shippingAddress.countryCode)
                                                })
                                            ]
                                        }),
                                        order === null || order === void 0 ? void 0 : order.items.map(function(item, index) {
                                            var ref, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
                                            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: classes.productCard,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: classes.imgContainer,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: item.product.images.length > 0 && ((ref = item.product) === null || ref === void 0 ? void 0 : (ref16 = ref.images) === null || ref16 === void 0 ? void 0 : (ref17 = ref16[0]) === null || ref17 === void 0 ? void 0 : ref17.cachedPath),
                                                                    alt: item.product.name,
                                                                    className: classes.imgProduct
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: classes.productName,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                                    variant: 'h5',
                                                                    children: [
                                                                        item.product.name,
                                                                        showSizes && item.product.variants !== 'undefined' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                            children: [
                                                                                ((ref19 = item === null || item === void 0 ? void 0 : (ref18 = item.product) === null || ref18 === void 0 ? void 0 : ref18.variants[0]) === null || ref19 === void 0 ? void 0 : ref19.size) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                    children: "\xa0-\xa0"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                                    variant: 'body1',
                                                                                    component: "span",
                                                                                    children: (ref21 = item === null || item === void 0 ? void 0 : (ref20 = item.product) === null || ref20 === void 0 ? void 0 : ref20.variants[0]) === null || ref21 === void 0 ? void 0 : ref21.size
                                                                                }),
                                                                                isSecondHand && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                    children: [
                                                                                        "\xa0-\xa0",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                                            variant: 'body1',
                                                                                            component: "span",
                                                                                            children: states["".concat(unit.productCondition)].title
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    !noCalendly && /*#__PURE__*/ (0,jsx_runtime.jsx)(InStoreLink, {
                                                        isInStore: isInStore,
                                                        cmsDefaultText: t('texts:instore:account_page_return_link_label'),
                                                        cmsText: inStoreText === null || inStoreText === void 0 ? void 0 : (ref22 = inStoreText.data) === null || ref22 === void 0 ? void 0 : ref22.account_page_return_link_label
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (0,clsx_m/* default */.Z)('order__buy', isBuyingOption === 'true' && state === 'return' && classes.buyArea),
                                                        children: isBuyingOption === 'true' && state === 'return' && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                variant: 'contained',
                                                                color: 'secondary',
                                                                size: 'small',
                                                                onClick: function() {
                                                                    return trackEvent({
                                                                        category: 'Buying option click',
                                                                        action: "User clicked on the buying option button"
                                                                    });
                                                                },
                                                                children: t('texts:account:buy')
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, item.product.name + index));
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RentalReturnLabelDownload/* default */.Z, {
                                            orderNumber: order.number,
                                            account: doc,
                                            t: t
                                        }),
                                        !!(order === null || order === void 0 ? void 0 : (ref10 = order.invoice) === null || ref10 === void 0 ? void 0 : ref10.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes.downloadInvoiceButton,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadInvoiceButton/* default */.Z, {
                                                accountRes: doc,
                                                orderToken: order.tokenValue,
                                                t: t,
                                                handleDownloadInvoice: handleDownloadInvoice,
                                                invoiceDownloadError: invoiceDownloadError,
                                                isSub: constants/* isSubscription */.Nn
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        (order === null || order === void 0 ? void 0 : order.isCancellable) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
                            className: (0,clsx_m/* default */.Z)('modal-cancelOrder', classes.modal),
                            open: openModal.currentOrder === order.number,
                            onClose: handleClose,
                            maxWidth: 'md',
                            disableBackdropClick: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)('modal-cancelOrder__head', classes.modalHead),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body1",
                                            component: 'h2',
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: (0,clsx_m/* default */.Z)('modal-cancelOrder__warning', classes.modalHeadWarning),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Error/* default */.Z, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: doc === null || doc === void 0 ? void 0 : (ref11 = doc.data) === null || ref11 === void 0 ? void 0 : ref11.cancel_order_modal_title,
                                                            defaultText: t('texts:account:cancel_order:modal_title')
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                            className: (0,clsx_m/* default */.Z)('modal-cancelOrder__close', classes.modalClose),
                                            onClick: handleClose
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)('modal-cancelOrder__content', classes.modalContent),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: 'h4',
                                            component: 'h3',
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: doc === null || doc === void 0 ? void 0 : (ref12 = doc.data) === null || ref12 === void 0 ? void 0 : ref12.command,
                                                    defaultText: t('texts:account:command')
                                                }),
                                                order.orderNumber || order.number
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            component: 'div',
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: doc === null || doc === void 0 ? void 0 : (ref13 = doc.data) === null || ref13 === void 0 ? void 0 : ref13.cancel_order_modal_warn,
                                                defaultText: t('texts:account:cancel_order:modal_warn')
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            color: 'primary',
                                            variant: 'outlined',
                                            size: 'small',
                                            className: (0,clsx_m/* default */.Z)('modal-cancelOrder__cta', classes.cancelCTA),
                                            onClick: function() {
                                                return handleCancel(order);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: doc === null || doc === void 0 ? void 0 : (ref14 = doc.data) === null || ref14 === void 0 ? void 0 : ref14.cancel_order_modal_cta,
                                                defaultText: t('texts:account:cancel_order:modal_cta')
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, orderNumber));
            })
        ]
    }));
};
/* harmony default export */ var Order_OrderList = (OrderList);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js
var Fade = __webpack_require__(73637);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(80797);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grow/Grow.js
var Grow = __webpack_require__(20170);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
;// CONCATENATED MODULE: ./redux/services/reviews.ts


var getReviews = function(data) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.reviews */.KU.reviews,
        uid: "/questions?orderNumber=".concat(data),
        hasLocale: false
    });
};
var postReviews = function(data) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.post */.YZ.post,
        url: requests/* ERequestUrl.reviews */.KU.reviews,
        data: data,
        hasLocale: false
    });
};

;// CONCATENATED MODULE: ./redux/actions/reviews.ts

var ACTIONS = {
    GET_REVIEWS_USER_REQUEST: 'GET_REVIEWS_USER_REQUEST',
    GET_REVIEWS_USER_SUCCESS: 'GET_REVIEWS_USER_SUCCESS',
    GET_REVIEWS_USER_FAILURE: 'GET_REVIEWS_USER_FAILURE',
    POST_REVIEWS_USER_REQUEST: 'POST_REVIEWS_USER_REQUEST',
    POST_REVIEWS_USER_SUCCESS: 'POST_REVIEWS_USER_SUCCESS',
    POST_REVIEWS_USER_FAILURE: 'POST_REVIEWS_USER_FAILURE'
};
var GET_REVIEWS_USER_REQUEST = function() {
    return {
        type: ACTIONS.GET_REVIEWS_USER_REQUEST
    };
};
var GET_REVIEWS_USER_SUCCESS = function(reviews) {
    return {
        type: ACTIONS.GET_REVIEWS_USER_SUCCESS,
        reviews: reviews
    };
};
var GET_REVIEWS_USER_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_REVIEWS_USER_FAILURE,
        err: err
    };
};
function reviews_getReviews(data) {
    return function(dispatch) {
        dispatch(GET_REVIEWS_USER_REQUEST());
        return getReviews(data).then(function(response) {
            return dispatch(GET_REVIEWS_USER_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_REVIEWS_USER_FAILURE(err));
        });
    };
}
var POST_REVIEWS_USER_REQUEST = function() {
    return {
        type: ACTIONS.POST_REVIEWS_USER_REQUEST
    };
};
var POST_REVIEWS_USER_SUCCESS = function(address) {
    return {
        type: ACTIONS.POST_REVIEWS_USER_SUCCESS,
        address: address
    };
};
var POST_REVIEWS_USER_FAILURE = function(err) {
    return {
        type: ACTIONS.POST_REVIEWS_USER_FAILURE,
        err: err
    };
};
function reviews_postReviews(data) {
    return function(dispatch) {
        dispatch(POST_REVIEWS_USER_REQUEST());
        return postReviews(data).then(function(response) {
            return dispatch(POST_REVIEWS_USER_SUCCESS(response));
        }, function(err) {
            return dispatch(POST_REVIEWS_USER_FAILURE(err));
        });
    };
}

;// CONCATENATED MODULE: ./components/Order/ProductSatisfactionForm.tsx







function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function ProductSatisfactionForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ProductSatisfactionForm_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ProductSatisfactionForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ProductSatisfactionForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var mapStateToProps = function(state) {
    return {
        reviews: state.reviews
    };
};
var mapDispatchToProps = {
    getReviews: reviews_getReviews
};
var ProductSatisfactionForm_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: {
            width: '100%',
            '& .MuiInput-multiline': {
                padding: 0,
                '&:before, &:after': {
                    display: 'none'
                }
            }
        },
        formControl: {
            width: '100%'
        },
        sizeSelector: {
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(0.5, 2, 0.5, 1),
            margin: theme.spacing(0.5),
            backgroundColor: theme.extraColors.greyLight,
            minWidth: 200,
            color: theme.palette.common.black,
            height: 40,
            fontWeight: 'bold',
            border: 'none'
        },
        smileyContainer: {
            display: 'inline-flex',
            justifyContent: 'space-evenly',
            width: '100%',
            height: 48,
            alignItems: 'center'
        },
        activeSmiley: {
            cursor: 'pointer',
            color: theme.palette.secondary.main
        },
        smiley: {
            cursor: 'pointer',
            color: theme.extraColors.grey
        },
        questionTitle: {
            padding: theme.spacing(0.5)
        },
        loaderBox: {
            width: '100%',
            display: 'inline-flex',
            justifyContent: 'center',
            padding: theme.spacing(2)
        }
    });
});
var ProductSatisfactionForm = function(param) {
    var reviews = param.reviews, getReviews1 = param.getReviews, sku = param.sku, answersSaved = param.answersSaved, saveAnswers = param.saveAnswers, t = param.t, orderId = param.orderId;
    var classes = ProductSatisfactionForm_useStyles();
    var ref5 = (0,react.useState)([]), answers = ref5[0], setAnswers = ref5[1];
    var ref1 = (0,react.useState)({
        sku: null,
        questions: null
    }), productReview = ref1[0], setProductReview = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    (0,react.useEffect)(function() {
        var asyncFunc = function() {
            var _ref = ProductSatisfactionForm_asyncToGenerator(runtime_default().mark(function _callee() {
                var ref, ref3, requestResponse, ref4;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            setIsLoading(true);
                            if (!(orderId && !(reviews === null || reviews === void 0 ? void 0 : (ref = reviews.items) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                                return item.sku === sku;
                            })))) {
                                _ctx.next = 10;
                                break;
                            }
                            ;
                            _ctx.next = 6;
                            return getReviews1(orderId);
                        case 6:
                            requestResponse = _ctx.sent;
                            if ((requestResponse === null || requestResponse === void 0 ? void 0 : (ref3 = requestResponse.reviews) === null || ref3 === void 0 ? void 0 : ref3.length) > 0) {
                                setProductReview(requestResponse.reviews[0]);
                            } else {
                                setProductReview({
                                    sku: null,
                                    questions: null
                                });
                            }
                            _ctx.next = 11;
                            break;
                        case 10:
                            {
                                ;
                                setProductReview(reviews === null || reviews === void 0 ? void 0 : (ref4 = reviews.items) === null || ref4 === void 0 ? void 0 : ref4.find(function(item) {
                                    return item.sku === sku;
                                }));
                            }
                        case 11:
                            setIsLoading(false);
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function asyncFunc() {
                return _ref.apply(this, arguments);
            };
        }();
        asyncFunc();
    }, [
        orderId
    ]);
    var handleStateCommand = function(event, idQuestion) {
        var currentAnswers = _toConsumableArray(answers);
        if (currentAnswers.find(function(answer) {
            return answer.reviewQuestionId === idQuestion;
        })) {
            currentAnswers.splice(currentAnswers.findIndex(function(answer) {
                return answer.reviewQuestionId === idQuestion;
            }), 1);
        }
        currentAnswers.push({
            reviewQuestionId: idQuestion,
            questionChoiceId: parseInt(event.target.value)
        });
        setAnswers(currentAnswers);
        saveAnswers(currentAnswers, sku, orderId);
    };
    var handleStateRate = function(event, idQuestion, defaultQuestionId) {
        var currentAnswers = _toConsumableArray(answers);
        if (currentAnswers.find(function(answer) {
            return answer.reviewQuestionId === idQuestion;
        })) {
            currentAnswers.splice(currentAnswers.findIndex(function(answer) {
                return answer.reviewQuestionId === idQuestion;
            }), 1);
        }
        currentAnswers.push({
            reviewQuestionId: idQuestion,
            rate: parseInt(event.target.value),
            questionChoiceId: defaultQuestionId
        });
        setAnswers(currentAnswers);
        saveAnswers(currentAnswers, sku, orderId);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.loaderBox,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.root,
            children: (productReview === null || productReview === void 0 ? void 0 : productReview.questions) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                spacing: 2,
                children: productReview === null || productReview === void 0 ? void 0 : productReview.questions.map(function(question, index1) {
                    var ref, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
                    var arrayRate = [];
                    if (question.rate) {
                        for(var i = question.min; i <= question.max; i++){
                            arrayRate.push(i);
                        }
                    }
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: 'body2',
                                className: classes.questionTitle,
                                children: question.title
                            }),
                            question.rate ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                    variant: "outlined",
                                    className: classes.formControl,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                        value: ((ref6 = answersSaved === null || answersSaved === void 0 ? void 0 : (ref = answersSaved.answers) === null || ref === void 0 ? void 0 : ref.find(function(answer) {
                                            return answer.reviewQuestionId === question.id;
                                        })) === null || ref6 === void 0 ? void 0 : ref6.rate) ? (ref8 = answersSaved === null || answersSaved === void 0 ? void 0 : (ref7 = answersSaved.answers) === null || ref7 === void 0 ? void 0 : ref7.find(function(answer) {
                                            return answer.reviewQuestionId === question.id;
                                        })) === null || ref8 === void 0 ? void 0 : ref8.rate : '',
                                        onChange: function(event) {
                                            return handleStateRate(event, question.id, question.questionChoices[0].id);
                                        },
                                        placeholder: t('account:review_placeholder'),
                                        className: classes.sizeSelector,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                "aria-label": "None",
                                                value: "",
                                                children: t('texts:account:review_placeholder')
                                            }),
                                            arrayRate.map(function(option, index) {
                                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: option,
                                                    children: option
                                                }, index));
                                            })
                                        ]
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                    variant: "outlined",
                                    className: classes.formControl,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                        value: ((ref10 = answersSaved === null || answersSaved === void 0 ? void 0 : (ref9 = answersSaved.answers) === null || ref9 === void 0 ? void 0 : ref9.find(function(answer) {
                                            return answer.reviewQuestionId === question.id;
                                        })) === null || ref10 === void 0 ? void 0 : ref10.questionChoiceId) ? (ref12 = answersSaved === null || answersSaved === void 0 ? void 0 : (ref11 = answersSaved.answers) === null || ref11 === void 0 ? void 0 : ref11.find(function(answer) {
                                            return answer.reviewQuestionId === question.id;
                                        })) === null || ref12 === void 0 ? void 0 : ref12.questionChoiceId : '',
                                        onChange: function(event) {
                                            return handleStateCommand(event, question.id);
                                        },
                                        className: classes.sizeSelector,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                "aria-label": "None",
                                                value: "",
                                                children: t('texts:account:review_placeholder')
                                            }),
                                            question.questionChoices.map(function(option, index) {
                                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: option.id,
                                                    children: option.choice
                                                }, index));
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }, index1));
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        })
    }));
};
/* harmony default export */ var Order_ProductSatisfactionForm = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(ProductSatisfactionForm));

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Help.js
var Help = __webpack_require__(60424);
// EXTERNAL MODULE: ./components/TextField/TextField.tsx + 1 modules
var TextField = __webpack_require__(59000);
;// CONCATENATED MODULE: ./components/Order/GlobalSatisfactionForm.tsx







function GlobalSatisfactionForm_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function GlobalSatisfactionForm_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return GlobalSatisfactionForm_arrayLikeToArray(arr);
}
function GlobalSatisfactionForm_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function GlobalSatisfactionForm_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function GlobalSatisfactionForm_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function GlobalSatisfactionForm_toConsumableArray(arr) {
    return GlobalSatisfactionForm_arrayWithoutHoles(arr) || GlobalSatisfactionForm_iterableToArray(arr) || GlobalSatisfactionForm_unsupportedIterableToArray(arr) || GlobalSatisfactionForm_nonIterableSpread();
}
function GlobalSatisfactionForm_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return GlobalSatisfactionForm_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return GlobalSatisfactionForm_arrayLikeToArray(o, minLen);
}
var GlobalSatisfactionForm_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: GlobalSatisfactionForm_defineProperty({
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(2),
            background: theme.extraColors.greyLight,
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(3, 4, 2)
        }, theme.breakpoints.down('md'), {
            padding: theme.spacing(2, 2, 1)
        }),
        rowCenter: {
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        rowLayout: GlobalSatisfactionForm_defineProperty({
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(2)
        }, theme.breakpoints.down('md'), {
            gap: theme.spacing(1)
        }),
        spaceLeft: {
            marginLeft: theme.spacing(2)
        },
        note: GlobalSatisfactionForm_defineProperty({
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: 36,
            height: 36,
            lineHeight: 1,
            textAlign: 'center',
            border: "".concat(theme.palette.common.black, " solid 1px"),
            borderRadius: '50%',
            margin: theme.spacing(0.5),
            cursor: 'pointer'
        }, theme.breakpoints.down('md'), {
            width: 24,
            height: 24,
            margin: theme.spacing(0.25)
        }),
        noteActive: {
            border: "".concat(theme.palette.secondary.main, " solid 2px"),
            color: theme.palette.secondary.main,
            fontWeight: 700
        },
        alignCenter: {
            textAlign: 'center'
        },
        textArea: {
            '& .input': {
                backgroundColor: theme.palette.common.white,
                '& .MuiInput-root': {
                    position: 'initial',
                    width: '100%'
                },
                '& .MuiInput-underline:before': {
                    display: 'none'
                }
            }
        },
        textAreaContainer: {}
    });
});
var GlobalSatisfactionForm = function(param) {
    var doc = param.doc, t = param.t, setGlobalReview = param.setGlobalReview, handleMessage = param.handleMessage, message = param.message;
    var ref7, ref1, ref2, ref3, ref4;
    var classes = GlobalSatisfactionForm_useStyles();
    var ref5 = (0,react.useState)([]), notes = ref5[0], setNotes = ref5[1];
    var noteArray = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10
    ];
    var handleNotes = function(idQuestion, note) {
        var arrayNotes = GlobalSatisfactionForm_toConsumableArray(notes);
        arrayNotes[idQuestion].note = note;
        setNotes(arrayNotes);
        setGlobalReview(arrayNotes);
    };
    (0,react.useEffect)(function() {
        var ref, ref6;
        var array = GlobalSatisfactionForm_toConsumableArray(notes);
        doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : (ref6 = ref.questions) === null || ref6 === void 0 ? void 0 : ref6.map(function(question, index) {
            array.push({
                note: 5,
                id: index
            });
        });
        setNotes(array);
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.rowCenter,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.spaceLeft,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: 'h3',
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: doc === null || doc === void 0 ? void 0 : (ref7 = doc.data) === null || ref7 === void 0 ? void 0 : ref7.main_title,
                                    defaultText: t('texts:customer_survey:main_title')
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: 'caption',
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: doc === null || doc === void 0 ? void 0 : (ref1 = doc.data) === null || ref1 === void 0 ? void 0 : ref1.subtitle,
                                    defaultText: t('texts:customer_survey:subtitle')
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.rowLayout,
                children: doc === null || doc === void 0 ? void 0 : (ref2 = doc.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.questions) === null || ref3 === void 0 ? void 0 : ref3.map(function(question, index) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: 'caption',
                                component: 'p',
                                children: (0,CMSText/* prismicText */.yz)(question === null || question === void 0 ? void 0 : question.question)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.rowCenter,
                                children: noteArray === null || noteArray === void 0 ? void 0 : noteArray.map(function(note, key) {
                                    var ref;
                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,clsx_m/* default */.Z)(classes.note, ((ref = notes[index]) === null || ref === void 0 ? void 0 : ref.note) === note && classes.noteActive),
                                        onClick: function() {
                                            return handleNotes(index, note);
                                        },
                                        children: note
                                    }, key));
                                })
                            })
                        ]
                    }, index));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.textAreaContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "caption",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: doc === null || doc === void 0 ? void 0 : (ref4 = doc.data) === null || ref4 === void 0 ? void 0 : ref4.let_a_message,
                            defaultText: t('texts:customer_survey:let_a_message')
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        multiline: true,
                        textArea: true,
                        rows: 4,
                        rowsMax: 4,
                        type: 'textarea',
                        name: 'message',
                        value: message,
                        onChange: handleMessage,
                        className: (0,clsx_m/* default */.Z)('textarea', classes.textArea)
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Order_GlobalSatisfactionForm = (GlobalSatisfactionForm);

// EXTERNAL MODULE: ./components/Order/OrderProductRow.tsx
var OrderProductRow = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowForward.js
var ArrowForward = __webpack_require__(29973);
// EXTERNAL MODULE: ./components/Shop/Price.tsx
var Price = __webpack_require__(31907);
;// CONCATENATED MODULE: ./components/Subscription/SubscriptionListHeader.tsx











function SubscriptionListHeader_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var customParseFormat = __webpack_require__(10285);
dayjs_min_default().extend(customParseFormat);
var SubscriptionListHeader_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        orderHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            textAlign: 'left'
        },
        smallerText: SubscriptionListHeader_defineProperty({
            fontSize: theme.typography.pxToRem(10)
        }, theme.breakpoints.down('md'), {
            fontSize: theme.typography.pxToRem(9)
        }),
        card: {
            background: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(3)
        },
        smallButton: SubscriptionListHeader_defineProperty({
            padding: theme.spacing(1, 1)
        }, theme.breakpoints.down('md'), {
            fontSize: theme.typography.pxToRem(11),
            padding: theme.spacing(0.4, 0.4)
        }),
        priceTotal: {
            marginLeft: theme.spacing(2)
        },
        subscription: SubscriptionListHeader_defineProperty({}, theme.breakpoints.down('md'), {
            fontSize: theme.typography.pxToRem(13)
        }),
        price: SubscriptionListHeader_defineProperty({}, theme.breakpoints.down('md'), {
            fontSize: theme.typography.pxToRem(13)
        }),
        returnButton: SubscriptionListHeader_defineProperty({
            margin: theme.spacing(1)
        }, theme.breakpoints.down('md'), {
            margin: theme.spacing(0.4)
        }),
        cancelButton: {
            width: 150,
            textAlign: 'center',
            cursor: 'pointer',
            '& .MuiTypography-root': SubscriptionListHeader_defineProperty({}, theme.breakpoints.down('md'), {
                fontSize: '80%'
            })
        },
        spacing: {
            marginLeft: 19
        },
        subscriptionBox: {
            margin: theme.spacing(0.4)
        },
        mobileLinkToModif: {
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end'
        },
        simpleMargin: {
            margin: theme.spacing(1)
        },
        subDone: SubscriptionListHeader_defineProperty({
            maxWidth: 400
        }, theme.breakpoints.up('md'), {
            paddingTop: theme.spacing(3)
        })
    });
});
var SubscriptionListHeader_mapStateToProps = function(state) {
    return {
        promotions: state.promotions,
        parameters: state.parameters
    };
};
var SubscriptionListHeader = function(param) {
    var isFunnel = param.isFunnel, allProducts = param.allProducts, isClassicSub = param.isClassicSub, isSmallScreen = param.isSmallScreen, isModifying = param.isModifying, doc = param.doc, isInStore = param.isInStore, t = param.t, cancelReturn = param.cancelReturn, setIsModifying = param.setIsModifying, contract = param.contract, totalCurrent = param.totalCurrent, newTotal = param.newTotal, currentSubscriptionPrice = param.currentSubscriptionPrice, currentSubscriptionMaxItems = param.currentSubscriptionMaxItems, newSubscriptionPrice = param.newSubscriptionPrice, newSubscriptionMaxItems = param.newSubscriptionMaxItems, settings = param.settings, orders = param.orders, parameters = param.parameters;
    var ref24, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
    var classes = SubscriptionListHeader_useStyles();
    var router = (0,next_router.useRouter)();
    var displayFlexPrice = settings === null || settings === void 0 ? void 0 : settings.display_flex_price_a_day;
    var minSubDuration = parseInt(parameters === null || parameters === void 0 ? void 0 : (ref24 = parameters.items) === null || ref24 === void 0 ? void 0 : ref24.minSubscriptionDays);
    var ref23 = (0,react.useState)(dayjs_min_default()().add(30, 'day')), minSubscriptionDate = ref23[0], setMinSubscriptionDate = ref23[1];
    var isDisabled = dayjs_min_default()().isBefore(minSubscriptionDate);
    (0,react.useEffect)(function() {
        var ref;
        if ((orders === null || orders === void 0 ? void 0 : orders.length) > 0) setMinSubscriptionDate(dayjs_min_default()((ref = orders[(orders === null || orders === void 0 ? void 0 : orders.length) - 1]) === null || ref === void 0 ? void 0 : ref.startLeasingDate, 'DD/MM/YYYY').add(minSubDuration, 'day'));
    }, [
        orders
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isFunnel && allProducts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: !isClassicSub ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    isSmallScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.mobileLinkToModif,
                        children: !isModifying ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                "data-testid": 'returnBtn',
                                className: classes.simpleMargin,
                                onClick: function() {
                                    var ref, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35;
                                    return (doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : (ref25 = ref.handle_return_cta) === null || ref25 === void 0 ? void 0 : (ref26 = ref25[0]) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.spans) === null || ref27 === void 0 ? void 0 : (ref28 = ref27[0]) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.data) === null || ref29 === void 0 ? void 0 : ref29.url) ? router.push(doc === null || doc === void 0 ? void 0 : (ref30 = doc.data) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.handle_return_cta) === null || ref31 === void 0 ? void 0 : (ref32 = ref31[0]) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.spans) === null || ref33 === void 0 ? void 0 : (ref34 = ref33[0]) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.data) === null || ref35 === void 0 ? void 0 : ref35.url) : setIsModifying(true);
                                },
                                color: 'primary',
                                disabled: isDisabled,
                                variant: 'text',
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: 'body2',
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: doc === null || doc === void 0 ? void 0 : (ref1 = doc.data) === null || ref1 === void 0 ? void 0 : ref1.handle_return_cta,
                                        defaultText: t('texts:subscription_order:change_cta')
                                    })
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                "data-testid": 'cancelBtn',
                                color: 'primary',
                                className: classes.simpleMargin,
                                onClick: cancelReturn,
                                variant: 'text',
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: 'body2',
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: doc === null || doc === void 0 ? void 0 : (ref2 = doc.data) === null || ref2 === void 0 ? void 0 : ref2.cancel_cta,
                                        defaultText: t('texts:subscription_order:cancel_cta')
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)(classes.orderHeader, isInStore && classes.card),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.subscriptionBox,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'h4',
                                        className: classes.subscription,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: doc === null || doc === void 0 ? void 0 : (ref3 = doc.data) === null || ref3 === void 0 ? void 0 : ref3.my_subscription,
                                            defaultText: t('texts:subscription_order:my_subscription')
                                        })
                                    }),
                                    contract && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: 'body2',
                                        className: classes.smallerText,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: doc === null || doc === void 0 ? void 0 : (ref4 = doc.data) === null || ref4 === void 0 ? void 0 : ref4.taken_every,
                                                defaultText: t('texts:subscription_order:taken_every')
                                            }),
                                            "\xa0",
                                            dayjs_min_default()(contract === null || contract === void 0 ? void 0 : contract.startLeasingDate).date(),
                                            "\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: doc === null || doc === void 0 ? void 0 : (ref5 = doc.data) === null || ref5 === void 0 ? void 0 : ref5.of_the_month,
                                                defaultText: t('texts:subscription_order:of_the_month')
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.priceTotal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: 'h3',
                                    color: 'secondary',
                                    className: classes.price,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                        amount: totalCurrent,
                                        isShort: false,
                                        showDayOrMonth: true,
                                        dayOrMonth: settings.day_or_month,
                                        amountNotDivided: true,
                                        displayFlexPrice: displayFlexPrice
                                    })
                                })
                            }),
                            isSmallScreen && isModifying && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classes.returnButton,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.priceTotal,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: 'h3',
                                                color: 'secondary',
                                                className: classes.price,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                    amount: newTotal,
                                                    isShort: false,
                                                    showDayOrMonth: true,
                                                    dayOrMonth: settings.day_or_month,
                                                    amountNotDivided: true,
                                                    displayFlexPrice: displayFlexPrice
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: 'body2',
                                                className: classes.smallerText,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: doc === null || doc === void 0 ? void 0 : (ref6 = doc.data) === null || ref6 === void 0 ? void 0 : ref6.per_month,
                                                    defaultText: t('texts:subscription_order:per_month')
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isSmallScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: !isModifying ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.returnButton,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: 'outlined',
                                        color: 'secondary',
                                        className: classes.smallButton,
                                        size: 'small',
                                        onClick: function() {
                                            var ref, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46;
                                            return (doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : (ref36 = ref.handle_return_cta) === null || ref36 === void 0 ? void 0 : (ref37 = ref36[0]) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.spans) === null || ref38 === void 0 ? void 0 : (ref39 = ref38[0]) === null || ref39 === void 0 ? void 0 : (ref40 = ref39.data) === null || ref40 === void 0 ? void 0 : ref40.url) ? router.push(doc === null || doc === void 0 ? void 0 : (ref41 = doc.data) === null || ref41 === void 0 ? void 0 : (ref42 = ref41.handle_return_cta) === null || ref42 === void 0 ? void 0 : (ref43 = ref42[0]) === null || ref43 === void 0 ? void 0 : (ref44 = ref43.spans) === null || ref44 === void 0 ? void 0 : (ref45 = ref44[0]) === null || ref45 === void 0 ? void 0 : (ref46 = ref45.data) === null || ref46 === void 0 ? void 0 : ref46.url) : setIsModifying(true);
                                        },
                                        "data-testid": 'returnBtn',
                                        disabled: isDisabled,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: doc === null || doc === void 0 ? void 0 : (ref7 = doc.data) === null || ref7 === void 0 ? void 0 : ref7.handle_return_cta,
                                            defaultText: t('texts:subscription_order:handle_return_cta')
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes.returnButton,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.priceTotal,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: 'h3',
                                                            color: 'secondary',
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                amount: newTotal,
                                                                isShort: false,
                                                                showDayOrMonth: true,
                                                                dayOrMonth: settings.day_or_month,
                                                                amountNotDivided: true,
                                                                displayFlexPrice: displayFlexPrice
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.cancelButton,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        "data-testid": 'cancelBtn',
                                                        variant: 'body2',
                                                        color: 'secondary',
                                                        onClick: cancelReturn,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: doc === null || doc === void 0 ? void 0 : (ref8 = doc.data) === null || ref8 === void 0 ? void 0 : ref8.cancel_cta,
                                                            defaultText: t('texts:subscription_order:cancel_cta')
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.orderHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: 'body2',
                                className: classes.smallerText,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: doc === null || doc === void 0 ? void 0 : (ref9 = doc.data) === null || ref9 === void 0 ? void 0 : ref9.my_subscription,
                                    defaultText: t('texts:subscription_order:my_subscription')
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: 'h4',
                                className: classes.subscription,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: doc === null || doc === void 0 ? void 0 : (ref10 = doc.data) === null || ref10 === void 0 ? void 0 : ref10.forfaits,
                                        defaultText: t('texts:subscription_order:rate')
                                    }),
                                    "\xa0",
                                    currentSubscriptionMaxItems,
                                    "\xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: doc === null || doc === void 0 ? void 0 : (ref11 = doc.data) === null || ref11 === void 0 ? void 0 : ref11.articles_max,
                                        defaultText: t('texts:subscription_order:articles_max')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: 'h4',
                                color: 'secondary',
                                className: classes.subscription,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                    amount: currentSubscriptionPrice,
                                    isShort: false,
                                    showDayOrMonth: true,
                                    dayOrMonth: settings.day_or_month,
                                    displayFlexPrice: displayFlexPrice
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: 'body2',
                                color: 'secondary',
                                className: classes.smallerText,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: doc === null || doc === void 0 ? void 0 : (ref12 = doc.data) === null || ref12 === void 0 ? void 0 : ref12.taken_every,
                                        defaultText: t('texts:subscription_order:taken_every')
                                    }),
                                    "\xa0",
                                    contract && dayjs_min_default()(contract === null || contract === void 0 ? void 0 : contract.startLeasingDate).date(),
                                    "\xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: doc === null || doc === void 0 ? void 0 : (ref13 = doc.data) === null || ref13 === void 0 ? void 0 : ref13.of_the_month,
                                        defaultText: t('texts:subscription_order:per_month')
                                    })
                                ]
                            })
                        ]
                    }),
                    !isModifying ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.returnButton,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            "data-testid": 'returnBtn',
                            variant: 'outlined',
                            color: 'secondary',
                            size: isSmallScreen ? 'small' : 'medium',
                            onClick: function() {
                                var ref, ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56, ref57;
                                return (doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : (ref47 = ref.handle_return_cta) === null || ref47 === void 0 ? void 0 : (ref48 = ref47[0]) === null || ref48 === void 0 ? void 0 : (ref49 = ref48.spans) === null || ref49 === void 0 ? void 0 : (ref50 = ref49[0]) === null || ref50 === void 0 ? void 0 : (ref51 = ref50.data) === null || ref51 === void 0 ? void 0 : ref51.url) ? router.push(doc === null || doc === void 0 ? void 0 : (ref52 = doc.data) === null || ref52 === void 0 ? void 0 : (ref53 = ref52.handle_return_cta) === null || ref53 === void 0 ? void 0 : (ref54 = ref53[0]) === null || ref54 === void 0 ? void 0 : (ref55 = ref54.spans) === null || ref55 === void 0 ? void 0 : (ref56 = ref55[0]) === null || ref56 === void 0 ? void 0 : (ref57 = ref56.data) === null || ref57 === void 0 ? void 0 : ref57.url) : setIsModifying(true);
                            },
                            disabled: isDisabled,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                asText: true,
                                data: doc === null || doc === void 0 ? void 0 : (ref14 = doc.data) === null || ref14 === void 0 ? void 0 : ref14.handle_return_cta,
                                defaultText: t('texts:subscription_order:handle_return_cta')
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.returnButton,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: newSubscriptionPrice / 100 === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.subDone,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: 'h4',
                                            color: 'secondary',
                                            className: classes.subscription,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: doc === null || doc === void 0 ? void 0 : (ref15 = doc.data) === null || ref15 === void 0 ? void 0 : ref15.sub_finished_title,
                                                defaultText: t('texts:subscription_order:sub_finished:title')
                                            })
                                        }),
                                        !isSmallScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: 'body2',
                                            color: 'secondary',
                                            component: 'div',
                                            className: classes.smallerText,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                data: doc === null || doc === void 0 ? void 0 : (ref16 = doc.data) === null || ref16 === void 0 ? void 0 : ref16.sub_finished_desc,
                                                defaultText: t('texts:subscription_order:sub_finished:desc')
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: 'body2',
                                            className: classes.smallerText,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: doc === null || doc === void 0 ? void 0 : (ref17 = doc.data) === null || ref17 === void 0 ? void 0 : ref17.my_new_subscription,
                                                defaultText: t('texts:subscription_order:my_new_subscription')
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: 'h4',
                                            className: classes.subscription,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: doc === null || doc === void 0 ? void 0 : (ref18 = doc.data) === null || ref18 === void 0 ? void 0 : ref18.forfaits,
                                                    defaultText: t('texts:subscription_order:rate')
                                                }),
                                                "\xa0",
                                                newSubscriptionMaxItems,
                                                "\xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: doc === null || doc === void 0 ? void 0 : (ref19 = doc.data) === null || ref19 === void 0 ? void 0 : ref19.articles_max,
                                                    defaultText: t('texts:subscription_order:articles_max')
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: 'h4',
                                            color: 'secondary',
                                            className: classes.subscription,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                amount: newSubscriptionPrice,
                                                isShort: false,
                                                showDayOrMonth: true,
                                                dayOrMonth: settings.day_or_month,
                                                displayFlexPrice: displayFlexPrice
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: 'body2',
                                            color: 'secondary',
                                            className: classes.smallerText,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: doc === null || doc === void 0 ? void 0 : (ref20 = doc.data) === null || ref20 === void 0 ? void 0 : ref20.taken_every,
                                                    defaultText: t('texts:subscription_order:taken_every')
                                                }),
                                                "\xa0",
                                                dayjs_min_default()(contract === null || contract === void 0 ? void 0 : contract.startLeasingDate).date(),
                                                "\xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: doc === null || doc === void 0 ? void 0 : (ref21 = doc.data) === null || ref21 === void 0 ? void 0 : ref21.of_the_month,
                                                    defaultText: t('texts:subscription_order:of_the_month')
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.cancelButton,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    "data-testid": 'cancelBtn',
                                    variant: 'body2',
                                    color: 'secondary',
                                    onClick: cancelReturn,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: doc === null || doc === void 0 ? void 0 : (ref22 = doc.data) === null || ref22 === void 0 ? void 0 : ref22.cancel_cta,
                                        defaultText: t('texts:subscription_order:cancel_cta')
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var Subscription_SubscriptionListHeader = ((0,es/* connect */.$j)(SubscriptionListHeader_mapStateToProps)(SubscriptionListHeader));

// EXTERNAL MODULE: ./redux/actions/inStore.ts + 1 modules
var inStore = __webpack_require__(7766);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Info.js
var Info = __webpack_require__(18362);
// EXTERNAL MODULE: ./components/Global/GlobalModal.tsx
var GlobalModal = __webpack_require__(29902);
// EXTERNAL MODULE: ./hooks/useThrottle.ts
var useThrottle = __webpack_require__(52957);
;// CONCATENATED MODULE: ./components/ReturnVoucherButton/ReturnVoucherButton.tsx









var ReturnVoucherButton_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        downloadlink: {
            textDecoration: 'underline'
        },
        hide: {
            opacity: 0,
            transition: theme.transitions.create('opacity')
        },
        show: {
            opacity: 1,
            transition: theme.transitions.create('opacity')
        },
        modalButtonsContainer: {
            display: 'flex',
            marginTop: '1rem',
            justifyContent: 'center'
        },
        modalButton: {
            '&:nth-child(2)': {
                marginLeft: '2rem'
            }
        },
        messageContainer: {
            display: 'flex',
            alignItems: 'center',
            '&>span': {
                marginLeft: '2rem'
            }
        }
    });
});
var ReturnVoucherButton = function(param) {
    var downloadLink = param.downloadLink, t = param.t, prismicData = param.prismicData, isDisabled = param.isDisabled, isDownloadLoading = param.isDownloadLoading, text = param.text, onValidateAction = param.onValidate;
    var classes = ReturnVoucherButton_useStyles();
    var ref = (0,react.useState)(false), openModal = ref[0], setOpenModal = ref[1];
    var hasDownloadLink = downloadLink !== '';
    var onValidate = (0,useThrottle/* useThrottle */.f)(onValidateAction, 1500);
    var handleCloseModal = function() {
        setOpenModal(false);
    };
    return hasDownloadLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
        variant: 'h4',
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: downloadLink,
            target: 'blank',
            className: classes.downloadlink,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                data: [],
                defaultText: t('texts:subscription_order:link_download_return')
            })
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                "data-testid": 'downloadBtn',
                variant: 'outlined',
                color: 'secondary',
                size: 'small',
                disabled: isDisabled,
                onClick: function() {
                    return setOpenModal(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: isDownloadLoading ? classes.hide : classes.show,
                        children: text
                    }),
                    isDownloadLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalModal/* default */.Z, {
                open: openModal,
                onClose: handleCloseModal,
                modalTitle: {
                    data: prismicData === null || prismicData === void 0 ? void 0 : prismicData.return_voucher_modal_title,
                    defaultText: t('texts:confirmation:generate_vouchers')
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.messageContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                    color: "error",
                                    fontSize: "large"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        data: prismicData === null || prismicData === void 0 ? void 0 : prismicData.return_voucher_modal_message,
                                        defaultText: t('texts:confirmation:voucher_confirmation_message')
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.modalButtonsContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    onClick: handleCloseModal,
                                    className: classes.modalButton,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        data: prismicData === null || prismicData === void 0 ? void 0 : prismicData.return_voucher_modal_cancel,
                                        defaultText: t('texts:confirmation:cancel')
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    onClick: onValidate,
                                    variant: 'contained',
                                    color: 'secondary',
                                    className: classes.modalButton,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        data: prismicData === null || prismicData === void 0 ? void 0 : prismicData.return_voucher_modal_confirm,
                                        defaultText: t('texts:confirmation:confirm')
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ReturnVoucherButton_ReturnVoucherButton = (ReturnVoucherButton);

;// CONCATENATED MODULE: ./components/Subscription/SubscriptionList.tsx




















function SubscriptionList_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function SubscriptionList_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return SubscriptionList_arrayLikeToArray(arr);
}
function SubscriptionList_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function SubscriptionList_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                SubscriptionList_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                SubscriptionList_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function SubscriptionList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SubscriptionList_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function SubscriptionList_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SubscriptionList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SubscriptionList_toConsumableArray(arr) {
    return SubscriptionList_arrayWithoutHoles(arr) || SubscriptionList_iterableToArray(arr) || SubscriptionList_unsupportedIterableToArray(arr) || SubscriptionList_nonIterableSpread();
}
function SubscriptionList_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SubscriptionList_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SubscriptionList_arrayLikeToArray(o, minLen);
}
var SubscriptionList_customParseFormat = __webpack_require__(10285);
dayjs_min_default().extend(SubscriptionList_customParseFormat);
var SubscriptionList_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        orderCard: SubscriptionList_defineProperty({
            background: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(3),
            marginTop: theme.spacing(1)
        }, theme.breakpoints.down('md'), {
            padding: theme.spacing(2)
        }),
        card: {
            background: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius,
            margin: theme.spacing(2, 0),
            padding: theme.spacing(3)
        },
        orderCardInStore: {
            marginTop: theme.spacing(1)
        },
        orderList: {
            marginTop: theme.spacing(2)
        },
        validModif: {
            width: '100%',
            textAlign: 'center',
            margin: theme.spacing(2, 0),
            padding: theme.spacing(1),
            position: 'sticky',
            bottom: 0,
            background: theme.palette.common.white
        },
        validModifInStore: SubscriptionList_defineProperty({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: theme.spacing(1),
            margin: theme.spacing(2, 0),
            padding: theme.spacing(1),
            background: theme.palette.common.white
        }, theme.breakpoints.down('md'), {
            flexDirection: 'column'
        }),
        inStoreRow: {
            textAlign: 'center'
        },
        subscription: SubscriptionList_defineProperty({}, theme.breakpoints.down('md'), {
            fontSize: 13
        }),
        price: SubscriptionList_defineProperty({}, theme.breakpoints.down('md'), {
            fontSize: 13
        }),
        separatorProduct: {
            borderBottom: "1px solid ".concat(theme.extraColors.greyLight),
            margin: theme.spacing(1)
        },
        spacing: {
            marginLeft: 19
        },
        warehouseContainer: {
            margin: theme.spacing(2, 0)
        },
        inProgress: {
            overflow: 'hidden',
            '& >span': {
                position: 'relative',
                color: theme.palette.common.white,
                zIndex: 2
            },
            '&:before': {
                content: '""',
                zIndex: 1,
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                backgroundColor: theme.palette.secondary.main,
                animation: '$progress 5s forwards',
                transformOrigin: 'left',
                willChange: 'transform'
            }
        },
        '@keyframes progress': {
            '0%': {
                transform: 'scale3d(0, 1, 1)'
            },
            '20%': {
                transform: 'scale3d(0.8, 1, 1)'
            },
            '80%': {
                transform: 'scale3d(0.9, 1, 1)'
            },
            '100%': {
                transform: 'scale3d(1.1, 1, 1)'
            }
        },
        buyArea: {
            display: 'flex',
            justifyContent: 'flex-end'
        }
    });
});
var SubscriptionList_mapStateToProps = function(state) {
    return {
        promotions: state.promotions,
        user: state.user,
        parameters: state.parameters
    };
};
var SubscriptionList_mapDispatchToProps = {
    postReviews: reviews_postReviews,
    getStoresByOrderId: inStore/* getStoresByOrderId */.f0
};
var SubscriptionList = function(param) {
    var orders = param.orders, postProductToReturn = param.postProductToReturn, saveProductToReturn = param.saveProductToReturn, submitConnectedData = param.submitConnectedData, promotions = param.promotions, isFunnel = param.isFunnel, postReviews1 = param.postReviews, contract = param.contract, getStoresByOrderId1 = param.getStoresByOrderId, user = param.user, parameters = param.parameters, t = param.t, prismicAccount = param.prismicAccount, doc = param.doc, customer_survey = param.customer_survey, settings = param.settings, inStoreText = param.inStoreText;
    var ref40, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18;
    var classes = SubscriptionList_useStyles();
    var router = (0,next_router.useRouter)();
    var theme = (0,useTheme/* default */.Z)();
    var ref19 = (0,react.useState)(0), totalCurrent = ref19[0], setTotalCurrent = ref19[1];
    var ref20 = (0,react.useState)(isFunnel ? true : false), isModifying = ref20[0], setIsModifying = ref20[1];
    var ref21 = (0,react.useState)([]), productToReturn = ref21[0], setProductToReturn = ref21[1];
    var ref22 = (0,react.useState)(totalCurrent), newTotal = ref22[0], setNewTotal = ref22[1];
    var ref23 = (0,react.useState)(false), returnAll = ref23[0], setReturnAll = ref23[1];
    var ref24 = (0,react.useState)(0), currentSubscriptionPrice1 = ref24[0], setCurrentSubscriptionPrice = ref24[1];
    var ref25 = (0,react.useState)([]), totalAnswers = ref25[0], setTotalAnswers = ref25[1];
    var ref26 = (0,react.useState)({}), globalReview = ref26[0], setGlobalReview = ref26[1];
    var ref27 = (0,react.useState)([]), returnedProducts = ref27[0], setReturnedProducts = ref27[1];
    var ref28 = (0,react.useState)([]), boughtProducts = ref28[0], setBoughtProducts = ref28[1];
    var ref29 = (0,react.useState)([]), filteredOrdersCancelled1 = ref29[0], setFilteredOrdersCancelled = ref29[1];
    var ref30 = (0,react.useState)([]), filteredOrdersRefunded1 = ref30[0], setFilteredOrdersRefunded = ref30[1];
    var ref31 = (0,react.useState)(false), isDownloadLoading = ref31[0], setIsDownloadLoading = ref31[1];
    var ref32 = (0,react.useState)(0), currentSubscriptionMaxItems1 = ref32[0], setCurrentSubscriptionMaxItems = ref32[1];
    var ref33 = (0,react.useState)(0), newSubscriptionPrice = ref33[0], setNewSubscriptionPrice = ref33[1];
    var ref34 = (0,react.useState)(0), newSubscriptionMaxItems = ref34[0], setNewSubscriptionMaxItems = ref34[1];
    var ref35 = (0,react.useState)([]), allProducts = ref35[0], setAllProducts = ref35[1];
    var ref36 = (0,react.useState)([]), filteredOrdersAndProductsByWarehouse = ref36[0], setFilteredOrdersAndProductsByWarehouse = ref36[1];
    var ref37 = (0,react.useState)(false), productSelection = ref37[0], setProductSelection = ref37[1];
    var ref38 = (0,react.useState)(''), downloadLink = ref38[0], setDownloadLink = ref38[1];
    var isSmallScreen = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('md'));
    var isClassicSub = "subscription" === 'classic_subscription';
    var ref39 = (0,react.useState)([]), warehouses = ref39[0], setWarehouses = ref39[1];
    var isBuyingOption = "false";
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    var isDisplayCustomerSurvey = customer_survey === null || customer_survey === void 0 ? void 0 : (ref40 = customer_survey.data) === null || ref40 === void 0 ? void 0 : ref40.display_customer_survey;
    (0,react.useEffect)(function() {
        var ref;
        if (parameters === null || parameters === void 0 ? void 0 : (ref = parameters.items) === null || ref === void 0 ? void 0 : ref.in_store) {
            var isAsync = function() {
                var _ref = SubscriptionList_asyncToGenerator(runtime_default().mark(function _callee() {
                    var orderNumbers, response;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                orderNumbers = [];
                                (orders === null || orders === void 0 ? void 0 : orders.length) > 0 && (orders === null || orders === void 0 ? void 0 : orders.map(function(order) {
                                    order.state !== 'cart' && order.state !== 'cancelled' && orderNumbers.push(order.number);
                                }));
                                _ctx.next = 4;
                                return getStoresByOrderId1(orderNumbers);
                            case 4:
                                response = _ctx.sent;
                                if ((response === null || response === void 0 ? void 0 : response.type) === 'GET_STORES_BY_ORDER_NUMBER_SUCCESS') {
                                    setWarehouses(response === null || response === void 0 ? void 0 : response.stores);
                                }
                            case 6:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function isAsync() {
                    return _ref.apply(this, arguments);
                };
            }();
            isAsync();
        }
    }, [
        orders,
        parameters
    ]);
    // Select all product from
    var handleReturnAll = function() {
        var productsArray = [];
        if (returnAll === false || productToReturn.length === 0) {
            setReturnAll(true);
            setProductSelection(true);
            allProducts.map(function(item, index) {
                var ref;
                if (dayjs_min_default()().isAfter((ref = item === null || item === void 0 ? void 0 : item.units[0]) === null || ref === void 0 ? void 0 : ref.startLeasingDate)) {
                    productsArray.push({
                        id: index,
                        code: item.variant.code,
                        total: item.total,
                        product: item,
                        carrierId: item.carrierId,
                        expand: true,
                        Sku: item.variant.sku,
                        quantity: item.quantity,
                        orderToken: item.orderToken
                    });
                }
            });
            setNewTotal(0);
            setNewSubscriptionPrice(0);
            setNewSubscriptionMaxItems(0);
        } else {
            setReturnAll(false);
            setProductSelection(false);
            setNewTotal(totalCurrent);
            setNewSubscriptionPrice(currentSubscriptionPrice1);
            setNewSubscriptionMaxItems(currentSubscriptionMaxItems1);
        }
        setProductToReturn(productsArray);
    };
    // get all products in array from orders
    var extractProducts = function(arrayOrder) {
        var arrayReturned = [];
        arrayOrder.map(function(order) {
            var ref;
            order.items.length > 0 && ((ref = order.items) === null || ref === void 0 ? void 0 : ref.map(function(product) {
                product['orderToken'] = order.tokenValue;
                arrayReturned.push(product);
            }));
        });
        return arrayReturned;
    };
    // when recieving orders, filter all into different array and calcul
    (0,react.useEffect)(function() {
        if (orders && orders.length > 0) {
            var ref49;
            // Get actual order state
            var fullProductArray = [];
            var returnedProductsArray = [];
            var totalWithoutReturnedAndBoughtProduct = 0;
            var boughtProductsArray = [];
            var filteredOrdersCancelled = orders.filter(function(order) {
                return order.paymentState === 'cancelled';
            });
            // Exclude paid, cancelled and refunded orders + filter on current month
            var filteredOrders = orders.filter(function(order) {
                return order.state !== 'cart' && order.state !== 'cancelled';
            });
            // After filteredOrders, we send the tokens to DLP to get the warehouses. We then create a new array of filtered orders grouped by warehouses
            var filteredOrdersRefunded = orders.filter(function(order) {
                return order.paymentState === 'refunded';
            });
            var filteredOrdersCancelledArray = extractProducts(filteredOrdersCancelled);
            var filteredOrdersRefundedArray = extractProducts(filteredOrdersRefunded);
            // mapping orders to calcul the subscription price and to create a new array wich contain every product row in the orders
            var warehouseOrdersProducts = [];
            // récupération du dernier carrierId pour l'associer à tous les orders, même ceux qui n'ont pas de shipments (comme les renouvellements)
            if ((user === null || user === void 0 ? void 0 : (ref49 = user.orders) === null || ref49 === void 0 ? void 0 : ref49.length) > 0) {
                var ref41, ref42;
                user === null || user === void 0 ? void 0 : (ref41 = user.orders) === null || ref41 === void 0 ? void 0 : ref41.map(function(userOrder) {
                    if (userOrder.shipments.length > 0) {
                        filteredOrders.map(function(filteredOrder) {
                            filteredOrder['shipments'] = userOrder.shipments;
                        });
                    }
                });
                if (parameters === null || parameters === void 0 ? void 0 : (ref42 = parameters.items) === null || ref42 === void 0 ? void 0 : ref42.in_store) {
                    warehouses.map(function(warehouse, indexWarehouse) {
                        warehouseOrdersProducts.push({
                            id: warehouse.id,
                            name: warehouse.name,
                            address: warehouse.address,
                            city: warehouse.city,
                            orders: []
                        });
                        warehouse.orders.map(function(whOrder, indexOrder) {
                            if (typeof filteredOrders.find(function(order) {
                                var ref, ref48;
                                return (order === null || order === void 0 ? void 0 : (ref = order.initialOrderNumber) === null || ref === void 0 ? void 0 : ref.length) > 0 && ((ref48 = order === null || order === void 0 ? void 0 : order.initialOrderNumber[0]) === null || ref48 === void 0 ? void 0 : ref48.length) > 0 ? order.initialOrderNumber[0] === whOrder.orderNumber : order.number === whOrder.orderNumber;
                            }) !== 'undefined') {
                                var ref51, ref45, ref46, ref47;
                                var order1 = filteredOrders.find(function(order) {
                                    var ref, ref52;
                                    return (order === null || order === void 0 ? void 0 : (ref = order.initialOrderNumber) === null || ref === void 0 ? void 0 : ref.length) > 0 && ((ref52 = order === null || order === void 0 ? void 0 : order.initialOrderNumber[0]) === null || ref52 === void 0 ? void 0 : ref52.length) > 0 ? order.initialOrderNumber[0] === whOrder.orderNumber : order.number === whOrder.orderNumber;
                                });
                                warehouseOrdersProducts[indexWarehouse].orders.push({
                                    number: (order1 === null || order1 === void 0 ? void 0 : (ref51 = order1.initialOrderNumber) === null || ref51 === void 0 ? void 0 : ref51.length) > 0 && ((ref45 = order1 === null || order1 === void 0 ? void 0 : order1.initialOrderNumber[0]) === null || ref45 === void 0 ? void 0 : ref45.length) > 0 ? order1.initialOrderNumber[0] : order1.number,
                                    startLeasingDate: order1.startLeasingDate,
                                    tokenValue: order1.tokenValue,
                                    carrierId: (order1 === null || order1 === void 0 ? void 0 : (ref46 = order1.shipments) === null || ref46 === void 0 ? void 0 : ref46.length) > 0 ? order1 === null || order1 === void 0 ? void 0 : order1.shipments[0].method.carrierId : [],
                                    products: []
                                });
                                order1.items.length > 0 && ((ref47 = order1.items) === null || ref47 === void 0 ? void 0 : ref47.map(function(product) {
                                    var ref56, ref53;
                                    (ref56 = product.units) === null || ref56 === void 0 ? void 0 : ref56.map(function(unit) {
                                        if (unit.isReturned) {
                                            returnedProductsArray.push({
                                                product: product,
                                                unit: unit
                                            });
                                        } else {
                                            var ref58, ref54, ref55;
                                            warehouseOrdersProducts[indexWarehouse].orders[indexOrder].products.push(_objectSpread({}, product, {
                                                puid: (ref55 = (ref58 = warehouse === null || warehouse === void 0 ? void 0 : warehouse.orders[indexOrder]) === null || ref58 === void 0 ? void 0 : (ref54 = ref58.products) === null || ref54 === void 0 ? void 0 : ref54.find(function(whProduct) {
                                                    var ref, ref57;
                                                    return whProduct.sku === ((ref57 = product === null || product === void 0 ? void 0 : (ref = product.product) === null || ref === void 0 ? void 0 : ref.variants[0]) === null || ref57 === void 0 ? void 0 : ref57.sku);
                                                })) === null || ref55 === void 0 ? void 0 : ref55.orderNumber
                                            }));
                                            fullProductArray.push(product);
                                            totalWithoutReturnedAndBoughtProduct += product.unitPrice;
                                        }
                                    });
                                    product['size'] = product.variant.size;
                                    product['orderToken'] = order1.tokenValue;
                                    product['orderNumber'] = order1.number;
                                    product['carrierId'] = (order1 === null || order1 === void 0 ? void 0 : (ref53 = order1.shipments) === null || ref53 === void 0 ? void 0 : ref53.length) > 0 ? order1 === null || order1 === void 0 ? void 0 : order1.shipments[0].method.carrierId : undefined;
                                }));
                            }
                        });
                    });
                } else {
                    filteredOrders === null || filteredOrders === void 0 ? void 0 : filteredOrders.map(function(order) {
                        var ref;
                        order.items.length > 0 && ((ref = order.items) === null || ref === void 0 ? void 0 : ref.map(function(product) {
                            if ((0,utils/* isPurchasedItem */.mo)(product)) {
                                boughtProductsArray.push({
                                    product: product
                                });
                            }
                            product.units.map(function(unit) {
                                if (unit.isReturned) {
                                    product['quantity'] = 1;
                                    !(0,utils/* isPurchasedItem */.mo)(product) && returnedProductsArray.push({
                                        product: product,
                                        unit: unit
                                    });
                                } else {
                                    if (!(0,utils/* isPurchasedItem */.mo)(product)) {
                                        product['quantity'] = 1;
                                        fullProductArray.push(product);
                                        totalWithoutReturnedAndBoughtProduct += product.unitPrice;
                                    }
                                }
                            });
                            product['size'] = product.variant.size;
                            product['orderToken'] = order.tokenValue;
                            product['orderNumber'] = order.number;
                            product['carrierId'] = order.shipments[0].method.carrierId;
                        }));
                    });
                }
                // Set the different Prices and the array
                setFilteredOrdersCancelled(filteredOrdersCancelledArray);
                setFilteredOrdersRefunded(filteredOrdersRefundedArray);
                setAllProducts(fullProductArray);
                setFilteredOrdersAndProductsByWarehouse(warehouseOrdersProducts);
                setReturnedProducts(returnedProductsArray);
                setBoughtProducts(boughtProductsArray);
                setTotalCurrent((0,utils/* numberToPrice */.e8)(totalWithoutReturnedAndBoughtProduct));
                setNewTotal((0,utils/* numberToPrice */.e8)(totalWithoutReturnedAndBoughtProduct));
                // For classic subscription we also need to compare the current subscription state to the promotion we recieve to know wich forfait is applied
                if (isClassicSub) {
                    var ref43;
                    if ((promotions === null || promotions === void 0 ? void 0 : (ref43 = promotions.items) === null || ref43 === void 0 ? void 0 : ref43.length) > 0) {
                        var ref44;
                        var userSubscriptionQuantity = 0;
                        var currentSubscriptionMaxItems = 0;
                        var currentSubscriptionPrice = 0;
                        // Only product not returned
                        userSubscriptionQuantity = fullProductArray.length;
                        // Filter plans from coupon_based promotions
                        var plans = promotions === null || promotions === void 0 ? void 0 : (ref44 = promotions.items) === null || ref44 === void 0 ? void 0 : ref44.filter(function(item) {
                            return !item.coupon_based;
                        });
                        plans === null || plans === void 0 ? void 0 : plans.map(function(plan) {
                            if (userSubscriptionQuantity >= plan.rules[0].configuration.from && userSubscriptionQuantity <= plan.rules[0].configuration.to) {
                                currentSubscriptionMaxItems = plan.rules[0].configuration.to;
                                currentSubscriptionPrice = plan.actions[0].configuration[Object.keys(promotions.items[0].actions[0].configuration)[0]].amount;
                            }
                        });
                        setCurrentSubscriptionPrice(currentSubscriptionPrice);
                        setCurrentSubscriptionMaxItems(currentSubscriptionMaxItems);
                        setNewSubscriptionPrice(currentSubscriptionPrice);
                        setNewSubscriptionMaxItems(currentSubscriptionMaxItems);
                    }
                }
            }
        }
    }, [
        orders,
        warehouses,
        user === null || user === void 0 ? void 0 : user.orders
    ]);
    var handleProductSelection = function(Sku, price, id, quantity, token, item1, orderNumber, warehouseId, carrierId) {
        setProductSelection(true);
        var ProductSelectionArray = SubscriptionList_toConsumableArray(productToReturn);
        // we first check if the product selected is already in the array of selected products
        if (productToReturn.find(function(product) {
            return product.id === id;
        })) {
            // if it is true the we remove the row in the array and we adapt the prices
            var index = productToReturn.findIndex(function(product) {
                return product.id === id;
            });
            var warehouseId1 = productToReturn.findIndex(function(product) {
                return product.warehouseId === warehouseId1;
            });
            ProductSelectionArray.splice(index, 1);
            if (newTotal === totalCurrent) {
                setNewTotal(totalCurrent + parseFloat(price) / 100);
            } else {
                setNewTotal(newTotal + parseFloat(price) / 100);
            }
            // if nothing selected, disable generate button
            setProductSelection(ProductSelectionArray.length !== 0);
        } else {
            var ref;
            // if it is false we push a new row in the array of selected products and we adapt the prices
            ProductSelectionArray.push({
                id: id,
                Sku: Sku,
                total: price,
                expand: true,
                product: item1.variant,
                size: item1 === null || item1 === void 0 ? void 0 : (ref = item1.variant) === null || ref === void 0 ? void 0 : ref.size,
                quantity: quantity,
                orderToken: token,
                orderNumber: orderNumber,
                warehouseId: warehouseId,
                carrierId: carrierId
            });
            // if nothing selected, disable generate button
            setProductSelection(ProductSelectionArray.length !== 0);
            if (newTotal === totalCurrent) {
                setNewTotal(totalCurrent - parseFloat(price) / 100);
            } else setNewTotal(newTotal - parseFloat(price) / 100);
        }
        setProductToReturn(ProductSelectionArray);
        // same in classic subscription but we also check if it will change the current forfait if the customer return the current selection
        if (isClassicSub) {
            if ((promotions === null || promotions === void 0 ? void 0 : promotions.items.length) > 0) {
                var ref60;
                var userSubscriptionQuantity = 0;
                var selectedProductQuantity = 0;
                var currentSubscriptionPrice = 0;
                var currentSubscriptionMaxItems = 0;
                ProductSelectionArray.map(function(order) {
                    selectedProductQuantity += order.quantity;
                });
                userSubscriptionQuantity = allProducts.length;
                // Filter plans of coupon based promotions
                var plans = promotions === null || promotions === void 0 ? void 0 : (ref60 = promotions.items) === null || ref60 === void 0 ? void 0 : ref60.filter(function(item) {
                    return !item.coupon_based;
                });
                plans === null || plans === void 0 ? void 0 : plans.map(function(plan) {
                    if (userSubscriptionQuantity - selectedProductQuantity >= plan.rules[0].configuration.from && userSubscriptionQuantity - selectedProductQuantity <= plan.rules[0].configuration.to) {
                        // Because Sylius is complex (and bullshit) we have to go through a lot of objects to find the amount of the current available subscription
                        currentSubscriptionPrice = plan.actions[0].configuration[Object.keys(promotions.items[0].actions[0].configuration)[0]].amount;
                        currentSubscriptionMaxItems = plan.rules[0].configuration.to;
                    }
                });
                setNewSubscriptionPrice(currentSubscriptionPrice);
                setNewSubscriptionMaxItems(currentSubscriptionMaxItems);
            }
        }
    };
    var cancelReturn = function() {
        // we reset everything
        setIsModifying(false);
        setReturnAll(false);
        setProductSelection(false);
        setProductToReturn([]);
        setNewTotal(totalCurrent);
        setNewSubscriptionPrice(currentSubscriptionPrice1);
        setNewSubscriptionMaxItems(currentSubscriptionMaxItems1);
    };
    var sendProductsToReturn = function() {
        var _ref1 = SubscriptionList_asyncToGenerator(runtime_default().mark(function _callee1(warehouseId) {
            var ref, productData, products, data, ref61, ref62;
            return runtime_default().wrap(function _callee$(_ctx1) {
                while(1)switch(_ctx1.prev = _ctx1.next){
                    case 0:
                        ;
                        // we prepare the data to send, the send it and check if response is ok, then we download the recieved file
                        setIsDownloadLoading(true);
                        productData = [];
                        if (warehouseId && typeof warehouseId === 'number') {
                            productData = productToReturn.filter(function(product) {
                                return product.warehouseId === warehouseId;
                            }).map(function(product) {
                                return {
                                    lizeeSKU: product.Sku,
                                    quantity: product.quantity,
                                    orderToken: product.orderToken
                                };
                            });
                        } else {
                            productData = productToReturn.map(function(product) {
                                return {
                                    lizeeSKU: product.Sku,
                                    quantity: product.quantity,
                                    orderToken: product.orderToken
                                };
                            });
                        }
                        products = {
                            products: productData,
                            gender: user === null || user === void 0 ? void 0 : (ref = user.user) === null || ref === void 0 ? void 0 : ref.gender,
                            warehouseId: productToReturn[0].warehouseId,
                            carrierId: productToReturn[0].carrierId
                        };
                        _ctx1.next = 7;
                        return postProductToReturn(products);
                    case 7:
                        data = _ctx1.sent;
                        if (!(data.type === 'POST_PRODUCT_TO_RETURN_SUCCESS')) {
                            _ctx1.next = 22;
                            break;
                        }
                        ;
                        if (totalAnswers.length > 0) {
                            totalAnswers[0]['globalReview'] = globalReview;
                            totalAnswers.map(function() {
                                var _ref = SubscriptionList_asyncToGenerator(runtime_default().mark(function _callee(totalAnswer) {
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                totalAnswer['email'] = user.user.email;
                                                _ctx.next = 3;
                                                return postReviews1(totalAnswer);
                                            case 3:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(totalAnswer) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                        }
                        router.push('/confirmReturn');
                        if (!((ref61 = data === null || data === void 0 ? void 0 : data.response[0]) === null || ref61 === void 0 ? void 0 : ref61.pdfUrl)) {
                            _ctx1.next = 20;
                            break;
                        }
                        ;
                        _ctx1.next = 16;
                        return setDownloadLink((ref62 = data === null || data === void 0 ? void 0 : data.response[0]) === null || ref62 === void 0 ? void 0 : ref62.pdfUrl);
                    case 16:
                        _ctx1.next = 18;
                        return (0,utils/* downloadURI */.l_)(data.response[0].pdfUrl, "".concat("equitry-subscription", "_").concat(data.response[0].trackingCode));
                    case 18:
                        _ctx1.next = 20;
                        return setIsDownloadLoading(false);
                    case 20:
                        _ctx1.next = 23;
                        break;
                    case 22:
                        {
                            setIsDownloadLoading(false);
                        }
                    case 23:
                    case "end":
                        return _ctx1.stop();
                }
            }, _callee1);
        }));
        return function sendProductsToReturn(warehouseId) {
            return _ref1.apply(this, arguments);
        };
    }();
    var funnelSaveProductsToReturn = function() {
        var _ref = SubscriptionList_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return setIsDownloadLoading(true);
                    case 2:
                        _ctx.next = 4;
                        return saveProductToReturn(productToReturn);
                    case 4:
                        _ctx.next = 6;
                        return submitConnectedData();
                    case 6:
                        _ctx.next = 8;
                        return setIsDownloadLoading(false);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function funnelSaveProductsToReturn() {
            return _ref.apply(this, arguments);
        };
    }();
    var saveAnswers = function(answers, sku, orderId) {
        var totalAnswersArray = SubscriptionList_toConsumableArray(totalAnswers);
        var currentOrder = totalAnswersArray.find(function(item) {
            return item.orderId === orderId;
        });
        if (!currentOrder) {
            totalAnswersArray.push({
                orderId: orderId,
                reviews: []
            });
            currentOrder = totalAnswersArray.find(function(item) {
                return item.orderId === orderId;
            });
        }
        var currentProduct = currentOrder.reviews.find(function(item) {
            return item.sku === sku;
        });
        if (!currentProduct) {
            totalAnswersArray.find(function(item) {
                return item.orderId === orderId;
            }).reviews.push({
                sku: sku,
                answers: answers
            });
        } else {
            totalAnswersArray.find(function(item) {
                return item.orderId === orderId;
            }).reviews.find(function(item) {
                return item.sku === sku;
            }).answers = answers;
        }
        setTotalAnswers(totalAnswersArray);
    };
    var handleGlobalReview = function(notes) {
        var ref, ref63, ref64, ref65, ref66, ref67;
        //const globalReviewState = globalReview
        globalReview['NPS'] = ((ref = notes[0]) === null || ref === void 0 ? void 0 : ref.note) ? (ref63 = notes[0]) === null || ref63 === void 0 ? void 0 : ref63.note : null;
        globalReview['expeditionRate'] = ((ref64 = notes[1]) === null || ref64 === void 0 ? void 0 : ref64.note) ? (ref65 = notes[1]) === null || ref65 === void 0 ? void 0 : ref65.note : null;
        globalReview['returnRate'] = ((ref66 = notes[2]) === null || ref66 === void 0 ? void 0 : ref66.note) ? (ref67 = notes[2]) === null || ref67 === void 0 ? void 0 : ref67.note : null;
        setGlobalReview(globalReview);
    };
    var handleMessage = function(message) {
        globalReview['renterReview'] = message;
        setGlobalReview(globalReview);
    };
    var InStoreReturnBtn = function() {
        var ref, ref68;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(InStoreLink, {
            isInStore: parameters === null || parameters === void 0 ? void 0 : (ref = parameters.items) === null || ref === void 0 ? void 0 : ref.in_store,
            isBlank: true,
            cmsDefaultText: t('texts:instore:account_page_return_link_label'),
            cmsText: inStoreText === null || inStoreText === void 0 ? void 0 : (ref68 = inStoreText.data) === null || ref68 === void 0 ? void 0 : ref68.account_page_return_link_label
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (allProducts === null || allProducts === void 0 ? void 0 : allProducts.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)('orders--current', !(parameters === null || parameters === void 0 ? void 0 : (ref1 = parameters.items) === null || ref1 === void 0 ? void 0 : ref1.in_store) ? classes.orderCard : classes.orderCardInStore),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subscription_SubscriptionListHeader, {
                        isFunnel: isFunnel,
                        allProducts: allProducts,
                        isClassicSub: isClassicSub,
                        isSmallScreen: isSmallScreen,
                        isModifying: isModifying,
                        doc: doc,
                        t: t,
                        settings: settings,
                        isInStore: parameters === null || parameters === void 0 ? void 0 : (ref2 = parameters.items) === null || ref2 === void 0 ? void 0 : ref2.in_store,
                        cancelReturn: cancelReturn,
                        setIsModifying: setIsModifying,
                        contract: contract,
                        orders: user === null || user === void 0 ? void 0 : user.orders,
                        totalCurrent: totalCurrent,
                        newTotal: newTotal,
                        currentSubscriptionPrice: currentSubscriptionPrice1,
                        currentSubscriptionMaxItems: currentSubscriptionMaxItems1,
                        newSubscriptionPrice: newSubscriptionPrice,
                        newSubscriptionMaxItems: newSubscriptionMaxItems
                    }),
                    isModifying && !(parameters === null || parameters === void 0 ? void 0 : (ref3 = parameters.items) === null || ref3 === void 0 ? void 0 : ref3.in_store) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.orderList,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                            in: isModifying,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.spacing,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        "data-testid": 'return_all',
                                        checked: returnAll && productToReturn.length !== 0,
                                        onChange: function() {
                                            return handleReturnAll();
                                        },
                                        name: 'return_all'
                                    }),
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'body2',
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: doc === null || doc === void 0 ? void 0 : (ref4 = doc.data) === null || ref4 === void 0 ? void 0 : ref4.select_all_and_stop,
                                            defaultText: t('texts:subscription_order:select_all_and_stop')
                                        })
                                    })
                                })
                            })
                        })
                    }),
                    !(parameters === null || parameters === void 0 ? void 0 : (ref5 = parameters.items) === null || ref5 === void 0 ? void 0 : ref5.in_store) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            allProducts.map(function(item, index) {
                                var ref, ref69;
                                var isExpanded = false;
                                var isSelected = productToReturn.find(function(product) {
                                    return product.id === index;
                                }) ? true : false;
                                if (isSelected) {
                                    isExpanded = productToReturn.find(function(product) {
                                        return product.id === index;
                                    }).expand;
                                }
                                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductRow/* default */.Z, {
                                            isModifying: isModifying,
                                            isSelected: isSelected,
                                            index: index,
                                            carrierId: item.carrierId,
                                            orderToken: item.orderToken,
                                            t: t,
                                            showQuantity: false,
                                            item: item,
                                            orderNumber: item.orderNumber,
                                            handleProductSelection: handleProductSelection,
                                            showPrice: !(settings === null || settings === void 0 ? void 0 : settings.only_add_with_pack),
                                            showSizes: settings === null || settings === void 0 ? void 0 : settings.show_size_name,
                                            settings: settings,
                                            doc: doc
                                        }),
                                        isDisplayCustomerSurvey && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grow/* default */.Z, {
                                            in: isExpanded,
                                            mountOnEnter: true,
                                            unmountOnExit: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Order_ProductSatisfactionForm, {
                                                t: t,
                                                doc: customer_survey,
                                                orderId: item.orderNumber,
                                                saveAnswers: saveAnswers,
                                                sku: item.variant.sku,
                                                answersSaved: (ref = totalAnswers.find(function(answer) {
                                                    return answer.orderId === item.orderNumber;
                                                })) === null || ref === void 0 ? void 0 : (ref69 = ref.reviews) === null || ref69 === void 0 ? void 0 : ref69.find(function(answer) {
                                                    return answer.sku === item.variant.sku;
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)('orders--current__buy', isBuyingOption === 'true' && classes.buyArea),
                                            children: isBuyingOption === 'true' && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    variant: 'contained',
                                                    color: 'secondary',
                                                    size: 'small',
                                                    onClick: function() {
                                                        return trackEvent({
                                                            category: 'Buying option click',
                                                            action: "User clicked on the buying option button"
                                                        });
                                                    },
                                                    children: t('texts:account:buy')
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes.separatorProduct
                                        })
                                    ]
                                }, index));
                            }),
                            isModifying && isDisplayCustomerSurvey && /*#__PURE__*/ (0,jsx_runtime.jsx)(Order_GlobalSatisfactionForm, {
                                doc: customer_survey,
                                t: t,
                                setGlobalReview: handleGlobalReview,
                                handleMessage: handleMessage
                            }),
                            isModifying && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: !isFunnel ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.validModif,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturnVoucherButton_ReturnVoucherButton, {
                                        downloadLink: downloadLink,
                                        t: t,
                                        prismicData: prismicAccount,
                                        isDisabled: isDownloadLoading || !productSelection,
                                        isDownloadLoading: isDownloadLoading,
                                        text: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: doc === null || doc === void 0 ? void 0 : (ref6 = doc.data) === null || ref6 === void 0 ? void 0 : ref6.generate_the_return_slip,
                                            defaultText: t('texts:subscription_order:generate_the_return_slip')
                                        }),
                                        onValidate: function() {
                                            return sendProductsToReturn();
                                        }
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.validModif,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturnVoucherButton_ReturnVoucherButton, {
                                            downloadLink: downloadLink,
                                            t: t,
                                            prismicData: prismicAccount,
                                            isDisabled: isDownloadLoading,
                                            isDownloadLoading: isDownloadLoading,
                                            text: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: doc === null || doc === void 0 ? void 0 : (ref7 = doc.data) === null || ref7 === void 0 ? void 0 : ref7.continue,
                                                defaultText: t('texts:subscription_order:continue')
                                            }),
                                            onValidate: function() {
                                                return funnelSaveProductsToReturn();
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: 'body2',
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: doc === null || doc === void 0 ? void 0 : (ref8 = doc.data) === null || ref8 === void 0 ? void 0 : ref8.bottom_sentence,
                                                defaultText: t('texts:subscription_order:bottom_sentence')
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    (parameters === null || parameters === void 0 ? void 0 : (ref9 = parameters.items) === null || ref9 === void 0 ? void 0 : ref9.in_store) && !isFunnel && filteredOrdersAndProductsByWarehouse.map(function(warehouse, warehouseIndex) {
                        // Check if there are non-returned product inside the orders
                        var hasProducts = false;
                        warehouse.orders.map(function(order) {
                            if (order.products.length > 0) {
                                hasProducts = true;
                            }
                        });
                        if (hasProducts) {
                            var ref73, ref70, ref71;
                            var i = 0;
                            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'h5',
                                        children: warehouse.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'body2',
                                        children: warehouse.address + ' ' + warehouse.city
                                    }),
                                    warehouse.orders.map(function(order, orderIndex) {
                                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: order.products.map(function(item, productIndex) {
                                                var ref, ref72;
                                                i++;
                                                var isExpanded = false;
                                                var isSelected = productToReturn.find(function(product) {
                                                    return product.id === i && product.warehouseId === warehouse.id;
                                                }) ? true : false;
                                                if (isSelected) {
                                                    isExpanded = productToReturn.find(function(product) {
                                                        return product.id === i;
                                                    }).expand;
                                                }
                                                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductRow/* default */.Z, {
                                                            isModifying: isModifying,
                                                            isSelected: isSelected,
                                                            index: i,
                                                            t: t,
                                                            orderToken: order.tokenValue,
                                                            carrierId: order.carrierId,
                                                            puid: item.puid,
                                                            item: item,
                                                            showQuantity: false,
                                                            warehouseId: warehouse.id,
                                                            orderNumber: order === null || order === void 0 ? void 0 : order.number,
                                                            handleProductSelection: handleProductSelection,
                                                            showPrice: !(settings === null || settings === void 0 ? void 0 : settings.only_add_with_pack),
                                                            showSizes: settings === null || settings === void 0 ? void 0 : settings.show_size_name,
                                                            settings: settings,
                                                            doc: doc
                                                        }),
                                                        isDisplayCustomerSurvey && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grow/* default */.Z, {
                                                            in: isExpanded,
                                                            mountOnEnter: true,
                                                            unmountOnExit: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Order_ProductSatisfactionForm, {
                                                                t: t,
                                                                doc: customer_survey,
                                                                orderId: item.orderNumber,
                                                                saveAnswers: saveAnswers,
                                                                sku: item.variant.sku,
                                                                answersSaved: (ref = totalAnswers.find(function(answer) {
                                                                    return answer.orderId === item.orderNumber;
                                                                })) === null || ref === void 0 ? void 0 : (ref72 = ref.reviews) === null || ref72 === void 0 ? void 0 : ref72.find(function(answer) {
                                                                    return answer.sku === item.variant.sku;
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: classes.separatorProduct
                                                        })
                                                    ]
                                                }, productIndex));
                                            })
                                        }, orderIndex));
                                    }),
                                    isModifying && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: !isFunnel ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes.validModifInStore,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturnVoucherButton_ReturnVoucherButton, {
                                                downloadLink: downloadLink,
                                                t: t,
                                                prismicData: prismicAccount,
                                                isDisabled: isDownloadLoading || !productSelection || typeof productToReturn.find(function(ptr) {
                                                    return ptr.warehouseId === warehouse.id;
                                                }) === 'undefined',
                                                isDownloadLoading: isDownloadLoading,
                                                text: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: doc === null || doc === void 0 ? void 0 : (ref73 = doc.data) === null || ref73 === void 0 ? void 0 : ref73.generate_the_return_slip,
                                                    defaultText: t('texts:subscription_order:generate_the_return_slip')
                                                }),
                                                onValidate: function() {
                                                    return sendProductsToReturn(warehouse.id);
                                                }
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classes.validModifInStore,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturnVoucherButton_ReturnVoucherButton, {
                                                    downloadLink: downloadLink,
                                                    t: t,
                                                    prismicData: prismicAccount,
                                                    isDisabled: isDownloadLoading,
                                                    isDownloadLoading: isDownloadLoading,
                                                    text: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        asText: true,
                                                        data: doc === null || doc === void 0 ? void 0 : (ref70 = doc.data) === null || ref70 === void 0 ? void 0 : ref70.continue,
                                                        defaultText: t('texts:subscription_order:continue')
                                                    }),
                                                    onValidate: function() {
                                                        return funnelSaveProductsToReturn();
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'body2',
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        asText: true,
                                                        data: doc === null || doc === void 0 ? void 0 : (ref71 = doc.data) === null || ref71 === void 0 ? void 0 : ref71.bottom_sentence,
                                                        defaultText: t('texts:subscription_order:bottom_sentence')
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }, warehouseIndex));
                        }
                    }),
                    isModifying && (parameters === null || parameters === void 0 ? void 0 : (ref10 = parameters.items) === null || ref10 === void 0 ? void 0 : ref10.in_store) && !isFunnel && isDisplayCustomerSurvey && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.validModifInStore,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Order_GlobalSatisfactionForm, {
                            doc: customer_survey,
                            t: t,
                            setGlobalReview: handleGlobalReview,
                            handleMessage: handleMessage
                        })
                    })
                ]
            }),
            parameters.items.in_store && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.inStoreRow,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InStoreReturnBtn, {})
            }),
            returnedProducts.length > 0 && !isFunnel && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)('orders--returned', classes.orderCard),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: 'h4',
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            data: doc === null || doc === void 0 ? void 0 : (ref11 = doc.data) === null || ref11 === void 0 ? void 0 : ref11.returned_product_title,
                            defaultText: t('texts:subscription_order:returned_product_title'),
                            asText: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: 'body2',
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            data: doc === null || doc === void 0 ? void 0 : (ref12 = doc.data) === null || ref12 === void 0 ? void 0 : ref12.returned_product_desc,
                            defaultText: t('texts:subscription_order:returned_product_desc'),
                            asText: true
                        })
                    }),
                    returnedProducts.map(function(item, index) {
                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductRow/* default */.Z, {
                                    isReturned: true,
                                    isModifying: false,
                                    isSelected: false,
                                    index: index,
                                    t: t,
                                    showQuantity: false,
                                    item: item.product,
                                    unit: item.unit,
                                    showPrice: true,
                                    handleProductSelection: handleProductSelection,
                                    showSizes: settings === null || settings === void 0 ? void 0 : settings.show_size_name,
                                    settings: settings,
                                    doc: doc
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.separatorProduct
                                })
                            ]
                        }, index));
                    })
                ]
            }),
            boughtProducts.length > 0 && !isFunnel && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)('orders--returned', classes.orderCard),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: 'h4',
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            data: doc === null || doc === void 0 ? void 0 : (ref13 = doc.data) === null || ref13 === void 0 ? void 0 : ref13.bought_product_title,
                            defaultText: t('texts:subscription_order:bought_product_title'),
                            asText: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: 'body2',
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            data: doc === null || doc === void 0 ? void 0 : (ref14 = doc.data) === null || ref14 === void 0 ? void 0 : ref14.bought_product_desc,
                            defaultText: t('texts:subscription_order:bought_product_desc'),
                            asText: true
                        })
                    }),
                    boughtProducts.map(function(item, index) {
                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductRow/* default */.Z, {
                                    isReturned: true,
                                    isModifying: false,
                                    isSelected: false,
                                    index: index,
                                    t: t,
                                    isBought: true,
                                    item: item.product,
                                    showPrice: true,
                                    unit: item.unit,
                                    handleProductSelection: handleProductSelection,
                                    showSizes: settings === null || settings === void 0 ? void 0 : settings.show_size_name,
                                    settings: settings,
                                    doc: doc
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.separatorProduct
                                })
                            ]
                        }, index));
                    })
                ]
            }),
            filteredOrdersCancelled1.length > 0 && !isFunnel && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)('orders--cancelled', classes.orderCard),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: 'h4',
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: doc === null || doc === void 0 ? void 0 : (ref15 = doc.data) === null || ref15 === void 0 ? void 0 : ref15.canceled_order_title,
                            defaultText: t('texts:subscription_order:canceled_order_title')
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: 'body2',
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: doc === null || doc === void 0 ? void 0 : (ref16 = doc.data) === null || ref16 === void 0 ? void 0 : ref16.canceled_order_desc,
                            defaultText: t('texts:subscription_order:canceled_order_desc')
                        })
                    }),
                    filteredOrdersCancelled1.map(function(item, index) {
                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductRow/* default */.Z, {
                                    isReturned: true,
                                    isModifying: false,
                                    isSelected: false,
                                    index: index,
                                    t: t,
                                    item: item,
                                    handleProductSelection: handleProductSelection,
                                    showSizes: settings === null || settings === void 0 ? void 0 : settings.show_size_name,
                                    settings: settings,
                                    doc: doc
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.separatorProduct
                                })
                            ]
                        }, index));
                    })
                ]
            }),
            filteredOrdersRefunded1.length > 0 && !isFunnel && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)('order--refunded', classes.orderCard),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: 'h4',
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: doc === null || doc === void 0 ? void 0 : (ref17 = doc.data) === null || ref17 === void 0 ? void 0 : ref17.refunded_order_title,
                            defaultText: t('texts:subscription_order:refunded_order_title')
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: 'body2',
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: doc === null || doc === void 0 ? void 0 : (ref18 = doc.data) === null || ref18 === void 0 ? void 0 : ref18.canceled_order_desc,
                            defaultText: t('texts:subscription_order:canceled_order_desc')
                        })
                    }),
                    filteredOrdersRefunded1.map(function(item, index) {
                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductRow/* default */.Z, {
                                    isReturned: true,
                                    isModifying: false,
                                    isSelected: false,
                                    index: index,
                                    t: t,
                                    item: item,
                                    handleProductSelection: handleProductSelection,
                                    showSizes: settings === null || settings === void 0 ? void 0 : settings.show_size_name,
                                    settings: settings,
                                    doc: doc
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.separatorProduct
                                })
                            ]
                        }, index));
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Subscription_SubscriptionList = ((0,es/* connect */.$j)(SubscriptionList_mapStateToProps, SubscriptionList_mapDispatchToProps)(SubscriptionList));

;// CONCATENATED MODULE: ./components/TakeBack/TakeBackList.tsx








function TakeBackList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var TakeBackList_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: {
            marginBottom: theme.spacing(3)
        },
        takeBackListTitle: {
            marginBottom: theme.spacing(2)
        },
        takeBackListHeader: {
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center'
        },
        takeBackItemTitle: {
            paddingLeft: theme.spacing(1)
        },
        circle: {
            width: 16,
            height: 16,
            borderRadius: '50%',
            backgroundColor: theme.palette.primary.main
        },
        productCard: TakeBackList_defineProperty({
            background: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius,
            minHeight: 60,
            padding: theme.spacing(1),
            display: 'flex',
            justifyContent: '',
            alignItems: 'center',
            marginBottom: theme.spacing(2)
        }, theme.breakpoints.down('md'), {
            width: '100%'
        }),
        takeBackItem: {
            borderLeft: "1px solid currentColor",
            paddingLeft: theme.spacing(2),
            marginLeft: theme.spacing(1),
            paddingBottom: theme.spacing(3)
        },
        takeBackItemLast: {
            borderLeft: 0
        },
        imgProduct: {
            width: 50,
            height: 50,
            objectFit: 'contain',
            display: 'block'
        },
        imgContainer: TakeBackList_defineProperty({
            width: 50,
            marginLeft: theme.spacing(2)
        }, theme.breakpoints.down('md'), {
            marginLeft: theme.spacing(0)
        }),
        productName: TakeBackList_defineProperty({
            marginLeft: theme.spacing(2)
        }, theme.breakpoints.down('md'), {
            marginLeft: theme.spacing(1)
        }),
        productPrice: TakeBackList_defineProperty({
            marginLeft: theme.spacing(2)
        }, theme.breakpoints.down('md'), {
            marginLeft: theme.spacing(1)
        }),
        productStatus: TakeBackList_defineProperty({
            marginLeft: theme.spacing(2)
        }, theme.breakpoints.down('md'), {
            marginLeft: theme.spacing(1)
        })
    });
});
var TakeBackList = function(param) {
    var t = param.t, takeback = param.takeback, userTakeBackProducts = param.userTakeBackProducts, settings = param.settings;
    var ref3, ref1;
    var classes = TakeBackList_useStyles();
    var ref2 = (0,useTakeback/* useTakeback */.C)(), productCheckState = ref2.productCheckState, productCheckStatus = ref2.productCheckStatus;
    var states = productCheckState(takeback === null || takeback === void 0 ? void 0 : takeback.data);
    var status = productCheckStatus(takeback === null || takeback === void 0 ? void 0 : takeback.data);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: 'h5',
                component: 'h2',
                className: classes.takeBackListTitle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                    asText: true,
                    data: takeback === null || takeback === void 0 ? void 0 : (ref3 = takeback.data) === null || ref3 === void 0 ? void 0 : ref3.take_back_list_title,
                    defaultText: t('texts:account:take_back_list_title')
                })
            }),
            (userTakeBackProducts === null || userTakeBackProducts === void 0 ? void 0 : (ref1 = userTakeBackProducts.response) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && (userTakeBackProducts === null || userTakeBackProducts === void 0 ? void 0 : userTakeBackProducts.response.map(function(takeBackProducts, index1) {
                var ref7;
                var takeBackDate = dayjs_min_default()(takeBackProducts.date).format('L');
                var lastTakeBackProducts = index1 + 1 === (userTakeBackProducts === null || userTakeBackProducts === void 0 ? void 0 : userTakeBackProducts.response.length);
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.takeBackListHeader,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.circle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    variant: 'body1',
                                    color: 'primary',
                                    className: classes.takeBackItemTitle,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: takeback === null || takeback === void 0 ? void 0 : (ref7 = takeback.data) === null || ref7 === void 0 ? void 0 : ref7.command,
                                            defaultText: t('texts:takeBack:command')
                                        }),
                                        takeBackProducts.id
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)(classes.takeBackItem, lastTakeBackProducts && classes.takeBackItemLast),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: 'body2',
                                    color: 'textSecondary',
                                    children: takeBackDate
                                }),
                                takeBackProducts.products.map(function(item, index) {
                                    var ref, ref4, ref5, ref6;
                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classes.productCard,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.imgContainer,
                                                    children: item.image === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: (settings === null || settings === void 0 ? void 0 : (ref = settings.default_image) === null || ref === void 0 ? void 0 : ref.url) ? settings === null || settings === void 0 ? void 0 : (ref4 = settings.default_image) === null || ref4 === void 0 ? void 0 : ref4.url : '/images/placeholder.jpg',
                                                        alt: '',
                                                        className: classes.imgProduct,
                                                        width: 50,
                                                        height: 50
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: item.image,
                                                        alt: '',
                                                        className: classes.imgProduct,
                                                        width: 50,
                                                        height: 50
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: classes.productName,
                                                            children: [
                                                                item.name,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                    children: "\xa0-\xa0"
                                                                }),
                                                                item.size,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                    children: "\xa0-\xa0"
                                                                }),
                                                                states["".concat(item.quality)].title
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: classes.productPrice,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                    asText: true,
                                                                    data: takeback === null || takeback === void 0 ? void 0 : (ref5 = takeback.data) === null || ref5 === void 0 ? void 0 : ref5.take_back_estimated_price,
                                                                    defaultText: t('texts:takeBack:take_back_estimated_price')
                                                                }),
                                                                "\xa0",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                    amount: item.price
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: classes.productStatus,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                    asText: true,
                                                                    data: takeback === null || takeback === void 0 ? void 0 : (ref6 = takeback.data) === null || ref6 === void 0 ? void 0 : ref6.status_label,
                                                                    defaultText: t('texts:takeBack:status_label')
                                                                }),
                                                                "\xa0",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                    children: status["".concat(item.status)]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, index));
                                })
                            ]
                        })
                    ]
                }, index1));
            }))
        ]
    }));
};
/* harmony default export */ var TakeBack_TakeBackList = (TakeBackList);

// EXTERNAL MODULE: ./node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(30172);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/pagination/pagination.js
var pagination = __webpack_require__(52997);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/scrollbar/scrollbar.js
var scrollbar = __webpack_require__(65014);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/a11y/a11y.js
var a11y = __webpack_require__(10787);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper.js + 8 modules
var swiper = __webpack_require__(84081);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(24002);
;// CONCATENATED MODULE: ./components/SwiperModal/SwiperModal.tsx






function SwiperModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SwiperModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SwiperModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
core_class/* default.use */.Z.use([
    pagination/* default */.Z,
    scrollbar/* default */.Z,
    a11y/* default */.Z
]);
var SwiperModal_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        slide: SwiperModal_defineProperty({
            width: 350,
            minHeight: 400,
            padding: theme.spacing(4, 2)
        }, theme.breakpoints.down('md'), {
            width: 'auto',
            minHeight: 350
        }),
        slideContent: SwiperModal_defineProperty({
            minHeight: 350
        }, theme.breakpoints.down('md'), {
            minHeight: 280
        }),
        imageSlide: SwiperModal_defineProperty({
            width: 'auto',
            height: 180
        }, theme.breakpoints.down('md'), {
            height: 80
        }),
        imageSlideContainer: {
            textAlign: 'center'
        },
        textContainer: {
            display: 'flex',
            justifyContent: 'flex-start'
        },
        numberSlide: {
            border: '1px solid black',
            borderRadius: 15,
            textAlign: 'center',
            marginRight: theme.spacing(0.5),
            width: 20
        },
        slideTitle: SwiperModal_defineProperty({}, theme.breakpoints.down('md'), {
        })
    });
});
var SwiperModal = function(param) {
    var open = param.open, handleCloseModal = param.handleCloseModal, slides = param.slides, title = param.title, t = param.t;
    var classes = SwiperModal_useStyles();
    var theme = (0,useTheme/* default */.Z)();
    var swiperParams = {
        pagination: {
            clickable: true
        },
        autoHeight: true,
        spaceBetween: theme.spacing(1),
        slidesPerView: 1,
        slidesPerGroup: 1
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
            open: open,
            onClose: handleCloseModal,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.slide,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: 'h3',
                        color: 'primary',
                        gutterBottom: true,
                        align: 'center',
                        className: classes.slideTitle,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, SwiperModal_objectSpread({}, swiperParams, {
                        children: slides ? slides.map(function(slide, index) {
                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.slideContent,
                                    children: [
                                        slide.imageslide.url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes.imageSlideContainer,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: slide.imageslide.url,
                                                className: classes.imageSlide
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classes.textContainer,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: 'body2',
                                                        className: classes.numberSlide,
                                                        children: index + 1
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        (0,CMSText/* isPrismicText */.LT)(slide.titleslide) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: 'body2',
                                                            gutterBottom: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: (0,CMSText/* prismicText */.yz)(slide === null || slide === void 0 ? void 0 : slide.titleslide)
                                                            })
                                                        }),
                                                        (0,CMSText/* isPrismicText */.LT)(slide.paragraph_slide) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: 'body2',
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                data: slide === null || slide === void 0 ? void 0 : slide.paragraph_slide
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, index));
                        }) : [
                            0,
                            1,
                            2
                        ].map(function(key, index) {
                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.slideContent,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes.imageSlideContainer,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: '/images/placeholder.jpg',
                                                className: classes.imageSlide
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classes.textContainer,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: 'body2',
                                                        className: classes.numberSlide,
                                                        children: index + 1
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: 'body2',
                                                            gutterBottom: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: t('texts:general:add_a_text')
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: 'body2',
                                                            children: t('texts:general:add_a_description')
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, index));
                        })
                    }))
                ]
            })
        })
    }));
};
/* harmony default export */ var SwiperModal_SwiperModal = (SwiperModal);

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./redux/actions/order.ts
var order = __webpack_require__(46194);
// EXTERNAL MODULE: ./redux/actions/addressUser.ts + 1 modules
var addressUser = __webpack_require__(78101);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Warning.js
var Warning = __webpack_require__(21727);
// EXTERNAL MODULE: ./redux/actions/contract.ts + 1 modules
var contract = __webpack_require__(97506);
// EXTERNAL MODULE: ./redux/actions/takeBack.ts + 1 modules
var takeBack = __webpack_require__(42738);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(14903);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/KeyboardBackspace.js
var KeyboardBackspace = __webpack_require__(64379);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js + 2 modules
var Tooltip = __webpack_require__(49161);
// EXTERNAL MODULE: ./components/ImgKitHandler/ImgKitHandler.tsx
var ImgKitHandler = __webpack_require__(26137);
// EXTERNAL MODULE: ./components/Global/DownloadLink.tsx
var DownloadLink = __webpack_require__(84732);
// EXTERNAL MODULE: ./components/Order/ReturningReasonForm.tsx
var ReturningReasonForm = __webpack_require__(89723);
;// CONCATENATED MODULE: ./components/TakeBack/TakeBackOrderItem.tsx


















function TakeBackOrderItem_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function TakeBackOrderItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function TakeBackOrderItem_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                TakeBackOrderItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                TakeBackOrderItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function TakeBackOrderItem_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || TakeBackOrderItem_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function TakeBackOrderItem_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return TakeBackOrderItem_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return TakeBackOrderItem_arrayLikeToArray(o, minLen);
}
var MainTooltip = (0,withStyles/* default */.Z)(function(theme) {
    return {
        tooltip: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText,
            fontSize: 12,
            textAlign: 'center',
            padding: theme.spacing(1),
            width: '100%'
        },
        arrow: {
            color: theme.palette.secondary.main
        }
    };
})(Tooltip/* default */.ZP);
var TakeBackOrderItem_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: {},
        hide: {
            opacity: 0,
            transition: theme.transitions.create('opacity')
        },
        show: {
            opacity: 1,
            transition: theme.transitions.create('opacity')
        },
        takeBackListTitle: {
            marginBottom: theme.spacing(2)
        },
        takeBackListHeader: {
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center'
        },
        takeBackItemTitle: {
            paddingLeft: theme.spacing(1)
        },
        circle: {
            width: 16,
            height: 16,
            borderRadius: '50%',
            backgroundColor: theme.palette.primary.main
        },
        productCard: {
            display: 'flex',
            overflow: 'hidden',
            alignItems: 'center',
            justifyContent: 'space-between',
            minHeight: 60,
            background: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(1),
            marginBottom: theme.spacing(2)
        },
        productCardCheckbox: {},
        productCardImg: TakeBackOrderItem_defineProperty({
            width: 50,
            height: 50,
            position: 'relative',
            marginRight: theme.spacing(2)
        }, theme.breakpoints.down('md'), {
            marginRight: theme.spacing(1)
        }),
        productCardContent: {
            flex: 1
        },
        takeBackItem: {
            borderLeft: "1px solid currentColor",
            paddingLeft: theme.spacing(2),
            marginLeft: theme.spacing(1),
            paddingBottom: theme.spacing(3)
        },
        takeBackItemActive: {
            borderColor: 'transparent',
            paddingLeft: 0,
            marginLeft: theme.spacing(1)
        },
        takeBackItemLast: {
            borderLeft: 0
        },
        imgProduct: {
            width: 50,
            height: 50,
            objectFit: 'contain',
            display: 'block'
        },
        productName: {},
        productStatus: TakeBackOrderItem_defineProperty({
            marginLeft: theme.spacing(2)
        }, theme.breakpoints.down('md'), {
            marginLeft: theme.spacing(1)
        }),
        takeBackOrder: {
            display: 'flex',
            justifyContent: 'space-between',
            gap: theme.spacing(2),
            width: '100%'
        },
        orderDetailsRow: {
            textAlign: 'right'
        },
        orderDetailsBtn: {},
        orderDetailsRowActions: {
            padding: theme.spacing(1, 0, 2)
        },
        simpleButton: {
            padding: 0,
            textTransform: 'inherit',
            color: theme.extraColors.greyText,
            '&:hover, &:focus': {
                background: 'none'
            },
            '& .MuiSvgIcon-root': {
                fontSize: '.8rem'
            }
        },
        simpleButtonPrimary: {
            color: theme.palette.primary.main
        },
        simpleButtonDanger: {
            color: theme.palette.error.main
        },
        currentOrderList: {
            padding: theme.spacing(3),
            background: theme.palette.common.white
        },
        loaderContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '20vh'
        },
        returnCtaContainer: {
            minHeight: '2rem'
        },
        downloadInvoiceButton: {
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: theme.spacing(1.5)
        }
    });
});
var TakeBackOrderItem = function(param1) {
    var takeback = param1.takeback, main = param1.main, account = param1.account, order = param1.order, activeOrder = param1.activeOrder, isModifying = param1.isModifying, isDisabled = param1.isDisabled, isDownloadLoading = param1.isDownloadLoading, downloadLink = param1.downloadLink, productSelection = param1.productSelection, productToReturn = param1.productToReturn, productReturningReasons = param1.productReturningReasons, isOrderReturnable = param1.isOrderReturnable, orderDate = param1.orderDate, handleProductSelection = param1.handleProductSelection, handleReturningReasonChange = param1.handleReturningReasonChange, handleReturningReasonCommentChange = param1.handleReturningReasonCommentChange, handleActiveCurrentOrder = param1.handleActiveCurrentOrder, lastOrder = param1.lastOrder, warehouseId = param1.warehouseId, handleDownloadInvoice = param1.handleDownloadInvoice, invoiceDownloadError = param1.invoiceDownloadError, tooltipWithdrawalText = param1.tooltipWithdrawalText, setIsDownloadLoading = param1.setIsDownloadLoading, setDownloadLink = param1.setDownloadLink, user = param1.user, postProductToReturn = param1.postProductToReturn, index = param1.index, settings = param1.settings;
    var ref7, ref1, ref2, ref3, ref4;
    var classes = TakeBackOrderItem_useStyles();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var productCheckState = (0,useTakeback/* useTakeback */.C)().productCheckState;
    var states = productCheckState(takeback === null || takeback === void 0 ? void 0 : takeback.data);
    var sendProductsToReturn = function() {
        var _ref = TakeBackOrderItem_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, productData, products, data, ref5, ref6;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        setIsDownloadLoading(true);
                        productData = [];
                        productToReturn.map(function(product) {
                            var returningReason = productReturningReasons[product.id] || {};
                            productData.push({
                                lizeeSKU: product.Sku,
                                quantity: product.quantity,
                                orderToken: product.orderToken,
                                returningRaisonId: returningReason.returningRaisonId,
                                returningComment: returningReason.returningComment
                            });
                        });
                        products = {
                            products: productData,
                            gender: user === null || user === void 0 ? void 0 : (ref = user.user) === null || ref === void 0 ? void 0 : ref.gender,
                            warehouseId: productToReturn[0].warehouseId,
                            carrierId: productToReturn[0].carrierId,
                            omsOrderId: productToReturn[0].orderNumber,
                            rightOfWithdrawal: true
                        };
                        _ctx.next = 7;
                        return postProductToReturn(products);
                    case 7:
                        data = _ctx.sent;
                        if (!(data.type === 'POST_PRODUCT_TO_RETURN_SUCCESS')) {
                            _ctx.next = 20;
                            break;
                        }
                        ;
                        if (!((ref5 = data === null || data === void 0 ? void 0 : data.response[0]) === null || ref5 === void 0 ? void 0 : ref5.pdfUrl)) {
                            _ctx.next = 18;
                            break;
                        }
                        ;
                        _ctx.next = 14;
                        return setDownloadLink((ref6 = data === null || data === void 0 ? void 0 : data.response[0]) === null || ref6 === void 0 ? void 0 : ref6.pdfUrl);
                    case 14:
                        _ctx.next = 16;
                        return (0,utils/* downloadURI */.l_)(data.response[0].pdfUrl, "".concat("equitry-subscription", "_").concat(data.response[0].trackingCode));
                    case 16:
                        _ctx.next = 18;
                        return setIsDownloadLoading(false);
                    case 18:
                        _ctx.next = 21;
                        break;
                    case 20:
                        {
                            setIsDownloadLoading(false);
                        }
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function sendProductsToReturn() {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.takeBackListHeader,
                children: [
                    !activeOrder && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.circle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)(classes.takeBackOrder),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: 'body1',
                                color: 'primary',
                                className: classes.takeBackItemTitle,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: takeback === null || takeback === void 0 ? void 0 : (ref7 = takeback.data) === null || ref7 === void 0 ? void 0 : ref7.take_back_command,
                                        defaultText: t('texts:takeBack:take_back_command')
                                    }),
                                    "\xa0",
                                    order.number
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: 'body1',
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                        amount: order.totals.total
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)(classes.takeBackItem, lastOrder && classes.takeBackItemLast, activeOrder && classes.takeBackItemActive),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: 'body2',
                        color: 'textSecondary',
                        children: orderDate
                    }),
                    order.items.map(function(item, itemIndex) {
                        var isReturnable = isOrderReturnable.find(function(isReturnableInfos) {
                            return isReturnableInfos.orderId === order.number;
                        });
                        // Group by quality if quantity selector is enabled
                        if (settings === null || settings === void 0 ? void 0 : settings.second_hand_has_quantity_selector) {
                            var ref9;
                            var groupedByQuality = (ref9 = item.units) === null || ref9 === void 0 ? void 0 : ref9.reduce(function(acc, unit) {
                                var quality = unit === null || unit === void 0 ? void 0 : unit.productCondition;
                                if (!acc[quality]) {
                                    acc[quality] = {
                                        units: [],
                                        totalPrice: 0
                                    };
                                }
                                acc[quality].units.push(unit);
                                acc[quality].totalPrice += (unit === null || unit === void 0 ? void 0 : unit.productPrice) || item.total / item.units.length;
                                return acc;
                            }, {});
                            return Object.entries(groupedByQuality || {}).map(function(param, groupIndex) {
                                var _param = _slicedToArray(param, 2), quality = _param[0], groupData = _param[1];
                                var ref, ref8;
                                var group = groupData;
                                var groupId = "".concat(item.id, "-").concat(quality);
                                var isSelected = !!productToReturn.find(function(product) {
                                    return product.id === groupId;
                                });
                                var productReturningReason = productReturningReasons[groupId] || {};
                                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classes.productCard,
                                            children: [
                                                activeOrder && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (0,clsx_m/* default */.Z)(classes.productCardCheckbox, 'checkbox'),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                                                        in: isModifying,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                            checked: isSelected,
                                                            name: item.name,
                                                            "data-testid": "order__checkbox--".concat(itemIndex, "-").concat(groupIndex),
                                                            disableRipple: true,
                                                            size: "small",
                                                            disabled: !(isReturnable === null || isReturnable === void 0 ? void 0 : isReturnable.returnable),
                                                            onChange: function() {
                                                                return handleProductSelection(item.product.variants[0].sku, groupId, group.units.length, order === null || order === void 0 ? void 0 : order.tokenValue, item, order.number, warehouseId, order.shipments[0].method.carrierId);
                                                            }
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.productCardImg,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgKitHandler/* default */.Z, {
                                                        classes: classes.imgProduct,
                                                        imagePaths: item.product.images[0],
                                                        settings: {
                                                            width: 50,
                                                            ar: '1-1',
                                                            defaultImage: main === null || main === void 0 ? void 0 : (ref = main.data) === null || ref === void 0 ? void 0 : ref.default_image
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: classes.productCardContent,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: classes.productName,
                                                            children: [
                                                                "x",
                                                                group.units.length,
                                                                "\xa0",
                                                                item.product.name,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                    children: "\xa0-\xa0"
                                                                }),
                                                                item.product.variants[0].size
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: classes.productName,
                                                            children: (ref8 = states["".concat(quality)]) === null || ref8 === void 0 ? void 0 : ref8.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: classes.productName,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                amount: group.totalPrice
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        isSelected && isModifying && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturningReasonForm/* default */.Z, {
                                            productId: groupId,
                                            returningRaisonId: productReturningReason.returningRaisonId || null,
                                            returningComment: productReturningReason.returningComment || '',
                                            onReturningRaisonChange: handleReturningReasonChange,
                                            onReturningCommentChange: handleReturningReasonCommentChange,
                                            account: account,
                                            t: t
                                        })
                                    ]
                                }, "".concat(groupId, "-").concat(groupIndex)));
                            });
                        }
                        // Default behavior: display each unit individually
                        return item.units.map(function(unit, unitIndex) {
                            var ref, ref11;
                            var isSelected = !!productToReturn.find(function(product) {
                                return product.id === item.id;
                            });
                            var productReturningReason = productReturningReasons[item.id] || {};
                            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.productCard,
                                        children: [
                                            activeOrder && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (0,clsx_m/* default */.Z)(classes.productCardCheckbox, 'checkbox'),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                                                    in: isModifying,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                        checked: isSelected,
                                                        name: item.name,
                                                        "data-testid": "order__checkbox--".concat(itemIndex),
                                                        disableRipple: true,
                                                        size: "small",
                                                        disabled: !(isReturnable === null || isReturnable === void 0 ? void 0 : isReturnable.returnable),
                                                        onChange: function() {
                                                            return handleProductSelection(item.product.variants[0].sku, item.id, 1, order === null || order === void 0 ? void 0 : order.tokenValue, item, order.number, warehouseId, order.shipments[0].method.carrierId);
                                                        }
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.productCardImg,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgKitHandler/* default */.Z, {
                                                    classes: classes.imgProduct,
                                                    imagePaths: item.product.images[0],
                                                    settings: {
                                                        width: 50,
                                                        ar: '1-1',
                                                        defaultImage: main === null || main === void 0 ? void 0 : (ref = main.data) === null || ref === void 0 ? void 0 : ref.default_image
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classes.productCardContent,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: classes.productName,
                                                        children: [
                                                            item.product.name,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: "\xa0-\xa0"
                                                            }),
                                                            item.product.variants[0].size
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: classes.productName,
                                                        children: (ref11 = states["".concat(unit.productCondition)]) === null || ref11 === void 0 ? void 0 : ref11.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: classes.productName,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                            amount: item.total
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    isSelected && isModifying && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturningReasonForm/* default */.Z, {
                                        productId: item.id,
                                        returningRaisonId: productReturningReason.returningRaisonId || null,
                                        returningComment: productReturningReason.returningComment || '',
                                        onReturningRaisonChange: handleReturningReasonChange,
                                        onReturningCommentChange: handleReturningReasonCommentChange,
                                        account: account,
                                        t: t
                                    })
                                ]
                            }, "".concat(unit.puid, "-").concat(unitIndex)));
                        });
                    }),
                    !!(order === null || order === void 0 ? void 0 : (ref1 = order.invoice) === null || ref1 === void 0 ? void 0 : ref1.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.downloadInvoiceButton,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadInvoiceButton/* default */.Z, {
                            accountRes: account,
                            orderToken: order.tokenValue,
                            t: t,
                            handleDownloadInvoice: handleDownloadInvoice,
                            invoiceDownloadError: invoiceDownloadError,
                            isSub: constants/* isSubscription */.Nn
                        })
                    }),
                    activeOrder && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        textAlign: 'center',
                        className: classes.returnCtaContainer,
                        children: productSelection && downloadLink === '' ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                            "data-testid": 'downloadBtn',
                            variant: "contained",
                            color: "primary",
                            disabled: isDownloadLoading || !productSelection,
                            onClick: function() {
                                return sendProductsToReturn();
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: isDownloadLoading ? classes.hide : classes.show,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: account === null || account === void 0 ? void 0 : (ref2 = account.data) === null || ref2 === void 0 ? void 0 : ref2.order_details_generate,
                                        defaultText: t('texts:account:order_details_generate')
                                    })
                                }),
                                isDownloadLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                            ]
                        }) : downloadLink !== '' && /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadLink/* default */.Z, {
                            downloadLink: downloadLink,
                            data: account === null || account === void 0 ? void 0 : (ref3 = account.data) === null || ref3 === void 0 ? void 0 : ref3.order_details_download,
                            defaultText: t('texts:account:order_details_download')
                        })
                    }),
                    !activeOrder && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.orderDetailsRow,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainTooltip, {
                            placement: 'top',
                            title: !isDisabled ? tooltipWithdrawalText : '',
                            arrow: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    size: "small",
                                    variant: "contained",
                                    color: "secondary",
                                    onClick: function() {
                                        return handleActiveCurrentOrder(index);
                                    },
                                    className: (0,clsx_m/* default */.Z)(classes.orderDetailsBtn, 'btn--order-details'),
                                    disabled: !isDisabled,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: account === null || account === void 0 ? void 0 : (ref4 = account.data) === null || ref4 === void 0 ? void 0 : ref4.order_details_open,
                                        defaultText: t('texts:account:order_details_open')
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var TakeBack_TakeBackOrderItem = (TakeBackOrderItem);

;// CONCATENATED MODULE: ./components/TakeBack/TakeBackOrderList.tsx
/* provided dependency */ var TakeBackOrderList_process = __webpack_require__(34155);












function TakeBackOrderList_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function TakeBackOrderList_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return TakeBackOrderList_arrayLikeToArray(arr);
}
function TakeBackOrderList_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function TakeBackOrderList_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                TakeBackOrderList_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                TakeBackOrderList_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function TakeBackOrderList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TakeBackOrderList_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function TakeBackOrderList_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function TakeBackOrderList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TakeBackOrderList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function TakeBackOrderList_toConsumableArray(arr) {
    return TakeBackOrderList_arrayWithoutHoles(arr) || TakeBackOrderList_iterableToArray(arr) || TakeBackOrderList_unsupportedIterableToArray(arr) || TakeBackOrderList_nonIterableSpread();
}
function TakeBackOrderList_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return TakeBackOrderList_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return TakeBackOrderList_arrayLikeToArray(o, minLen);
}
var TakeBackOrderList_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: {},
        hide: {
            opacity: 0,
            transition: theme.transitions.create('opacity')
        },
        show: {
            opacity: 1,
            transition: theme.transitions.create('opacity')
        },
        takeBackListTitle: {
            marginBottom: theme.spacing(2)
        },
        takeBackListHeader: {
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center'
        },
        takeBackItemTitle: {
            paddingLeft: theme.spacing(1)
        },
        circle: {
            width: 16,
            height: 16,
            borderRadius: '50%',
            backgroundColor: theme.palette.primary.main
        },
        productCard: {
            display: 'flex',
            overflow: 'hidden',
            alignItems: 'center',
            justifyContent: 'space-between',
            minHeight: 60,
            background: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(1),
            marginBottom: theme.spacing(2)
        },
        productCardCheckbox: {},
        productCardImg: TakeBackOrderList_defineProperty({
            width: 50,
            height: 50,
            position: 'relative',
            marginRight: theme.spacing(2)
        }, theme.breakpoints.down('md'), {
            marginRight: theme.spacing(1)
        }),
        productCardContent: {
            flex: 1
        },
        takeBackItem: {
            borderLeft: "1px solid currentColor",
            paddingLeft: theme.spacing(2),
            marginLeft: theme.spacing(1),
            paddingBottom: theme.spacing(3)
        },
        takeBackItemActive: {
            borderColor: 'transparent',
            paddingLeft: 0,
            marginLeft: theme.spacing(1)
        },
        takeBackItemLast: {
            borderLeft: 0
        },
        imgProduct: {
            width: 50,
            height: 50,
            objectFit: 'contain',
            display: 'block'
        },
        productName: {},
        productStatus: TakeBackOrderList_defineProperty({
            marginLeft: theme.spacing(2)
        }, theme.breakpoints.down('md'), {
            marginLeft: theme.spacing(1)
        }),
        takeBackOrder: {
            display: 'flex',
            justifyContent: 'space-between',
            gap: theme.spacing(2),
            width: '100%'
        },
        orderDetailsRow: {
            textAlign: 'right'
        },
        orderDetailsBtn: {},
        orderDetailsRowActions: {
            padding: theme.spacing(1, 0, 2)
        },
        simpleButton: {
            padding: 0,
            textTransform: 'inherit',
            color: theme.extraColors.greyText,
            '&:hover, &:focus': {
                background: 'none'
            },
            '& .MuiSvgIcon-root': {
                fontSize: '.8rem'
            }
        },
        simpleButtonPrimary: {
            color: theme.palette.primary.main
        },
        simpleButtonDanger: {
            color: theme.palette.error.main
        },
        currentOrderList: {
            padding: theme.spacing(3),
            background: theme.palette.common.white
        },
        loaderContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '20vh'
        },
        returnCtaContainer: {
            minHeight: '2rem'
        },
        downloadInvoiceButton: {
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: theme.spacing(1.5)
        }
    });
});
var TakeBackOrderList_mapStateToProps = function(state) {
    return {
        user: state.user
    };
};
var TakeBackOrderList = function(param) {
    var t = param.t, takeback = param.takeback, orders = param.orders, main = param.main, user = param.user, stores = param.stores, postProductToReturn = param.postProductToReturn, account = param.account, getRightOfWithdrawalInfo = param.getRightOfWithdrawalInfo, handleDownloadInvoice = param.handleDownloadInvoice, invoiceDownloadError = param.invoiceDownloadError, savForm = param.savForm, onOpenSavForm = param.onOpenSavForm, settings = param.settings;
    var ref18, ref1, ref2, ref3, ref4, ref5, ref6;
    var classes = TakeBackOrderList_useStyles();
    var ref7 = (0,react.useState)(false), activeOrder = ref7[0], setActiveOrder = ref7[1];
    var ref8 = (0,react.useState)(false), activeOrderLoading = ref8[0], setActiveLoading = ref8[1];
    var ref9 = (0,react.useState)(null), indexOrder = ref9[0], setIndexOrder = ref9[1];
    var ref10 = (0,react.useState)(false), isModifying = ref10[0], setIsModifying = ref10[1];
    var ref11 = (0,react.useState)(false), productSelection = ref11[0], setProductSelection = ref11[1];
    var ref12 = (0,react.useState)([]), productToReturn = ref12[0], setProductToReturn = ref12[1];
    var ref13 = (0,react.useState)(false), isDownloadLoading = ref13[0], setIsDownloadLoading = ref13[1];
    var ref14 = (0,react.useState)(''), downloadLink = ref14[0], setDownloadLink = ref14[1];
    var ref15 = (0,react.useState)({}), productReturningReasons = ref15[0], setProductReturningReasons = ref15[1];
    var warehouseId1 = (stores === null || stores === void 0 ? void 0 : (ref18 = stores.selectedStore) === null || ref18 === void 0 ? void 0 : ref18.warehouseId) ? stores === null || stores === void 0 ? void 0 : (ref1 = stores.selectedStore) === null || ref1 === void 0 ? void 0 : ref1.warehouseId : TakeBackOrderList_process.env.CUSTOM_WAREHOUSE ? TakeBackOrderList_process.env.CUSTOM_WAREHOUSE : null;
    var ref16 = (0,react.useState)([]), isOrderReturnable = ref16[0], setIsOrderReturnable = ref16[1];
    var tooltipWithdrawalText = (0,CMSText/* prismicText */.yz)(takeback === null || takeback === void 0 ? void 0 : (ref2 = takeback.data) === null || ref2 === void 0 ? void 0 : ref2.order_withdrawal_text, t('texts:account:order_take_back_withdrawal_text'));
    var getReturnValues = function() {
        var _ref = TakeBackOrderList_asyncToGenerator(runtime_default().mark(function _callee(idList) {
            var responses;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return Promise.all(idList.map(function(id) {
                            return getRightOfWithdrawalInfo(id).then(function(info) {
                                return {
                                    orderId: id,
                                    orderInfo: info
                                };
                            });
                        }));
                    case 2:
                        responses = _ctx.sent;
                        return _ctx.abrupt("return", responses.map(function(response) {
                            var ref, ref17;
                            return {
                                orderId: response.orderId,
                                returnable: response === null || response === void 0 ? void 0 : (ref = response.orderInfo) === null || ref === void 0 ? void 0 : (ref17 = ref.response) === null || ref17 === void 0 ? void 0 : ref17.map(function(item) {
                                    return item.returnable;
                                }).includes(true)
                            };
                        }));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getReturnValues(idList) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var ordersToCheck = orders.filter(function(order) {
            return dayjs_min_default()().diff(order.checkoutCompletedAt, 'day') <= 45;
        }).map(function(order) {
            return order.number;
        });
        getReturnValues(ordersToCheck).then(function(result) {
            return setIsOrderReturnable(result);
        });
    }, [
        orders
    ]);
    var handleActiveCurrentOrder = function(orderIndex) {
        if (savForm) {
            var ref;
            var orderNumber = ((ref = orders[orderIndex]) === null || ref === void 0 ? void 0 : ref.number) || '';
            onOpenSavForm && onOpenSavForm(orderNumber);
            return;
        }
        setActiveLoading(true);
        setIndexOrder(orderIndex);
        setTimeout(function() {
            setActiveOrder(true);
            setActiveLoading(false);
        }, 800);
    };
    var handleBackToOrders = function() {
        setActiveOrder(false);
        setIndexOrder(null);
        setIsModifying(false);
        setProductSelection(false);
        setProductToReturn([]);
        setDownloadLink('');
        setProductReturningReasons({});
    };
    var cancelReturn = function() {
        // we reset everything
        setIsModifying(false);
        setProductSelection(false);
        setProductToReturn([]);
        setProductReturningReasons({});
    };
    var handleProductSelection = function(Sku, id, quantity, token, item, orderNumber, warehouseId, carrierId) {
        setProductSelection(true);
        var productSelectionArray = TakeBackOrderList_toConsumableArray(productToReturn);
        // we first check if the product selected is already in the array of selected products
        var index = productToReturn.findIndex(function(product) {
            return product.id === id;
        });
        if (index !== -1) {
            // if it is true the we remove the row in the array and we adapt the prices
            productSelectionArray.splice(index, 1);
            // if nothing selected, disable generate button
            setProductSelection(productSelectionArray.length !== 0);
            // Remove returning reasons for this product
            var newReturningReasons = TakeBackOrderList_objectSpread({}, productReturningReasons);
            delete newReturningReasons[id];
            setProductReturningReasons(newReturningReasons);
        } else {
            // if it is false we push a new row in the array of selected products and we adapt the prices
            productSelectionArray.push({
                id: id,
                Sku: Sku,
                expand: true,
                product: item.variant,
                quantity: quantity,
                orderToken: token,
                orderNumber: orderNumber,
                warehouseId: warehouseId,
                carrierId: carrierId
            });
        }
        setProductToReturn(productSelectionArray);
    };
    var handleReturningReasonChange = (0,react.useCallback)(function(productId, returningRaisonId) {
        setProductReturningReasons(function(prev) {
            return TakeBackOrderList_objectSpread({}, prev, TakeBackOrderList_defineProperty({}, productId, TakeBackOrderList_objectSpread({}, prev[productId], {
                returningRaisonId: returningRaisonId
            })));
        });
    }, []);
    var handleReturningReasonCommentChange = (0,react.useCallback)(function(productId, returningComment) {
        setProductReturningReasons(function(prev) {
            return TakeBackOrderList_objectSpread({}, prev, TakeBackOrderList_defineProperty({}, productId, TakeBackOrderList_objectSpread({}, prev[productId], {
                returningComment: returningComment
            })));
        });
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: 'h5',
                component: 'h2',
                className: classes.takeBackListTitle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                    asText: true,
                    data: takeback === null || takeback === void 0 ? void 0 : (ref3 = takeback.data) === null || ref3 === void 0 ? void 0 : ref3.order_list_title,
                    defaultText: t('texts:account:order_list_title')
                })
            }),
            activeOrder && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                spacing: 1,
                className: classes.orderDetailsRowActions,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 3,
                        md: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            size: 'small',
                            className: classes.simpleButton,
                            onClick: function() {
                                return handleBackToOrders();
                            },
                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardBackspace/* default */.Z, {}),
                            disableRipple: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                asText: true,
                                data: account === null || account === void 0 ? void 0 : (ref4 = account.data) === null || ref4 === void 0 ? void 0 : ref4.order_details_close,
                                defaultText: t('texts:account:order_details_close')
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 9,
                        md: 6,
                        alignItems: 'center',
                        alignContent: 'flex-end',
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            textAlign: 'right',
                            children: isModifying ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                size: 'small',
                                className: (0,clsx_m/* default */.Z)(classes.simpleButton, classes.simpleButtonDanger),
                                onClick: function() {
                                    return cancelReturn();
                                },
                                disableRipple: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: account === null || account === void 0 ? void 0 : (ref5 = account.data) === null || ref5 === void 0 ? void 0 : ref5.order_details_manage_cancel,
                                    defaultText: t('texts:account:order_details_manage_cancel')
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                size: 'small',
                                className: (0,clsx_m/* default */.Z)(classes.simpleButton, classes.simpleButtonPrimary),
                                onClick: function() {
                                    return setIsModifying(true);
                                },
                                disableRipple: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: account === null || account === void 0 ? void 0 : (ref6 = account.data) === null || ref6 === void 0 ? void 0 : ref6.order_details_manage,
                                    defaultText: t('texts:account:order_details_manage')
                                })
                            })
                        })
                    })
                ]
            }),
            orders.map(function(order, index) {
                var ref;
                var lastOrder = index + 1 === orders.length;
                var orderDate = dayjs_min_default()(order.checkoutCompletedAt).format('L');
                var isDisabled = (ref = isOrderReturnable.find(function(orderInfos) {
                    return orderInfos.orderId === order.number;
                })) === null || ref === void 0 ? void 0 : ref.returnable;
                if (indexOrder === null) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBack_TakeBackOrderItem, {
                            takeback: takeback,
                            main: main,
                            account: account,
                            order: order,
                            activeOrder: activeOrder,
                            isModifying: isModifying,
                            isDisabled: isDisabled,
                            isDownloadLoading: isDownloadLoading,
                            downloadLink: downloadLink,
                            productSelection: productSelection,
                            productToReturn: productToReturn,
                            productReturningReasons: productReturningReasons,
                            isOrderReturnable: isOrderReturnable,
                            orderDate: orderDate,
                            handleProductSelection: handleProductSelection,
                            handleReturningReasonChange: handleReturningReasonChange,
                            handleReturningReasonCommentChange: handleReturningReasonCommentChange,
                            handleActiveCurrentOrder: handleActiveCurrentOrder,
                            lastOrder: lastOrder,
                            warehouseId: warehouseId1,
                            handleDownloadInvoice: handleDownloadInvoice,
                            invoiceDownloadError: invoiceDownloadError,
                            tooltipWithdrawalText: tooltipWithdrawalText,
                            setIsDownloadLoading: setIsDownloadLoading,
                            setDownloadLink: setDownloadLink,
                            user: user,
                            postProductToReturn: postProductToReturn,
                            index: index,
                            settings: settings
                        })
                    }, index));
                } else {
                    if (indexOrder === index) {
                        return activeOrderLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.loaderContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBack_TakeBackOrderItem, {
                            takeback: takeback,
                            main: main,
                            account: account,
                            order: order,
                            activeOrder: activeOrder,
                            isModifying: isModifying,
                            isDisabled: isDisabled,
                            isDownloadLoading: isDownloadLoading,
                            downloadLink: downloadLink,
                            productSelection: productSelection,
                            productToReturn: productToReturn,
                            productReturningReasons: productReturningReasons,
                            isOrderReturnable: isOrderReturnable,
                            orderDate: orderDate,
                            handleProductSelection: handleProductSelection,
                            handleReturningReasonChange: handleReturningReasonChange,
                            handleReturningReasonCommentChange: handleReturningReasonCommentChange,
                            handleActiveCurrentOrder: handleActiveCurrentOrder,
                            lastOrder: lastOrder,
                            warehouseId: warehouseId1,
                            handleDownloadInvoice: handleDownloadInvoice,
                            invoiceDownloadError: invoiceDownloadError,
                            tooltipWithdrawalText: tooltipWithdrawalText,
                            setIsDownloadLoading: setIsDownloadLoading,
                            setDownloadLink: setDownloadLink,
                            user: user,
                            postProductToReturn: postProductToReturn,
                            index: index,
                            settings: settings
                        });
                    }
                }
            })
        ]
    }));
};
/* harmony default export */ var TakeBack_TakeBackOrderList = ((0,es/* connect */.$j)(TakeBackOrderList_mapStateToProps, null)(TakeBackOrderList));

// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/PrismicRichText.js + 15 modules
var PrismicRichText = __webpack_require__(63064);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js + 2 modules
var TextField_TextField = __webpack_require__(4073);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(85639);
;// CONCATENATED MODULE: ./components/DynamicForm/inputs/BasicInput.tsx



var BasicInput = function(param) {
    var label = param.label, name = param.name, _kind = param.kind, kind = _kind === void 0 ? 'text' : _kind, required = param.required, placeholder = param.placeholder, value = param.value, error = param.error, helperText = param.helperText, _rows = param.rows, rows = _rows === void 0 ? 4 : _rows, _options = param.options, options = _options === void 0 ? [] : _options, onChange = param.onChange;
    var isSelect = kind === 'select';
    var isTextarea = kind === 'textarea';
    var inputType = isSelect || isTextarea ? undefined : kind;
    var ref;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(TextField_TextField/* default */.Z, {
        fullWidth: true,
        select: isSelect,
        multiline: isTextarea,
        rows: isTextarea ? rows : undefined,
        type: inputType,
        label: label,
        name: name,
        placeholder: placeholder,
        required: required,
        value: (ref = value) !== null && ref !== void 0 ? ref : '',
        onChange: function(e) {
            return onChange(e.target.value);
        },
        error: Boolean(error),
        helperText: error || helperText,
        margin: "normal",
        inputProps: kind === 'number' ? {
            inputMode: 'numeric',
            pattern: '[0-9]*'
        } : undefined,
        children: isSelect && options.map(function(opt, idx) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                value: opt.value,
                children: opt.label
            }, idx);
        })
    }));
};
/* harmony default export */ var inputs_BasicInput = (BasicInput);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormHelperText/FormHelperText.js
var FormHelperText = __webpack_require__(30585);
;// CONCATENATED MODULE: ./components/DynamicForm/inputs/CheckboxInput.tsx




var CheckboxInput = function(param) {
    var labelRich = param.labelRich, name = param.name, checked = param.checked, error = param.error, helperText = param.helperText, onChange = param.onChange;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        my: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                    name: name,
                    color: "primary",
                    checked: checked,
                    onChange: function(e) {
                        return onChange(e.target.checked);
                    }
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                    field: labelRich
                })
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                error: true,
                children: error
            }),
            !error && helperText && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                children: helperText
            })
        ]
    }));
};
/* harmony default export */ var inputs_CheckboxInput = (CheckboxInput);

;// CONCATENATED MODULE: ./redux/services/dynamicForm.ts




function dynamicForm_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function dynamicForm_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            dynamicForm_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var submitDynamicForm = function(payload) {
    return (0,api/* axiosRMSWrapper */.UZ)({
        method: requests/* EMethods.post */.YZ.post,
        url: requests/* RMSRequestUrl.customReturn */.jo.customReturn,
        headers: dynamicForm_objectSpread({
            'Content-Type': 'application/json'
        }, (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE))),
        data: payload
    });
};
var getFileSignedUrl = function(params) {
    return (0,api/* axiosRMSWrapper */.UZ)({
        method: requests/* EMethods.post */.YZ.post,
        url: requests/* RMSRequestUrl.fileSignedUrl */.jo.fileSignedUrl,
        data: {
            name: params.fileName,
            type: params.fileType,
            entityType: params.entityType
        }
    });
};
var deleteFile = function(fileId) {
    return (0,api/* axiosRMSWrapper */.UZ)({
        method: requests/* EMethods.delete */.YZ["delete"],
        url: requests/* RMSRequestUrl.file */.jo.file,
        uid: fileId
    });
};

;// CONCATENATED MODULE: ./components/DynamicForm/inputs/FileInput.tsx





function FileInput_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function FileInput_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                FileInput_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                FileInput_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var FileInput = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref2) {
    var label = param.label, name = param.name, required = param.required, helperText = param.helperText, accept = param.accept, multiple = param.multiple, maxSizeMB = param.maxSizeMB, value = param.value, onChange = param.onChange, config = param.config;
    var inputRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(), error = ref1[0], setError = ref1[1];
    (0,react.useImperativeHandle)(ref2, function() {
        return {
            upload: FileInput_asyncToGenerator(runtime_default().mark(function _callee() {
                var files, uploadedIds, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, f, ref, signedUrl, remoteFileName, putRes;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setError(undefined);
                            if (config) {
                                _ctx.next = 3;
                                break;
                            }
                            return _ctx.abrupt("return", {
                                uploadedIds: []
                            });
                        case 3:
                            files = Array.isArray(value) ? value : value ? [
                                value
                            ] : [];
                            uploadedIds = [];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _ctx.prev = 6;
                            _iterator = files[Symbol.iterator]();
                        case 8:
                            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                _ctx.next = 24;
                                break;
                            }
                            f = _step.value;
                            _ctx.next = 12;
                            return getFileSignedUrl({
                                fileName: f.name,
                                fileType: f.type || 'application/octet-stream',
                                entityType: config.entityType
                            });
                        case 12:
                            ref = _ctx.sent;
                            signedUrl = ref.signedUrl;
                            remoteFileName = ref.remoteFileName;
                            _ctx.next = 17;
                            return fetch(signedUrl, {
                                method: 'PUT',
                                body: f,
                                headers: {
                                    'Content-Type': f.type || 'application/octet-stream'
                                }
                            });
                        case 17:
                            putRes = _ctx.sent;
                            if (putRes.ok) {
                                _ctx.next = 20;
                                break;
                            }
                            throw new Error('Failed to upload file');
                        case 20:
                            uploadedIds.push(remoteFileName);
                        case 21:
                            _iteratorNormalCompletion = true;
                            _ctx.next = 8;
                            break;
                        case 24:
                            _ctx.next = 30;
                            break;
                        case 26:
                            _ctx.prev = 26;
                            _ctx.t0 = _ctx["catch"](6);
                            _didIteratorError = true;
                            _iteratorError = _ctx.t0;
                        case 30:
                            _ctx.prev = 30;
                            _ctx.prev = 31;
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        case 33:
                            _ctx.prev = 33;
                            if (!_didIteratorError) {
                                _ctx.next = 36;
                                break;
                            }
                            throw _iteratorError;
                        case 36:
                            return _ctx.finish(33);
                        case 37:
                            return _ctx.finish(30);
                        case 38:
                            return _ctx.abrupt("return", {
                                uploadedIds: uploadedIds
                            });
                        case 39:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        6,
                        26,
                        30,
                        38
                    ],
                    [
                        31,
                        ,
                        33,
                        37
                    ]
                ]);
            })),
            rollback: (function() {
                var _ref = FileInput_asyncToGenerator(runtime_default().mark(function _callee(ids) {
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                if (!(!config || !(ids === null || ids === void 0 ? void 0 : ids.length))) {
                                    _ctx.next = 2;
                                    break;
                                }
                                return _ctx.abrupt("return");
                            case 2:
                                _ctx.next = 4;
                                return Promise.all(ids.map(function(id) {
                                    return deleteFile(id);
                                }));
                            case 4:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function(ids) {
                    return _ref.apply(this, arguments);
                };
            })()
        };
    });
    var onLocalChange = function(e) {
        setError(undefined);
        var fl = e.target.files;
        if (!fl) return onChange(null);
        var files = Array.from(fl);
        if (maxSizeMB) {
            var tooBig = files.some(function(f) {
                return f.size > maxSizeMB * 1024 * 1024;
            });
            if (tooBig) {
                setError("Max file size is ".concat(maxSizeMB, " MB"));
                return;
            }
        }
        onChange(multiple ? files : files[0]);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        my: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "subtitle1",
                gutterBottom: true,
                children: [
                    label,
                    required ? ' *' : ''
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                ref: inputRef,
                type: "file",
                name: name,
                accept: accept,
                multiple: multiple,
                onChange: onLocalChange
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                error: true,
                children: error
            }),
            !error && helperText && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                children: helperText
            })
        ]
    }));
});
FileInput.displayName = 'FileInput';
/* harmony default export */ var inputs_FileInput = (FileInput);

;// CONCATENATED MODULE: ./components/DynamicForm/DynamicForm.tsx







// Unified BasicInput now handles textarea and select too



function DynamicForm_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function DynamicForm_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function DynamicForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function DynamicForm_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                DynamicForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                DynamicForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function DynamicForm_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function DynamicForm_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function DynamicForm_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function DynamicForm_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            DynamicForm_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function DynamicForm_slicedToArray(arr, i) {
    return DynamicForm_arrayWithHoles(arr) || DynamicForm_iterableToArrayLimit(arr, i) || DynamicForm_unsupportedIterableToArray(arr, i) || DynamicForm_nonIterableRest();
}
function DynamicForm_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return DynamicForm_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return DynamicForm_arrayLikeToArray(o, minLen);
}
var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
var DynamicForm = function(param) {
    var formData = param.formData, orderNumber = param.orderNumber, fileUploadConfig = param.fileUploadConfig;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)({}), formValues = ref4[0], setFormValues = ref4[1];
    var ref5 = (0,react.useState)({}), errors = ref5[0], setErrors = ref5[1];
    var ref6 = (0,react.useState)(false), isSubmitted = ref6[0], setIsSubmitted = ref6[1];
    var formDataTyped = formData === null || formData === void 0 ? void 0 : formData.data;
    var ref7, ref8;
    var fieldsSlices = (ref8 = (ref7 = formDataTyped === null || formDataTyped === void 0 ? void 0 : formDataTyped.body) !== null && ref7 !== void 0 ? ref7 : formDataTyped === null || formDataTyped === void 0 ? void 0 : formDataTyped.form_body) !== null && ref8 !== void 0 ? ref8 : [];
    var hasFileInputs = (0,react.useMemo)(function() {
        return fieldsSlices.some(function(s) {
            return s.slice_type === 'file_input';
        });
    }, [
        fieldsSlices
    ]);
    var fileRefs = react.useRef({});
    var handleChange = function(fieldName, value) {
        setFormValues(function(prev) {
            return DynamicForm_objectSpread({}, prev, DynamicForm_defineProperty({}, fieldName, value));
        });
        if (errors[fieldName]) setErrors(function(prev) {
            return DynamicForm_objectSpread({}, prev, DynamicForm_defineProperty({}, fieldName, ''));
        });
    };
    var validateForm = function() {
        var nextErrors = {};
        fieldsSlices.forEach(function(slice) {
            var fieldName = (0,CMSText/* prismicText */.yz)(slice.primary.field_name);
            if (!fieldName) return;
            var isRequired = Boolean(slice.primary.required);
            var value = formValues[fieldName];
            if (slice.slice_type === 'file_input') {
                var files = Array.isArray(value) ? value : _instanceof(value, File) ? [
                    value
                ] : [];
                if (isRequired && files.length === 0) nextErrors[fieldName] = 'This field is required';
                var maxMB = Number(slice.primary.max_size_mb || 0);
                if (maxMB > 0 && files.length) {
                    var tooBig = files.some(function(f) {
                        return f.size > maxMB * 1024 * 1024;
                    });
                    if (tooBig) nextErrors[fieldName] = "Max file size is ".concat(maxMB, " MB");
                }
                return;
            }
            // Required validation
            if (isRequired) {
                var isEmpty = value === undefined || value === null || value === '' || value === false;
                if (isEmpty) nextErrors[fieldName] = 'This field is required';
            }
            // Type-specific validation
            if (slice.slice_type === 'email_input' && value) {
                if (!emailRegex.test(String(value))) {
                    nextErrors[fieldName] = 'Invalid email address';
                }
            }
        });
        setErrors(nextErrors);
        return Object.keys(nextErrors).length === 0;
    };
    // If any checkbox has primary.disable_sybmit_button_on_unchecked true,
    // submission must be disabled until that checkbox is checked.
    var mustAcceptCheckboxFieldNames = (0,react.useMemo)(function() {
        return fieldsSlices.filter(function(slice) {
            return slice.slice_type === 'checkbox_input' && Boolean(slice.primary.disable_sybmit_button_on_unchecked || slice.primary.disable_submit_button_on_unchecked);
        }).map(function(slice) {
            return (0,CMSText/* prismicText */.yz)(slice.primary.field_name);
        }).filter(function(name) {
            return Boolean(name);
        });
    }, [
        fieldsSlices
    ]);
    var isSubmitDisabledByCheckbox = (0,react.useMemo)(function() {
        if (!mustAcceptCheckboxFieldNames.length) return false;
        // Disabled if any gating checkbox is not truthy
        return mustAcceptCheckboxFieldNames.some(function(fieldName) {
            return !Boolean(formValues[fieldName]);
        });
    }, [
        mustAcceptCheckboxFieldNames,
        formValues
    ]);
    var onSubmit = function() {
        var _ref = DynamicForm_asyncToGenerator(runtime_default().mark(function _callee(e) {
            var uploadedByField, payloadFields, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, slice, fieldName, handle, uploadedIds, rollbacks, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, _value, fieldName1, ids, handle1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (validateForm()) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        uploadedByField = {};
                        _ctx.prev = 4;
                        payloadFields = DynamicForm_objectSpread({}, formValues);
                        if (!(hasFileInputs && fileUploadConfig)) {
                            _ctx.next = 41;
                            break;
                        }
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _ctx.prev = 8;
                        _iterator = fieldsSlices[Symbol.iterator]();
                    case 10:
                        if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                            _ctx.next = 27;
                            break;
                        }
                        slice = _step.value;
                        if (!(slice.slice_type !== 'file_input')) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("continue", 24);
                    case 14:
                        fieldName = (0,CMSText/* prismicText */.yz)(slice.primary.field_name);
                        if (fieldName) {
                            _ctx.next = 17;
                            break;
                        }
                        return _ctx.abrupt("continue", 24);
                    case 17:
                        handle = fileRefs.current[fieldName];
                        if (handle) {
                            _ctx.next = 20;
                            break;
                        }
                        return _ctx.abrupt("continue", 24);
                    case 20:
                        _ctx.next = 22;
                        return handle.upload();
                    case 22:
                        uploadedIds = _ctx.sent.uploadedIds;
                        if (uploadedIds === null || uploadedIds === void 0 ? void 0 : uploadedIds.length) {
                            uploadedByField[fieldName] = uploadedIds;
                            payloadFields[fieldName] = Array.isArray(formValues[fieldName]) ? uploadedIds : uploadedIds[0];
                        }
                    case 24:
                        _iteratorNormalCompletion = true;
                        _ctx.next = 10;
                        break;
                    case 27:
                        _ctx.next = 33;
                        break;
                    case 29:
                        _ctx.prev = 29;
                        _ctx.t0 = _ctx["catch"](8);
                        _didIteratorError = true;
                        _iteratorError = _ctx.t0;
                    case 33:
                        _ctx.prev = 33;
                        _ctx.prev = 34;
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    case 36:
                        _ctx.prev = 36;
                        if (!_didIteratorError) {
                            _ctx.next = 39;
                            break;
                        }
                        throw _iteratorError;
                    case 39:
                        return _ctx.finish(36);
                    case 40:
                        return _ctx.finish(33);
                    case 41:
                        _ctx.next = 43;
                        return submitDynamicForm({
                            oms_order_id: orderNumber || '',
                            type: (formData === null || formData === void 0 ? void 0 : formData.uid) || '',
                            data: payloadFields
                        });
                    case 43:
                        setIsSubmitted(true);
                        setFormValues({});
                        _ctx.next = 71;
                        break;
                    case 47:
                        _ctx.prev = 47;
                        _ctx.t1 = _ctx["catch"](4);
                        if (!fileUploadConfig) {
                            _ctx.next = 70;
                            break;
                        }
                        rollbacks = [];
                        _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        _ctx.prev = 52;
                        for(_iterator1 = Object.entries(uploadedByField)[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            _value = DynamicForm_slicedToArray(_step1.value, 2), fieldName1 = _value[0], ids = _value[1];
                            handle1 = fileRefs.current[fieldName1];
                            if (handle1 && (ids === null || ids === void 0 ? void 0 : ids.length)) {
                                rollbacks.push(handle1.rollback(ids));
                            }
                        }
                        _ctx.next = 60;
                        break;
                    case 56:
                        _ctx.prev = 56;
                        _ctx.t2 = _ctx["catch"](52);
                        _didIteratorError1 = true;
                        _iteratorError1 = _ctx.t2;
                    case 60:
                        _ctx.prev = 60;
                        _ctx.prev = 61;
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    case 63:
                        _ctx.prev = 63;
                        if (!_didIteratorError1) {
                            _ctx.next = 66;
                            break;
                        }
                        throw _iteratorError1;
                    case 66:
                        return _ctx.finish(63);
                    case 67:
                        return _ctx.finish(60);
                    case 68:
                        _ctx.next = 70;
                        return Promise.all(rollbacks);
                    case 70:
                        // Keep minimal handling consistent with codebase
                        alert('Error submitting form. Please try again later.');
                    case 71:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    47
                ],
                [
                    8,
                    29,
                    33,
                    41
                ],
                [
                    34,
                    ,
                    36,
                    40
                ],
                [
                    52,
                    56,
                    60,
                    68
                ],
                [
                    61,
                    ,
                    63,
                    67
                ]
            ]);
        }));
        return function onSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var renderField = function(slice, key) {
        var sliceType = slice.slice_type;
        var fieldName = (0,CMSText/* prismicText */.yz)(slice.primary.field_name);
        if (!fieldName) return null;
        var fieldLabel = (0,CMSText/* prismicText */.yz)(slice.primary.field_label);
        var required = Boolean(slice.primary.required);
        var helperText = (0,CMSText/* prismicText */.yz)(slice.primary.helper_text);
        var errorMsg = errors[fieldName];
        var basicTypes = {
            text_input: 'text',
            email_input: 'email',
            phone_input: 'tel',
            number_input: 'number',
            textarea_input: 'textarea',
            select_input: 'select'
        };
        switch(sliceType){
            case 'text_input':
            case 'email_input':
            case 'phone_input':
            case 'number_input':
            case 'textarea_input':
            case 'select_input':
                {
                    var kind = basicTypes[sliceType];
                    var placeholder = 'placeholder' in slice.primary ? (0,CMSText/* prismicText */.yz)(slice.primary.placeholder) : undefined;
                    var rows = 'rows' in slice.primary ? slice.primary.rows : undefined;
                    var options = kind === 'select' && 'items' in slice ? slice.items.map(function(item) {
                        return {
                            label: (0,CMSText/* prismicText */.yz)(item.option_label),
                            value: (0,CMSText/* prismicText */.yz)(item.option_value)
                        };
                    }) : [];
                    var fieldValue = formValues[fieldName];
                    var inputValue = typeof fieldValue === 'string' || typeof fieldValue === 'number' ? fieldValue : undefined;
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(inputs_BasicInput, {
                        label: fieldLabel,
                        name: fieldName,
                        kind: kind,
                        required: required,
                        placeholder: placeholder,
                        value: inputValue,
                        error: errorMsg,
                        helperText: helperText,
                        onChange: function(val) {
                            return handleChange(fieldName, val);
                        },
                        rows: rows,
                        options: options
                    }, key));
                }
            case 'checkbox_input':
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(inputs_CheckboxInput, {
                    labelRich: slice.primary.field_label,
                    name: fieldName,
                    checked: Boolean(formValues[fieldName]),
                    error: errorMsg,
                    helperText: helperText,
                    onChange: function(val) {
                        return handleChange(fieldName, val);
                    }
                }, key));
            case 'file_input':
                {
                    var fileValue = formValues[fieldName];
                    var typedFileValue = _instanceof(fileValue, File) ? fileValue : Array.isArray(fileValue) ? fileValue : null;
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(inputs_FileInput, {
                        ref: function(el) {
                            return fileRefs.current[fieldName] = el;
                        },
                        label: fieldLabel,
                        name: fieldName,
                        required: required,
                        helperText: helperText,
                        accept: (0,CMSText/* prismicText */.yz)(slice.primary.accept) || undefined,
                        multiple: Boolean(slice.primary.multiple),
                        maxSizeMB: slice.primary.max_size_mb,
                        value: typedFileValue,
                        onChange: function(val) {
                            return handleChange(fieldName, val);
                        },
                        config: fileUploadConfig ? {
                            entityType: fileUploadConfig.entityType
                        } : undefined
                    }, key));
                }
            default:
                return null;
        }
    };
    if (isSubmitted) {
        var ref9;
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "md",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                py: 8,
                textAlign: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                    field: formData === null || formData === void 0 ? void 0 : (ref9 = formData.data) === null || ref9 === void 0 ? void 0 : ref9.success_message
                })
            })
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: "md",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            py: 4,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h1",
                    gutterBottom: true,
                    children: (0,CMSText/* prismicText */.yz)(formData === null || formData === void 0 ? void 0 : (ref = formData.data) === null || ref === void 0 ? void 0 : ref.form_title)
                }),
                (formData === null || formData === void 0 ? void 0 : (ref1 = formData.data) === null || ref1 === void 0 ? void 0 : ref1.form_description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mb: 3,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                        field: formData === null || formData === void 0 ? void 0 : (ref2 = formData.data) === null || ref2 === void 0 ? void 0 : ref2.form_description
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: onSubmit,
                    children: [
                        fieldsSlices.map(function(slice, index) {
                            return renderField(slice, index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mt: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                type: "submit",
                                variant: "contained",
                                color: "primary",
                                size: "large",
                                disabled: isSubmitDisabledByCheckbox,
                                children: (0,CMSText/* prismicText */.yz)(formData === null || formData === void 0 ? void 0 : (ref3 = formData.data) === null || ref3 === void 0 ? void 0 : ref3.submit_button_text, 'Submit')
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var DynamicForm_DynamicForm = (DynamicForm);

;// CONCATENATED MODULE: ./components/DynamicForm/DynamicFormModal.tsx




var DynamicFormModal = function(param) {
    var open = param.open, onClose = param.onClose, formData = param.formData, orderNumber = param.orderNumber, fileUploadConfig = param.fileUploadConfig;
    var ref;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalModal/* default */.Z, {
        open: open,
        onClose: onClose,
        customClass: 'dynamic-form-modal',
        modalTitle: {
            data: formData === null || formData === void 0 ? void 0 : (ref = formData.data) === null || ref === void 0 ? void 0 : ref.form_title,
            defaultText: 'Form'
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicForm_DynamicForm, {
            formData: formData,
            orderNumber: orderNumber,
            fileUploadConfig: fileUploadConfig
        })
    }));
};
/* harmony default export */ var DynamicForm_DynamicFormModal = (DynamicFormModal);

;// CONCATENATED MODULE: ./components/UserForm/SSOLogout.tsx
/* provided dependency */ var SSOLogout_process = __webpack_require__(34155);

function SSOCulturaLogout(idToken, trackingFunction, routingFunction, emptyCart) {
    var env = "dev";
    var culturaRedirectUrl = SSOLogout_process.env.SSO_REDIRECT_URL;
    localStorage.removeItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN);
    localStorage.removeItem(constants/* LOCAL_STORAGE_KEYS.USER_TYPE */.dA.USER_TYPE);
    localStorage.removeItem('email');
    emptyCart();
    if (env === 'dev') {
        trackingFunction({
            category: 'User Information',
            action: "User logged out on Cultura PP"
        });
        return routingFunction.push("https://connect-preprod.cultura.com/oauth2/ausqji2d6RIPsk8wC0x6/v1/logout?id_token_hint=".concat(idToken, "&post_logout_redirect_uri=").concat(culturaRedirectUrl));
    }
    // TODO : fix the ENV variable for CulturaProd from dev to prod on CleverCloud
    if (env === 'prod') {
        trackingFunction({
            category: 'User Information',
            action: "User logged out on Cultura Prod"
        });
        return routingFunction.push("https://connect.cultura.com/oauth2/auspOslggmgGzzfjd416/v1/logout?id_token_hint=".concat(idToken, "&post_logout_redirect_uri=").concat(culturaRedirectUrl));
    }
    return;
}
function SSODecathlonLogout(idToken, trackingFunction, routingFunction, emptyCart) {
    var locale = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 'fr';
    var env = "dev";
    var localePath = locale !== 'fr' ? locale : '';
    var decathlonRedirectUrl = "".concat(SSOLogout_process.env.SSO_REDIRECT_URL).concat(localePath);
    localStorage.removeItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN);
    localStorage.removeItem(constants/* LOCAL_STORAGE_KEYS.USER_TYPE */.dA.USER_TYPE);
    localStorage.removeItem('CartToken');
    localStorage.removeItem('email');
    emptyCart();
    if (env === 'dev') {
        trackingFunction({
            category: 'User Information',
            action: "User logged out on Decathlon PP"
        });
        return routingFunction.push("https://api-global.preprod.decathlon.net/connect/openid/logout?id_token_hint=".concat(idToken, "&post_logout_redirect_uri=").concat(decathlonRedirectUrl));
    }
    // TODO : fix the ENV variable for CulturaProd from dev to prod on CleverCloud
    if (env === 'prod') {
        trackingFunction({
            category: 'User Information',
            action: "User logged out on Decathlon Prod"
        });
        return routingFunction.push("https://api-global.decathlon.net/connect/openid/logout?id_token_hint=".concat(idToken, "&post_logout_redirect_uri=").concat(decathlonRedirectUrl));
    }
    return;
}
function SSOVirginLogout(idToken, trackingFunction, routingFunction, emptyCart) {
    var ssoState = localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.SSO_STATE */.dA.SSO_STATE);
    localStorage.removeItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN);
    localStorage.removeItem(constants/* LOCAL_STORAGE_KEYS.REFRESH_TOKEN */.dA.REFRESH_TOKEN);
    localStorage.removeItem(constants/* LOCAL_STORAGE_KEYS.TOKEN_EXPIRE_AT */.dA.TOKEN_EXPIRE_AT);
    localStorage.removeItem(constants/* LOCAL_STORAGE_KEYS.LOGIN_METHOD */.dA.LOGIN_METHOD);
    localStorage.removeItem(constants/* LOCAL_STORAGE_KEYS.SSO_STATE */.dA.SSO_STATE);
    localStorage.removeItem(constants/* LOCAL_STORAGE_KEYS.USER_TYPE */.dA.USER_TYPE);
    localStorage.removeItem('CartToken');
    localStorage.removeItem('email');
    emptyCart();
    //TODO: si erreur token expiré au /me, on refresh token -> /me
    //TODO : si le refresh token est expiré, je vide tout
    return routingFunction.push("".concat("https://equitry-subscription-staging-admin.lizee.io/", "/ciam/logout?state=").concat(ssoState));
}

// EXTERNAL MODULE: ./components/Order/SecondHandAndRentalOrderList.tsx + 4 modules
var SecondHandAndRentalOrderList = __webpack_require__(24219);
;// CONCATENATED MODULE: ./components/Account/AccountStyles.ts

function AccountStyles_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useAccountStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        accountContainer: AccountStyles_defineProperty({}, theme.breakpoints.up('md'), {
            padding: theme.spacing(8)
        }),
        sticky: AccountStyles_defineProperty({}, theme.breakpoints.up('md'), {
            position: 'sticky',
            top: theme.sizes.headerHeight + theme.spacing(2)
        }),
        background: {
            background: theme.extraColors.greyLight
        },
        text: {
            marginBottom: theme.spacing(2)
        },
        desc: {
            maxWidth: 300
        },
        accountHeader: {
            width: '100%'
        },
        main: {
            textAlign: 'center',
            margin: theme.spacing(8, 0)
        },
        infosLink: {
            display: 'inline-flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            color: theme.extraColors.greyText
        },
        infosLinkContainer: AccountStyles_defineProperty({
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center'
        }, theme.breakpoints.down('md'), {
            marginTop: theme.spacing(2)
        }),
        questionContainer: {
            background: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(3)
        },
        smallMarginBottom: {
            marginBottom: theme.spacing(2)
        },
        stepLabel: {
            color: theme.palette.secondary.main
        },
        loaderSection: {
            height: '70vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        loaderSectionFull: {
            height: '100vh'
        },
        link: {
            textDecoration: 'underline',
            cursor: 'pointer'
        },
        loaderContainer: {
            height: 300,
            width: '100%',
            alignContent: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        warning: {
            margin: theme.spacing(6, 0, 0),
            padding: theme.spacing(2, 3),
            borderRadius: theme.shape.borderRadius,
            background: theme.palette.warning.light,
            color: theme.palette.warning.contrastText,
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(2)
        },
        warningContainer: AccountStyles_defineProperty({
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(1)
        }, theme.breakpoints.up('lg'), {
            flexDirection: 'row',
            alignItems: 'center',
            '&>.MuiTypography-root': {},
            '&>div': {
                whiteSpace: 'nowrap'
            }
        }),
        warningContainerAlt: AccountStyles_defineProperty({}, theme.breakpoints.up('lg'), {
            flexDirection: 'column',
            alignItems: 'flex-start'
        }),
        warningBtn: {
            color: theme.palette.warning.light,
            background: theme.palette.warning.contrastText
        },
        center: {
            textAlign: 'center'
        }
    });
});

;// CONCATENATED MODULE: ./components/Account/AccountFaq.tsx







var AccountFaq = function(param) {
    var doc = param.doc;
    var ref, ref1;
    var classes = useAccountStyles();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.questionContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: 'h4',
                color: 'primary',
                align: 'center',
                className: "".concat(classes.smallMarginBottom, " account__questions"),
                children: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : ref.block_title, t('texts:account:block_title'))
            }),
            (doc === null || doc === void 0 ? void 0 : doc.data) ? doc === null || doc === void 0 ? void 0 : (ref1 = doc.data) === null || ref1 === void 0 ? void 0 : ref1.block.map(function(item, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: 'body2',
                            className: "account__question",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: (0,CMSText/* prismicText */.yz)(item === null || item === void 0 ? void 0 : item.bold_sentence)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: 'body2',
                            className: (0,clsx_m/* default */.Z)('account__answer', classes.smallMarginBottom),
                            component: 'div',
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                data: item === null || item === void 0 ? void 0 : item.paragraph
                            })
                        })
                    ]
                }, index);
            }) : [
                0,
                1
            ].map(function(index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: 'body2',
                            className: "account__question",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: t('texts:general:add_a_title')
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: 'body2',
                            className: (0,clsx_m/* default */.Z)('account__answer', classes.smallMarginBottom),
                            children: t('texts:general:add_a_description')
                        })
                    ]
                }, index);
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Settings.js
var Settings = __webpack_require__(9969);
;// CONCATENATED MODULE: ./components/Account/InfoLink.tsx
/* provided dependency */ var InfoLink_process = __webpack_require__(34155);










var InfoLink = function(param) {
    var doc = param.doc;
    var ref;
    var classes = useAccountStyles();
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.infosLinkContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            href: InfoLink_process.env.IS_ACCOUNT_INFORMATION_EXTERNAL === 'true' ? InfoLink_process.env.ACCOUNT_INFORMATION_URL : '/account/informations',
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                "data-testid": 'go_to_info',
                onClick: function() {
                    return trackEvent({
                        category: 'user Information',
                        action: "User go to his Informations"
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: 'body2',
                    component: 'span',
                    className: (0,clsx_m/* default */.Z)(classes.infosLink, 'account__infos-link'),
                    children: [
                        (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : ref.info_link, t('texts:account:info_link')),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Settings/* default */.Z, {})
                    ]
                })
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/Account/NoOrderBox.tsx








var NoOrderBox = function(param) {
    var doc = param.doc;
    var ref, ref1;
    var classes = useAccountStyles();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.main,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        asText: true,
                        data: doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : ref.no_command,
                        defaultText: t('texts:account:no_command')
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                href: '/shop',
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: 'contained',
                        color: 'secondary',
                        component: "span",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: doc === null || doc === void 0 ? void 0 : (ref1 = doc.data) === null || ref1 === void 0 ? void 0 : ref1.go_to_shop,
                            defaultText: t('texts:account:go_to_shop')
                        })
                    })
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(19789);
// EXTERNAL MODULE: ./node_modules/notistack/dist/notistack.esm.js
var notistack_esm = __webpack_require__(73400);
;// CONCATENATED MODULE: ./pages/account.tsx
/* provided dependency */ var account_process = __webpack_require__(34155);








































function account_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function account_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                account_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                account_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var account_customParseFormat = __webpack_require__(10285);
dayjs_min_default().extend(account_customParseFormat);
var account_mapStateToProps = function(state) {
    return {
        user: state.user,
        cart: state.cart,
        parameters: state.parameters,
        addressUser: state.addressUser,
        contract: state.contract,
        userTakeBackProducts: state.takeBack,
        stores: state.stores,
        SSOdata: state.SSOdata
    };
};
var account_mapDispatchToProps = {
    postProductToReturn: order/* postProductToReturn */.Gv,
    deleteUser: actions_user/* deleteUser */.h8,
    getAddress: addressUser/* getAddress */.Kn,
    patchAddress: addressUser/* patchAddress */.Pe,
    getUser: actions_user/* getUser */.PR,
    logoutUser: actions_user/* logoutUser */.TX,
    getInProgressContractCSUB: contract/* getInProgressContractCSUB */.UF,
    getInProgressContractSUB: contract/* getInProgressContractSUB */.R0,
    putUserOrder: actions_user/* putUserOrder */.XN,
    getUserOrders: actions_user/* getUserOrders */.uI,
    getUserTakeBackProducts: takeBack/* getUserTakeBackProducts */.TW,
    getRightOfWithdrawalInfo: takeBack/* getRightOfWithdrawalInfo */.R2,
    getOrderInvoice: order/* getOrderInvoice */.Fh
};
var Account = function(param) {
    var main = param.main, user = param.user, faqRes = param.faqRes, parameters = param.parameters, postProductToReturn1 = param.postProductToReturn, getInProgressContractCSUB1 = param.getInProgressContractCSUB, getInProgressContractSUB1 = param.getInProgressContractSUB, inStoreText = param.inStoreText, customer_survey = param.customer_survey, doc = param.doc, sub_list = param.sub_list, getAddress1 = param.getAddress, patchAddress1 = param.patchAddress, addressUser = param.addressUser, getUser1 = param.getUser, contract2 = param.contract, putUserOrder1 = param.putUserOrder, getUserOrders1 = param.getUserOrders, basket = param.basket, getUserTakeBackProducts1 = param.getUserTakeBackProducts, getRightOfWithdrawalInfo1 = param.getRightOfWithdrawalInfo, takeback = param.takeback, userTakeBackProducts = param.userTakeBackProducts, stores = param.stores, SSOdata = param.SSOdata, getOrderInvoice1 = param.getOrderInvoice, logoutUser1 = param.logoutUser, banner = param.banner, savForm = param.savForm;
    var ref45, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34;
    var classes = useAccountStyles();
    var router = (0,next_router.useRouter)();
    var theme = (0,useTheme/* default */.Z)();
    var emptyCart = (0,useCart/* useCart */.j)().emptyCart;
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('md'));
    var ref35 = (0,react.useState)(false), modalHowItWorks = ref35[0], setModalHowItWorks = ref35[1];
    var ref36 = (0,react.useState)(false), modalRemoveItem = ref36[0], setModalRemoveItem = ref36[1];
    var ref37 = (0,react.useState)(false), savFormOpen = ref37[0], setSavFormOpen = ref37[1];
    var ref38 = (0,react.useState)(''), savFormOrderNumber = ref38[0], setSavFormOrderNumber = ref38[1];
    var ref39 = (0,react.useState)(false), invoiceDownloadError = ref39[0], setInvoiceDownloadError = ref39[1];
    var ref40 = (0,react.useState)(false), checkUser = ref40[0], setCheckUser = ref40[1];
    var ref41 = (0,react.useState)(false), showSuccessMessage = ref41[0], setShowSuccessMessage = ref41[1];
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref42 = (0,useMatomo/* default */.Z)(), trackPageView = ref42.trackPageView, trackEvent = ref42.trackEvent;
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var dispatch = (0,es/* useDispatch */.I0)();
    var isSecondHand = parameters === null || parameters === void 0 ? void 0 : (ref45 = parameters.items) === null || ref45 === void 0 ? void 0 : ref45.enableTakeBack;
    var isSubscription =  true || 0;
    var rmsFileUploadConfig = (0,react.useMemo)(function() {
        return {
            entityType: 'instruction'
        };
    }, []);
    var token = typeof localStorage !== 'undefined' ? localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN) : 'undefined';
    (0,react.useEffect)(function() {
        dispatch((0,prismic/* SAVE_PRISMIC_DOCUMENTS */.w)({
            general: main === null || main === void 0 ? void 0 : main.data,
            instore: inStoreText === null || inStoreText === void 0 ? void 0 : inStoreText.data
        }));
    }, [
        main,
        inStoreText
    ]);
    (0,react.useEffect)(function() {
        trackPageView({
            documentTitle: 'Account'
        });
    }, []);
    (0,react.useEffect)(function() {
        // Check if state parameter is "account" in URL
        var code = router.query.code;
        if (code && !showSuccessMessage) {
            enqueueSnackbar({
                message: 'profil-updated',
                variant: 'success',
                autoHideDuration: 5000,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            });
            setShowSuccessMessage(true);
        // const newQuery = { ...router.query }
        // delete newQuery.state
        // router.replace(
        //   {
        //     pathname: router.pathname,
        //     query: newQuery,
        //   },
        //   undefined,
        //   { shallow: true }
        // )
        }
    }, [
        router.query,
        showSuccessMessage,
        enqueueSnackbar
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (user === null || user === void 0 ? void 0 : user.user) {
            var ref44;
            searchContract();
            getUserTakeBackProducts1({
                email: user === null || user === void 0 ? void 0 : (ref44 = user.user) === null || ref44 === void 0 ? void 0 : ref44.email
            });
        }
        if (!(user === null || user === void 0 ? void 0 : user.orders) || (user === null || user === void 0 ? void 0 : (ref = user.orders) === null || ref === void 0 ? void 0 : ref.length) === 0) getUserOrders1();
    }, [
        user === null || user === void 0 ? void 0 : user.user
    ]);
    var searchContract = function() {
        var _ref = account_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, contract, ref46, contract1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (true) {
                            _ctx.next = 10;
                            break;
                        }
                        ;
                        _ctx.next = 4;
                        return getInProgressContractCSUB1('in_progress');
                    case 4:
                        contract = _ctx.sent;
                        if (!(contract.type === 'GET_IN_PROGRESS_CONTRACT_SUB_FAILURE' || (contract === null || contract === void 0 ? void 0 : (ref = contract.currentContract) === null || ref === void 0 ? void 0 : ref.length) === 0)) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 8;
                        return getInProgressContractCSUB1('in_coming');
                    case 8:
                        _ctx.next = 18;
                        break;
                    case 10:
                        if (false) {}
                        ;
                        _ctx.next = 14;
                        return getInProgressContractSUB1('in_progress');
                    case 14:
                        contract1 = _ctx.sent;
                        if (!(contract1.type === 'GET_IN_PROGRESS_CONTRACT_SUB_FAILURE' || (contract1 === null || contract1 === void 0 ? void 0 : (ref46 = contract1.currentContract) === null || ref46 === void 0 ? void 0 : ref46.length) === 0)) {
                            _ctx.next = 18;
                            break;
                        }
                        _ctx.next = 18;
                        return getInProgressContractSUB1('in_coming');
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function searchContract() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (token && !(user === null || user === void 0 ? void 0 : user.user)) {
            var isAsync = function() {
                var _ref = account_asyncToGenerator(runtime_default().mark(function _callee() {
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return getUser1();
                            case 2:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function isAsync() {
                    return _ref.apply(this, arguments);
                };
            }();
            isAsync();
        }
    }, []);
    (0,react.useEffect)(function() {
        if (!user.loading && !user.isLoggedIn) {
            router.push('/register');
            setCheckUser(false);
        } else setCheckUser(true);
    }, [
        user === null || user === void 0 ? void 0 : user.isLoggedIn
    ]);
    (0,react.useEffect)(function() {
        var ref, ref47;
        // Check if user as a default address
        if ((user === null || user === void 0 ? void 0 : (ref = user.user) === null || ref === void 0 ? void 0 : ref.address) && Object.keys(user === null || user === void 0 ? void 0 : (ref47 = user.user) === null || ref47 === void 0 ? void 0 : ref47.address).length === 0) {
            setCheckUser(false);
            var isAsync = function() {
                var _ref = account_asyncToGenerator(runtime_default().mark(function _callee() {
                    var response;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return getAddress1();
                            case 2:
                                response = _ctx.sent;
                                if (response.type === 'GET_ADDRESS_USER_SUCCESS') {
                                    setCheckUser(true);
                                }
                            case 4:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function isAsync() {
                    return _ref.apply(this, arguments);
                };
            }();
            isAsync();
        }
    }, [
        user === null || user === void 0 ? void 0 : (ref1 = user.user) === null || ref1 === void 0 ? void 0 : ref1.address
    ]);
    (0,react.useEffect)(function() {
        // If address are available get the first one and set to default address in user state
        var isAsync = function() {
            var _ref = account_asyncToGenerator(runtime_default().mark(function _callee() {
                var ref, ref48, ref49, defaultAddressId, response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            setCheckUser(false);
                            if (!((user === null || user === void 0 ? void 0 : (ref = user.user) === null || ref === void 0 ? void 0 : ref.address) && Object.keys(user === null || user === void 0 ? void 0 : (ref48 = user.user) === null || ref48 === void 0 ? void 0 : ref48.address).length === 0 && (addressUser === null || addressUser === void 0 ? void 0 : (ref49 = addressUser.items) === null || ref49 === void 0 ? void 0 : ref49.length) > 0)) {
                                _ctx.next = 13;
                                break;
                            }
                            defaultAddressId = addressUser.items[0].id;
                            _ctx.next = 6;
                            return patchAddress1(defaultAddressId);
                        case 6:
                            response = _ctx.sent;
                            if (!(response.type === 'PATCH_ADDRESS_USER_SUCCESS')) {
                                _ctx.next = 10;
                                break;
                            }
                            _ctx.next = 10;
                            return getUser1();
                        case 10:
                            setCheckUser(true);
                            _ctx.next = 14;
                            break;
                        case 13:
                            {
                                setCheckUser(true);
                            }
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function isAsync() {
                return _ref.apply(this, arguments);
            };
        }();
        isAsync();
    }, [
        addressUser
    ]);
    var logOut = function() {
        var userType = localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.USER_TYPE */.dA.USER_TYPE);
        var connexionType = localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE);
        var store = "equitry-subscription";
        var isDecathlonUser = connexionType === 'decathlon' && userType === 'SSO';
        var isCulturaUser = store === 'cultura' && userType === 'SSO';
        var isVirginUser = store === 'virgin' && userType === 'SSO';
        if (isCulturaUser) {
            var ref;
            var SSOIdToken = SSOdata === null || SSOdata === void 0 ? void 0 : (ref = SSOdata.items) === null || ref === void 0 ? void 0 : ref.id_token;
            SSOCulturaLogout(SSOIdToken, trackEvent, router, emptyCart);
        }
        if (isDecathlonUser) {
            var SSOIdToken1 = localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN);
            SSODecathlonLogout(SSOIdToken1, trackEvent, router, emptyCart, router.locale);
        }
        if (isVirginUser) {
            var SSOIdToken2 = localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN);
            SSOVirginLogout(SSOIdToken2, trackEvent, router, emptyCart);
        }
        if (!isCulturaUser && !isDecathlonUser && !isVirginUser) {
            // For non-SSO users, empty cart manually
            emptyCart();
        }
        trackEvent({
            category: 'User Information',
            action: "User logged out"
        });
        (0,actions_user/* deleteUser */.h8)();
        logoutUser1();
        router.push('/register');
    };
    var setModalHowItWorksAndTrack = function() {
        setModalHowItWorks(true);
        trackEvent({
            category: "User Information",
            action: "Clicked on how it works"
        });
    };
    var handleDownloadInvoice = function() {
        var _ref = account_asyncToGenerator(runtime_default().mark(function _callee(orderNumber) {
            var invoicePDF, ref, ref50;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getOrderInvoice1(orderNumber);
                    case 2:
                        invoicePDF = _ctx.sent;
                        if (invoicePDF.type === 'GET_ORDER_INVOICE_SUCCESS') {
                            ;
                            if ((invoicePDF === null || invoicePDF === void 0 ? void 0 : (ref = invoicePDF.invoice) === null || ref === void 0 ? void 0 : ref.url) !== undefined) {
                                ;
                                (0,utils/* downloadInvoice */._Z)(invoicePDF === null || invoicePDF === void 0 ? void 0 : (ref50 = invoicePDF.invoice) === null || ref50 === void 0 ? void 0 : ref50.url);
                                setInvoiceDownloadError(false);
                            }
                        }
                        if ((invoicePDF === null || invoicePDF === void 0 ? void 0 : invoicePDF.type) === 'GET_ORDER_INVOICE_FAILURE') {
                            setInvoiceDownloadError(true);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleDownloadInvoice(orderNumber) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref43 = (0,react.useMemo)(function() {
        var ref;
        var items = ((ref = contract2.items) === null || ref === void 0 ? void 0 : ref.sort(function(a, b) {
            return dayjs_min_default()(a.startLeasingDate).isAfter(dayjs_min_default()(b.startLeasingDate)) ? -1 : 1;
        })) || [];
        return {
            currentContract: items[0],
            allContracts: items
        };
    }, [
        contract2
    ]), currentContract = ref43.currentContract, allContracts = ref43.allContracts;
    return user && user.user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "page-account",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
                mainLogo: main === null || main === void 0 ? void 0 : (ref2 = main.data) === null || ref2 === void 0 ? void 0 : ref2.logo,
                doc: main,
                inStoreText: inStoreText,
                t: t,
                metaTitle: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref3 = doc.data) === null || ref3 === void 0 ? void 0 : ref3.meta_title_account, t('texts:account:herotitle')),
                metaDescription: doc === null || doc === void 0 ? void 0 : (ref4 = doc.data) === null || ref4 === void 0 ? void 0 : ref4.meta_description_account,
                metaKeywords: doc === null || doc === void 0 ? void 0 : (ref5 = doc.data) === null || ref5 === void 0 ? void 0 : ref5.meta_keywords_account,
                basket: basket,
                takeback: takeback,
                account: doc,
                faq: faqRes,
                banner: banner,
                children: !checkUser ? /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: (0,clsx_m/* default */.Z)('account', classes.background, classes.loaderSection),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: (0,clsx_m/* default */.Z)('account', classes.background),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        className: classes.accountContainer,
                        maxWidth: isSubscription ? 'xl' : 'lg',
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.accountHeader,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                container: true,
                                spacing: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        lg: isSubscription ? 4 : 6,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classes.sticky,
                                            children: [
                                                isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoLink, {
                                                    doc: doc
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: classes.text,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            variant: "h3",
                                                            className: 'account__title',
                                                            children: [
                                                                (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref6 = doc.data) === null || ref6 === void 0 ? void 0 : ref6.hi, t('texts:account:hi')),
                                                                ' ',
                                                                user === null || user === void 0 ? void 0 : (ref7 = user.user) === null || ref7 === void 0 ? void 0 : ref7.firstName
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "body2",
                                                            color: "textSecondary",
                                                            className: (0,clsx_m/* default */.Z)('account_desc', classes.desc),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                data: doc === null || doc === void 0 ? void 0 : (ref8 = doc.data) === null || ref8 === void 0 ? void 0 : ref8.paragraph1,
                                                                defaultText: t('texts:account:paragraph1')
                                                            })
                                                        })
                                                    ]
                                                }),
                                                (doc === null || doc === void 0 ? void 0 : (ref9 = doc.data) === null || ref9 === void 0 ? void 0 : ref9.is_slider_active) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.smallMarginBottom,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        size: 'small',
                                                        variant: 'outlined',
                                                        color: 'primary',
                                                        onClick: setModalHowItWorksAndTrack,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: doc === null || doc === void 0 ? void 0 : (ref10 = doc.data) === null || ref10 === void 0 ? void 0 : ref10.link_name,
                                                            defaultText: t('texts:account:link_name')
                                                        })
                                                    })
                                                }),
                                                !(doc === null || doc === void 0 ? void 0 : (ref11 = doc.data) === null || ref11 === void 0 ? void 0 : ref11.hide_logout_button) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    variant: 'contained',
                                                    color: 'secondary',
                                                    size: 'small',
                                                    onClick: logOut,
                                                    className: (0,clsx_m/* default */.Z)('account__logout', 'btn--logout', classes.smallMarginBottom),
                                                    children: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref12 = doc.data) === null || ref12 === void 0 ? void 0 : ref12.log_out_button, t('texts:account:log_out_button'))
                                                }),
                                                (contract2 === null || contract2 === void 0 ? void 0 : (ref13 = contract2.items) === null || ref13 === void 0 ? void 0 : ref13.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: !(contract2 === null || contract2 === void 0 ? void 0 : contract2.loading) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (0,clsx_m/* default */.Z)(classes.questionContainer, classes.smallMarginBottom),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    !((ref14 = main.data) === null || ref14 === void 0 ? void 0 : ref14.display_flex_price_a_day) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                                        variant: 'h4',
                                                                        align: 'center',
                                                                        color: 'primary',
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                                asText: true,
                                                                                data: sub_list === null || sub_list === void 0 ? void 0 : (ref15 = sub_list.data) === null || ref15 === void 0 ? void 0 : ref15.invoice_this_month,
                                                                                defaultText: t('texts:subscription_order:invoice_this_month')
                                                                            }),
                                                                            "\xa0",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                                                children: [
                                                                                    (0,utils/* numberToPrice */.e8)(currentContract === null || currentContract === void 0 ? void 0 : currentContract.total),
                                                                                    ' €'
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                        variant: 'body2',
                                                                        component: 'div',
                                                                        className: classes.smallMarginBottom,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                            data: sub_list === null || sub_list === void 0 ? void 0 : (ref16 = sub_list.data) === null || ref16 === void 0 ? void 0 : ref16.invoice_explanation,
                                                                            defaultText: t('texts:subscription_order:invoice_explanation')
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                                        variant: 'h5',
                                                                        align: 'center',
                                                                        color: 'primary',
                                                                        component: 'p',
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                                asText: true,
                                                                                data: sub_list === null || sub_list === void 0 ? void 0 : (ref17 = sub_list.data) === null || ref17 === void 0 ? void 0 : ref17.subscription_start_date,
                                                                                defaultText: t('texts:subscription_order:subscription_start_date')
                                                                            }),
                                                                            "\xa0",
                                                                            dayjs_min_default()(currentContract === null || currentContract === void 0 ? void 0 : currentContract.startLeasingDate).format('L')
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                        variant: 'body2',
                                                                        component: 'div',
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                            data: sub_list === null || sub_list === void 0 ? void 0 : (ref18 = sub_list.data) === null || ref18 === void 0 ? void 0 : ref18.subscription_date_explanation,
                                                                            defaultText: t('texts:subscription_order:subscription_date_explanation')
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (0,clsx_m/* default */.Z)(classes.questionContainer, classes.smallMarginBottom, classes.center),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                                                    })
                                                }),
                                                !isMobile && (doc === null || doc === void 0 ? void 0 : (ref19 = doc.data) === null || ref19 === void 0 ? void 0 : ref19.enable_faq_account) && /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountFaq, {
                                                    doc: doc
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                        item: true,
                                        lg: isSubscription ? 8 : 6,
                                        xs: 12,
                                        children: [
                                            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoLink, {
                                                doc: doc
                                            }),
                                            (addressUser === null || addressUser === void 0 ? void 0 : (ref20 = addressUser.items) === null || ref20 === void 0 ? void 0 : ref20.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (0,clsx_m/* default */.Z)(classes.warning, 'warning-adress__container'),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Warning/* default */.Z, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (0,clsx_m/* default */.Z)(classes.warningContainer, !isSubscription && classes.warningContainerAlt),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                    data: doc === null || doc === void 0 ? void 0 : (ref21 = doc.data) === null || ref21 === void 0 ? void 0 : ref21.warning_text,
                                                                    defaultText: t('texts:account:warning:text')
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                                    href: account_process.env.IS_ACCOUNT_INFORMATION_EXTERNAL === 'true' ? account_process.env.ACCOUNT_INFORMATION_URL : '/account/informations',
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                            component: 'span',
                                                                            size: 'small',
                                                                            variant: 'contained',
                                                                            className: classes.warningBtn,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                                asText: true,
                                                                                data: doc === null || doc === void 0 ? void 0 : (ref22 = doc.data) === null || ref22 === void 0 ? void 0 : ref22.warning_cta,
                                                                                defaultText: t('texts:account:warning:cta')
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            !(userTakeBackProducts === null || userTakeBackProducts === void 0 ? void 0 : userTakeBackProducts.loading) ? (userTakeBackProducts === null || userTakeBackProducts === void 0 ? void 0 : (ref23 = userTakeBackProducts.response) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.variants) === null || ref24 === void 0 ? void 0 : ref24.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBack_TakeBackList, {
                                                t: t,
                                                takeback: takeback,
                                                userTakeBackProducts: userTakeBackProducts,
                                                settings: main === null || main === void 0 ? void 0 : main.data
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.loaderContainer,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                                            }),
                                            !(user === null || user === void 0 ? void 0 : user.loading) ? isSecondHand && constants/* isSecondHandOnly */.G7 && ((user === null || user === void 0 ? void 0 : (ref25 = user.orders) === null || ref25 === void 0 ? void 0 : ref25.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TakeBack_TakeBackOrderList, {
                                                t: t,
                                                main: main,
                                                takeback: takeback,
                                                account: doc,
                                                stores: stores,
                                                orders: user === null || user === void 0 ? void 0 : user.orders,
                                                postProductToReturn: postProductToReturn1,
                                                getRightOfWithdrawalInfo: getRightOfWithdrawalInfo1,
                                                handleDownloadInvoice: handleDownloadInvoice,
                                                invoiceDownloadError: invoiceDownloadError,
                                                savForm: savForm,
                                                onOpenSavForm: function(orderNumber) {
                                                    setSavFormOrderNumber(orderNumber);
                                                    setSavFormOpen(true);
                                                },
                                                settings: main === null || main === void 0 ? void 0 : main.data
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoOrderBox, {
                                                doc: doc
                                            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.loaderContainer,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                                            }),
                                            !isSubscription && !isSecondHand ? !(user === null || user === void 0 ? void 0 : user.loading) ? (user === null || user === void 0 ? void 0 : (ref26 = user.orders) === null || ref26 === void 0 ? void 0 : ref26.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Order_OrderList, {
                                                doc: doc,
                                                orders: user === null || user === void 0 ? void 0 : user.orders,
                                                t: t,
                                                inStoreText: inStoreText,
                                                isInStore: parameters === null || parameters === void 0 ? void 0 : (ref27 = parameters.items) === null || ref27 === void 0 ? void 0 : ref27.in_store,
                                                showSizes: main === null || main === void 0 ? void 0 : (ref28 = main.data) === null || ref28 === void 0 ? void 0 : ref28.show_size_name,
                                                putUserOrder: putUserOrder1,
                                                getUserOrders: getUserOrders1,
                                                takeback: takeback,
                                                handleDownloadInvoice: handleDownloadInvoice,
                                                invoiceDownloadError: invoiceDownloadError
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoOrderBox, {
                                                doc: doc
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.loaderContainer,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                                            }) : !(contract2 === null || contract2 === void 0 ? void 0 : contract2.loading) ? allContracts.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: allContracts.map(function(item) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Subscription_SubscriptionList, {
                                                        postProductToReturn: postProductToReturn1,
                                                        customer_survey: customer_survey,
                                                        doc: sub_list,
                                                        prismicAccount: doc === null || doc === void 0 ? void 0 : doc.data,
                                                        t: t,
                                                        orders: item.orders,
                                                        contract: item,
                                                        settings: main === null || main === void 0 ? void 0 : main.data,
                                                        inStoreText: inStoreText
                                                    }, item.id);
                                                })
                                            }) : !isSecondHand && /*#__PURE__*/ (0,jsx_runtime.jsx)(NoOrderBox, {
                                                doc: doc
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.loaderContainer,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                                            }),
                                            !(user === null || user === void 0 ? void 0 : user.loading) && isSecondHand && !constants/* isSecondHandOnly */.G7 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondHandAndRentalOrderList/* default */.Z, {
                                                takeback: takeback,
                                                orders: user === null || user === void 0 ? void 0 : user.orders,
                                                showSizes: main === null || main === void 0 ? void 0 : (ref29 = main.data) === null || ref29 === void 0 ? void 0 : ref29.show_size_name,
                                                putUserOrder: putUserOrder1,
                                                getUserOrders: getUserOrders1,
                                                handleDownloadInvoice: handleDownloadInvoice,
                                                invoiceDownloadError: invoiceDownloadError,
                                                getRightOfWithdrawalInfo: getRightOfWithdrawalInfo1,
                                                postProductToReturn: postProductToReturn1,
                                                prismicAccount: doc,
                                                savForm: savForm,
                                                onOpenSavForm: function(orderNumber) {
                                                    setSavFormOrderNumber(orderNumber);
                                                    setSavFormOpen(true);
                                                },
                                                settings: main === null || main === void 0 ? void 0 : main.data
                                            })
                                        ]
                                    }),
                                    isMobile && (doc === null || doc === void 0 ? void 0 : (ref30 = doc.data) === null || ref30 === void 0 ? void 0 : ref30.enable_faq_account) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountFaq, {
                                            doc: doc
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            savForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicForm_DynamicFormModal, {
                open: savFormOpen,
                onClose: function() {
                    return setSavFormOpen(false);
                },
                formData: savForm,
                orderNumber: savFormOrderNumber,
                fileUploadConfig: rmsFileUploadConfig
            }),
            modalHowItWorks && doc.data.is_slider_active && /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperModal_SwiperModal, {
                t: t,
                open: modalHowItWorks,
                handleCloseModal: function() {
                    return setModalHowItWorks(false);
                },
                title: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref31 = doc.data) === null || ref31 === void 0 ? void 0 : ref31.slides_title, t('texts:account:slides_title')),
                slides: doc === null || doc === void 0 ? void 0 : (ref32 = doc.data) === null || ref32 === void 0 ? void 0 : ref32.slides
            }),
            modalRemoveItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperModal_SwiperModal, {
                t: t,
                open: modalRemoveItem,
                handleCloseModal: function() {
                    return setModalRemoveItem(false);
                },
                title: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref33 = doc.data) === null || ref33 === void 0 ? void 0 : ref33.slides_title),
                slides: doc === null || doc === void 0 ? void 0 : (ref34 = doc.data) === null || ref34 === void 0 ? void 0 : ref34.slides
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (0,clsx_m/* default */.Z)('account', classes.background, classes.loaderSection, classes.loaderSectionFull),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
    });
};
var __N_SSG = true;
/* harmony default export */ var account = ((0,es/* connect */.$j)(account_mapStateToProps, account_mapDispatchToProps)(Account));


/***/ }),

/***/ 78101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Kn": function() { return /* binding */ addressUser_getAddress; },
  "Pe": function() { return /* binding */ addressUser_patchAddress; },
  "L4": function() { return /* binding */ addressUser_postAddress; },
  "EJ": function() { return /* binding */ addressUser_putAddress; }
});

// UNUSED EXPORTS: ACTIONS, GET_ADDRESS_USER_FAILURE, GET_ADDRESS_USER_REQUEST, GET_ADDRESS_USER_SUCCESS, PATCH_ADDRESS_USER_FAILURE, PATCH_ADDRESS_USER_REQUEST, PATCH_ADDRESS_USER_SUCCESS, POST_ADDRESS_USER_FAILURE, POST_ADDRESS_USER_REQUEST, POST_ADDRESS_USER_SUCCESS, PUT_ADDRESS_USER_FAILURE, PUT_ADDRESS_USER_REQUEST, PUT_ADDRESS_USER_SUCCESS

// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
;// CONCATENATED MODULE: ./redux/services/addressUser.ts




var getAddress = function() {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.address */.KU.address,
        headers: (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE))
    });
};
var postAddress = function(data) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.post */.YZ.post,
        url: requests/* ERequestUrl.address */.KU.address,
        data: data,
        headers: (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE))
    });
};
var putAddress = function(data, id) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.put */.YZ.put,
        url: requests/* ERequestUrl.address */.KU.address,
        data: data,
        uid: id.toString(),
        headers: (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE))
    });
};
var patchAddress = function(id) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.patch */.YZ.patch,
        url: requests/* ERequestUrl.address */.KU.address,
        uid: "".concat(id.toString(), "/default"),
        headers: (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE))
    });
};

;// CONCATENATED MODULE: ./redux/actions/addressUser.ts

var ACTIONS = {
    GET_ADDRESS_USER_REQUEST: 'GET_ADDRESS_USER_REQUEST',
    GET_ADDRESS_USER_SUCCESS: 'GET_ADDRESS_USER_SUCCESS',
    GET_ADDRESS_USER_FAILURE: 'GET_ADDRESS_USER_FAILURE',
    POST_ADDRESS_USER_REQUEST: 'POST_ADDRESS_USER_REQUEST',
    POST_ADDRESS_USER_SUCCESS: 'POST_ADDRESS_USER_SUCCESS',
    POST_ADDRESS_USER_FAILURE: 'POST_ADDRESS_USER_FAILURE',
    PUT_ADDRESS_USER_REQUEST: 'PUT_ADDRESS_USER_REQUEST',
    PUT_ADDRESS_USER_SUCCESS: 'PUT_ADDRESS_USER_SUCCESS',
    PUT_ADDRESS_USER_FAILURE: 'PUT_ADDRESS_USER_FAILURE',
    PATCH_ADDRESS_USER_REQUEST: 'PATCH_ADDRESS_USER_REQUEST',
    PATCH_ADDRESS_USER_SUCCESS: 'PATCH_ADDRESS_USER_SUCCESS',
    PATCH_ADDRESS_USER_FAILURE: 'PATCH_ADDRESS_USER_FAILURE'
};
var GET_ADDRESS_USER_REQUEST = function() {
    return {
        type: ACTIONS.GET_ADDRESS_USER_REQUEST
    };
};
var GET_ADDRESS_USER_SUCCESS = function(address) {
    return {
        type: ACTIONS.GET_ADDRESS_USER_SUCCESS,
        address: address
    };
};
var GET_ADDRESS_USER_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_ADDRESS_USER_FAILURE,
        err: err
    };
};
function addressUser_getAddress() {
    return function(dispatch) {
        dispatch(GET_ADDRESS_USER_REQUEST());
        return getAddress().then(function(response) {
            return dispatch(GET_ADDRESS_USER_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_ADDRESS_USER_FAILURE(err));
        });
    };
}
var POST_ADDRESS_USER_REQUEST = function() {
    return {
        type: ACTIONS.POST_ADDRESS_USER_REQUEST
    };
};
var POST_ADDRESS_USER_SUCCESS = function(address) {
    return {
        type: ACTIONS.POST_ADDRESS_USER_SUCCESS,
        address: address
    };
};
var POST_ADDRESS_USER_FAILURE = function(err) {
    return {
        type: ACTIONS.POST_ADDRESS_USER_FAILURE,
        err: err
    };
};
function addressUser_postAddress(data) {
    return function(dispatch) {
        dispatch(POST_ADDRESS_USER_REQUEST());
        return postAddress(data).then(function(response) {
            return dispatch(POST_ADDRESS_USER_SUCCESS(response));
        }, function(err) {
            return dispatch(POST_ADDRESS_USER_FAILURE(err));
        });
    };
}
var PUT_ADDRESS_USER_REQUEST = function() {
    return {
        type: ACTIONS.PUT_ADDRESS_USER_REQUEST
    };
};
var PUT_ADDRESS_USER_SUCCESS = function(address) {
    return {
        type: ACTIONS.PUT_ADDRESS_USER_SUCCESS,
        address: address
    };
};
var PUT_ADDRESS_USER_FAILURE = function(err) {
    return {
        type: ACTIONS.PUT_ADDRESS_USER_FAILURE,
        err: err
    };
};
function addressUser_putAddress(data, id) {
    return function(dispatch) {
        dispatch(PUT_ADDRESS_USER_REQUEST());
        return putAddress(data, id).then(function(response) {
            return dispatch(PUT_ADDRESS_USER_SUCCESS(response));
        }, function(err) {
            return dispatch(PUT_ADDRESS_USER_FAILURE(err));
        });
    };
}
var PATCH_ADDRESS_USER_REQUEST = function() {
    return {
        type: ACTIONS.PATCH_ADDRESS_USER_REQUEST
    };
};
var PATCH_ADDRESS_USER_SUCCESS = function(address) {
    return {
        type: ACTIONS.PATCH_ADDRESS_USER_SUCCESS,
        address: address
    };
};
var PATCH_ADDRESS_USER_FAILURE = function(err) {
    return {
        type: ACTIONS.PATCH_ADDRESS_USER_FAILURE,
        err: err
    };
};
function addressUser_patchAddress(id) {
    return function(dispatch) {
        dispatch(PATCH_ADDRESS_USER_REQUEST());
        return patchAddress(id).then(function(response) {
            return dispatch(PATCH_ADDRESS_USER_SUCCESS(response));
        }, function(err) {
            return dispatch(PATCH_ADDRESS_USER_FAILURE(err));
        });
    };
}


/***/ }),

/***/ 97506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UF": function() { return /* binding */ contract_getInProgressContractCSUB; },
  "R0": function() { return /* binding */ contract_getInProgressContractSUB; }
});

// UNUSED EXPORTS: ACTIONS, GET_IN_PROGRESS_CONTRACT_CSUB_FAILURE, GET_IN_PROGRESS_CONTRACT_CSUB_REQUEST, GET_IN_PROGRESS_CONTRACT_CSUB_SUCCESS, GET_IN_PROGRESS_CONTRACT_SUB_FAILURE, GET_IN_PROGRESS_CONTRACT_SUB_REQUEST, GET_IN_PROGRESS_CONTRACT_SUB_SUCCESS

// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
;// CONCATENATED MODULE: ./redux/services/contract.ts




var getInProgressContractCSUB = function(state) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.contractCSUB */.KU.contractCSUB,
        headers: (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE), true),
        isV2: true,
        uid: "?state=".concat(state)
    });
};
var getInProgressContractSUB = function(state) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.contractSUB */.KU.contractSUB,
        headers: (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE), true),
        isV2: true,
        uid: "?state=".concat(state)
    });
};

;// CONCATENATED MODULE: ./redux/actions/contract.ts

var ACTIONS = {
    GET_IN_PROGRESS_CONTRACT_CSUB_REQUEST: 'GET_IN_PROGRESS_CONTRACT_CSUB_REQUEST',
    GET_IN_PROGRESS_CONTRACT_CSUB_SUCCESS: 'GET_IN_PROGRESS_CONTRACT_CSUB_SUCCESS',
    GET_IN_PROGRESS_CONTRACT_CSUB_FAILURE: 'GET_IN_PROGRESS_CONTRACT_CSUB_FAILURE',
    GET_IN_PROGRESS_CONTRACT_SUB_REQUEST: 'GET_IN_PROGRESS_CONTRACT_SUB_REQUEST',
    GET_IN_PROGRESS_CONTRACT_SUB_SUCCESS: 'GET_IN_PROGRESS_CONTRACT_SUB_SUCCESS',
    GET_IN_PROGRESS_CONTRACT_SUB_FAILURE: 'GET_IN_PROGRESS_CONTRACT_SUB_FAILURE'
};
var GET_IN_PROGRESS_CONTRACT_CSUB_REQUEST = function() {
    return {
        type: ACTIONS.GET_IN_PROGRESS_CONTRACT_CSUB_REQUEST
    };
};
var GET_IN_PROGRESS_CONTRACT_CSUB_SUCCESS = function(currentContract) {
    return {
        type: ACTIONS.GET_IN_PROGRESS_CONTRACT_CSUB_SUCCESS,
        currentContract: currentContract
    };
};
var GET_IN_PROGRESS_CONTRACT_CSUB_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_IN_PROGRESS_CONTRACT_CSUB_FAILURE,
        err: err
    };
};
function contract_getInProgressContractCSUB(state) {
    return function(dispatch) {
        dispatch(GET_IN_PROGRESS_CONTRACT_CSUB_REQUEST());
        return getInProgressContractCSUB(state).then(function(response) {
            return dispatch(GET_IN_PROGRESS_CONTRACT_CSUB_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_IN_PROGRESS_CONTRACT_CSUB_FAILURE(err));
        });
    };
}
var GET_IN_PROGRESS_CONTRACT_SUB_REQUEST = function() {
    return {
        type: ACTIONS.GET_IN_PROGRESS_CONTRACT_SUB_REQUEST
    };
};
var GET_IN_PROGRESS_CONTRACT_SUB_SUCCESS = function(currentContract) {
    return {
        type: ACTIONS.GET_IN_PROGRESS_CONTRACT_SUB_SUCCESS,
        currentContract: currentContract
    };
};
var GET_IN_PROGRESS_CONTRACT_SUB_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_IN_PROGRESS_CONTRACT_SUB_FAILURE,
        err: err
    };
};
function contract_getInProgressContractSUB(state) {
    return function(dispatch) {
        dispatch(GET_IN_PROGRESS_CONTRACT_SUB_REQUEST());
        return getInProgressContractSUB(state).then(function(response) {
            return dispatch(GET_IN_PROGRESS_CONTRACT_SUB_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_IN_PROGRESS_CONTRACT_SUB_FAILURE(err));
        });
    };
}


/***/ }),

/***/ 65014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6156);
/* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38557);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28262);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }




var Scrollbar = {
  setTranslate: function setTranslate() {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    var scrollbar = swiper.scrollbar,
        rtl = swiper.rtlTranslate,
        progress = swiper.progress;
    var dragSize = scrollbar.dragSize,
        trackSize = scrollbar.trackSize,
        $dragEl = scrollbar.$dragEl,
        $el = scrollbar.$el;
    var params = swiper.params.scrollbar;
    var newSize = dragSize;
    var newPos = (trackSize - dragSize) * progress;

    if (rtl) {
      newPos = -newPos;

      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }

    if (swiper.isHorizontal()) {
      $dragEl.transform("translate3d(" + newPos + "px, 0, 0)");
      $dragEl[0].style.width = newSize + "px";
    } else {
      $dragEl.transform("translate3d(0px, " + newPos + "px, 0)");
      $dragEl[0].style.height = newSize + "px";
    }

    if (params.hide) {
      clearTimeout(swiper.scrollbar.timeout);
      $el[0].style.opacity = 1;
      swiper.scrollbar.timeout = setTimeout(function () {
        $el[0].style.opacity = 0;
        $el.transition(400);
      }, 1000);
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    swiper.scrollbar.$dragEl.transition(duration);
  },
  updateSize: function updateSize() {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    var scrollbar = swiper.scrollbar;
    var $dragEl = scrollbar.$dragEl,
        $el = scrollbar.$el;
    $dragEl[0].style.width = '';
    $dragEl[0].style.height = '';
    var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
    var divider = swiper.size / swiper.virtualSize;
    var moveDivider = divider * (trackSize / swiper.size);
    var dragSize;

    if (swiper.params.scrollbar.dragSize === 'auto') {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }

    if (swiper.isHorizontal()) {
      $dragEl[0].style.width = dragSize + "px";
    } else {
      $dragEl[0].style.height = dragSize + "px";
    }

    if (divider >= 1) {
      $el[0].style.display = 'none';
    } else {
      $el[0].style.display = '';
    }

    if (swiper.params.scrollbar.hide) {
      $el[0].style.opacity = 0;
    }

    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__/* .extend */ .l7)(scrollbar, {
      trackSize: trackSize,
      divider: divider,
      moveDivider: moveDivider,
      dragSize: dragSize
    });
    scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
  },
  getPointerPosition: function getPointerPosition(e) {
    var swiper = this;

    if (swiper.isHorizontal()) {
      return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
    }

    return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
  },
  setDragPosition: function setDragPosition(e) {
    var swiper = this;
    var scrollbar = swiper.scrollbar,
        rtl = swiper.rtlTranslate;
    var $el = scrollbar.$el,
        dragSize = scrollbar.dragSize,
        trackSize = scrollbar.trackSize,
        dragStartPos = scrollbar.dragStartPos;
    var positionRatio;
    positionRatio = (scrollbar.getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);

    if (rtl) {
      positionRatio = 1 - positionRatio;
    }

    var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  },
  onDragStart: function onDragStart(e) {
    var swiper = this;
    var params = swiper.params.scrollbar;
    var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el,
        $dragEl = scrollbar.$dragEl;
    swiper.scrollbar.isTouched = true;
    swiper.scrollbar.dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
    e.preventDefault();
    e.stopPropagation();
    $wrapperEl.transition(100);
    $dragEl.transition(100);
    scrollbar.setDragPosition(e);
    clearTimeout(swiper.scrollbar.dragTimeout);
    $el.transition(0);

    if (params.hide) {
      $el.css('opacity', 1);
    }

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', 'none');
    }

    swiper.emit('scrollbarDragStart', e);
  },
  onDragMove: function onDragMove(e) {
    var swiper = this;
    var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el,
        $dragEl = scrollbar.$dragEl;
    if (!swiper.scrollbar.isTouched) return;
    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    scrollbar.setDragPosition(e);
    $wrapperEl.transition(0);
    $el.transition(0);
    $dragEl.transition(0);
    swiper.emit('scrollbarDragMove', e);
  },
  onDragEnd: function onDragEnd(e) {
    var swiper = this;
    var params = swiper.params.scrollbar;
    var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el;
    if (!swiper.scrollbar.isTouched) return;
    swiper.scrollbar.isTouched = false;

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', '');
      $wrapperEl.transition('');
    }

    if (params.hide) {
      clearTimeout(swiper.scrollbar.dragTimeout);
      swiper.scrollbar.dragTimeout = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__/* .nextTick */ .Y3)(function () {
        $el.css('opacity', 0);
        $el.transition(400);
      }, 1000);
    }

    swiper.emit('scrollbarDragEnd', e);

    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  },
  enableDraggable: function enableDraggable() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var document = (0,ssr_window__WEBPACK_IMPORTED_MODULE_0__/* .getDocument */ .Me)();
    var scrollbar = swiper.scrollbar,
        touchEventsTouch = swiper.touchEventsTouch,
        touchEventsDesktop = swiper.touchEventsDesktop,
        params = swiper.params,
        support = swiper.support;
    var $el = scrollbar.$el;
    var target = $el[0];
    var activeListener = support.passiveListener && params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    var passiveListener = support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    if (!target) return;

    if (!support.touch) {
      target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
      document.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
      document.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
      target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
      target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
      target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
    }
  },
  disableDraggable: function disableDraggable() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var document = (0,ssr_window__WEBPACK_IMPORTED_MODULE_0__/* .getDocument */ .Me)();
    var scrollbar = swiper.scrollbar,
        touchEventsTouch = swiper.touchEventsTouch,
        touchEventsDesktop = swiper.touchEventsDesktop,
        params = swiper.params,
        support = swiper.support;
    var $el = scrollbar.$el;
    var target = $el[0];
    var activeListener = support.passiveListener && params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    var passiveListener = support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    if (!target) return;

    if (!support.touch) {
      target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
      document.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
      document.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
      target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
      target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
      target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
    }
  },
  init: function init() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var scrollbar = swiper.scrollbar,
        $swiperEl = swiper.$el;
    var params = swiper.params.scrollbar;
    var $el = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(params.el);

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
      $el = $swiperEl.find(params.el);
    }

    var $dragEl = $el.find("." + swiper.params.scrollbar.dragClass);

    if ($dragEl.length === 0) {
      $dragEl = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("<div class=\"" + swiper.params.scrollbar.dragClass + "\"></div>");
      $el.append($dragEl);
    }

    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__/* .extend */ .l7)(scrollbar, {
      $el: $el,
      el: $el[0],
      $dragEl: $dragEl,
      dragEl: $dragEl[0]
    });

    if (params.draggable) {
      scrollbar.enableDraggable();
    }
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.scrollbar.disableDraggable();
  }
};
/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'scrollbar',
  params: {
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag'
    }
  },
  create: function create() {
    var swiper = this;
    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__/* .bindModuleMethods */ .cR)(swiper, {
      scrollbar: _extends({
        isTouched: false,
        timeout: null,
        dragTimeout: null
      }, Scrollbar)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.scrollbar.init();
      swiper.scrollbar.updateSize();
      swiper.scrollbar.setTranslate();
    },
    update: function update(swiper) {
      swiper.scrollbar.updateSize();
    },
    resize: function resize(swiper) {
      swiper.scrollbar.updateSize();
    },
    observerUpdate: function observerUpdate(swiper) {
      swiper.scrollbar.updateSize();
    },
    setTranslate: function setTranslate(swiper) {
      swiper.scrollbar.setTranslate();
    },
    setTransition: function setTransition(swiper, duration) {
      swiper.scrollbar.setTransition(duration);
    },
    destroy: function destroy(swiper) {
      swiper.scrollbar.destroy();
    }
  }
});

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [282,2215,15350,79593,68480,1111,57443,94108,74805,12979,230,19789,29705,79956,86192,24219,26699,49774,92888,40179], function() { return __webpack_exec__(90431); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);